(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.AuctionNow = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortController = void 0;
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */
class AbortController {
    constructor() {
        this._isAborted = false;
        this.onabort = null;
    }
    abort() {
        if (!this._isAborted) {
            this._isAborted = true;
            if (this.onabort) {
                this.onabort();
            }
        }
    }
    get signal() {
        return this;
    }
    get aborted() {
        return this._isAborted;
    }
}
exports.AbortController = AbortController;

},{}],2:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTokenHttpClient = void 0;
const HeaderNames_1 = require("./HeaderNames");
const HttpClient_1 = require("./HttpClient");
/** @private */
class AccessTokenHttpClient extends HttpClient_1.HttpClient {
    constructor(innerClient, accessTokenFactory) {
        super();
        this._innerClient = innerClient;
        this._accessTokenFactory = accessTokenFactory;
    }
    async send(request) {
        let allowRetry = true;
        if (this._accessTokenFactory && (!this._accessToken || (request.url && request.url.indexOf("/negotiate?") > 0))) {
            // don't retry if the request is a negotiate or if we just got a potentially new token from the access token factory
            allowRetry = false;
            this._accessToken = await this._accessTokenFactory();
        }
        this._setAuthorizationHeader(request);
        const response = await this._innerClient.send(request);
        if (allowRetry && response.statusCode === 401 && this._accessTokenFactory) {
            this._accessToken = await this._accessTokenFactory();
            this._setAuthorizationHeader(request);
            return await this._innerClient.send(request);
        }
        return response;
    }
    _setAuthorizationHeader(request) {
        if (!request.headers) {
            request.headers = {};
        }
        if (this._accessToken) {
            request.headers[HeaderNames_1.HeaderNames.Authorization] = `Bearer ${this._accessToken}`;
        }
        // don't remove the header if there isn't an access token factory, the user manually added the header in this case
        else if (this._accessTokenFactory) {
            if (request.headers[HeaderNames_1.HeaderNames.Authorization]) {
                delete request.headers[HeaderNames_1.HeaderNames.Authorization];
            }
        }
    }
    getCookieString(url) {
        return this._innerClient.getCookieString(url);
    }
}
exports.AccessTokenHttpClient = AccessTokenHttpClient;

},{"./HeaderNames":8,"./HttpClient":9}],3:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHttpClient = void 0;
const Errors_1 = require("./Errors");
const FetchHttpClient_1 = require("./FetchHttpClient");
const HttpClient_1 = require("./HttpClient");
const Utils_1 = require("./Utils");
const XhrHttpClient_1 = require("./XhrHttpClient");
/** Default implementation of {@link @microsoft/signalr.HttpClient}. */
class DefaultHttpClient extends HttpClient_1.HttpClient {
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
    constructor(logger) {
        super();
        if (typeof fetch !== "undefined" || Utils_1.Platform.isNode) {
            this._httpClient = new FetchHttpClient_1.FetchHttpClient(logger);
        }
        else if (typeof XMLHttpRequest !== "undefined") {
            this._httpClient = new XhrHttpClient_1.XhrHttpClient(logger);
        }
        else {
            throw new Error("No usable HttpClient found.");
        }
    }
    /** @inheritDoc */
    send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new Errors_1.AbortError());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return this._httpClient.send(request);
    }
    getCookieString(url) {
        return this._httpClient.getCookieString(url);
    }
}
exports.DefaultHttpClient = DefaultHttpClient;

},{"./Errors":5,"./FetchHttpClient":6,"./HttpClient":9,"./Utils":23,"./XhrHttpClient":25}],4:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultReconnectPolicy = void 0;
// 0, 2, 10, 30 second delays before reconnect attempts.
const DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2000, 10000, 30000, null];
/** @private */
class DefaultReconnectPolicy {
    constructor(retryDelays) {
        this._retryDelays = retryDelays !== undefined ? [...retryDelays, null] : DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    nextRetryDelayInMilliseconds(retryContext) {
        return this._retryDelays[retryContext.previousRetryCount];
    }
}
exports.DefaultReconnectPolicy = DefaultReconnectPolicy;

},{}],5:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateErrors = exports.FailedToNegotiateWithServerError = exports.FailedToStartTransportError = exports.DisabledTransportError = exports.UnsupportedTransportError = exports.AbortError = exports.TimeoutError = exports.HttpError = void 0;
/** Error thrown when an HTTP request fails. */
class HttpError extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */
    constructor(errorMessage, statusCode) {
        const trueProto = new.target.prototype;
        super(`${errorMessage}: Status code '${statusCode}'`);
        this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.HttpError = HttpError;
/** Error thrown when a timeout elapses. */
class TimeoutError extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    constructor(errorMessage = "A timeout occurred.") {
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.TimeoutError = TimeoutError;
/** Error thrown when an action is aborted. */
class AbortError extends Error {
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    constructor(errorMessage = "An abort occurred.") {
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.AbortError = AbortError;
/** Error thrown when the selected transport is unsupported by the browser. */
/** @private */
class UnsupportedTransportError extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */
    constructor(message, transport) {
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'UnsupportedTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.UnsupportedTransportError = UnsupportedTransportError;
/** Error thrown when the selected transport is disabled by the browser. */
/** @private */
class DisabledTransportError extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */
    constructor(message, transport) {
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'DisabledTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.DisabledTransportError = DisabledTransportError;
/** Error thrown when the selected transport cannot be started. */
/** @private */
class FailedToStartTransportError extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */
    constructor(message, transport) {
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'FailedToStartTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.FailedToStartTransportError = FailedToStartTransportError;
/** Error thrown when the negotiation with the server failed to complete. */
/** @private */
class FailedToNegotiateWithServerError extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
     *
     * @param {string} message A descriptive error message.
     */
    constructor(message) {
        const trueProto = new.target.prototype;
        super(message);
        this.errorType = 'FailedToNegotiateWithServerError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.FailedToNegotiateWithServerError = FailedToNegotiateWithServerError;
/** Error thrown when multiple errors have occurred. */
/** @private */
class AggregateErrors extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
     *
     * @param {string} message A descriptive error message.
     * @param {Error[]} innerErrors The collection of errors this error is aggregating.
     */
    constructor(message, innerErrors) {
        const trueProto = new.target.prototype;
        super(message);
        this.innerErrors = innerErrors;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
exports.AggregateErrors = AggregateErrors;

},{}],6:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchHttpClient = void 0;
const Errors_1 = require("./Errors");
const HttpClient_1 = require("./HttpClient");
const ILogger_1 = require("./ILogger");
const Utils_1 = require("./Utils");
class FetchHttpClient extends HttpClient_1.HttpClient {
    constructor(logger) {
        super();
        this._logger = logger;
        // Node added a fetch implementation to the global scope starting in v18.
        // We need to add a cookie jar in node to be able to share cookies with WebSocket
        if (typeof fetch === "undefined" || Utils_1.Platform.isNode) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            this._jar = new (requireFunc("tough-cookie")).CookieJar();
            if (typeof fetch === "undefined") {
                this._fetchType = requireFunc("node-fetch");
            }
            else {
                // Use fetch from Node if available
                this._fetchType = fetch;
            }
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            this._fetchType = requireFunc("fetch-cookie")(this._fetchType, this._jar);
        }
        else {
            this._fetchType = fetch.bind((0, Utils_1.getGlobalThis)());
        }
        if (typeof AbortController === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            this._abortControllerType = requireFunc("abort-controller");
        }
        else {
            this._abortControllerType = AbortController;
        }
    }
    /** @inheritDoc */
    async send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            throw new Errors_1.AbortError();
        }
        if (!request.method) {
            throw new Error("No method defined.");
        }
        if (!request.url) {
            throw new Error("No url defined.");
        }
        const abortController = new this._abortControllerType();
        let error;
        // Hook our abortSignal into the abort controller
        if (request.abortSignal) {
            request.abortSignal.onabort = () => {
                abortController.abort();
                error = new Errors_1.AbortError();
            };
        }
        // If a timeout has been passed in, setup a timeout to call abort
        // Type needs to be any to fit window.setTimeout and NodeJS.setTimeout
        let timeoutId = null;
        if (request.timeout) {
            const msTimeout = request.timeout;
            timeoutId = setTimeout(() => {
                abortController.abort();
                this._logger.log(ILogger_1.LogLevel.Warning, `Timeout from HTTP request.`);
                error = new Errors_1.TimeoutError();
            }, msTimeout);
        }
        if (request.content === "") {
            request.content = undefined;
        }
        if (request.content) {
            // Explicitly setting the Content-Type header for React Native on Android platform.
            request.headers = request.headers || {};
            if ((0, Utils_1.isArrayBuffer)(request.content)) {
                request.headers["Content-Type"] = "application/octet-stream";
            }
            else {
                request.headers["Content-Type"] = "text/plain;charset=UTF-8";
            }
        }
        let response;
        try {
            response = await this._fetchType(request.url, {
                body: request.content,
                cache: "no-cache",
                credentials: request.withCredentials === true ? "include" : "same-origin",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    ...request.headers,
                },
                method: request.method,
                mode: "cors",
                redirect: "follow",
                signal: abortController.signal,
            });
        }
        catch (e) {
            if (error) {
                throw error;
            }
            this._logger.log(ILogger_1.LogLevel.Warning, `Error from HTTP request. ${e}.`);
            throw e;
        }
        finally {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            if (request.abortSignal) {
                request.abortSignal.onabort = null;
            }
        }
        if (!response.ok) {
            const errorMessage = await deserializeContent(response, "text");
            throw new Errors_1.HttpError(errorMessage || response.statusText, response.status);
        }
        const content = deserializeContent(response, request.responseType);
        const payload = await content;
        return new HttpClient_1.HttpResponse(response.status, response.statusText, payload);
    }
    getCookieString(url) {
        let cookies = "";
        if (Utils_1.Platform.isNode && this._jar) {
            // @ts-ignore: unused variable
            this._jar.getCookies(url, (e, c) => cookies = c.join("; "));
        }
        return cookies;
    }
}
exports.FetchHttpClient = FetchHttpClient;
function deserializeContent(response, responseType) {
    let content;
    switch (responseType) {
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(`${responseType} is not supported.`);
        default:
            content = response.text();
            break;
    }
    return content;
}

},{"./Errors":5,"./HttpClient":9,"./ILogger":14,"./Utils":23}],7:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandshakeProtocol = void 0;
const TextMessageFormat_1 = require("./TextMessageFormat");
const Utils_1 = require("./Utils");
/** @private */
class HandshakeProtocol {
    // Handshake request is always JSON
    writeHandshakeRequest(handshakeRequest) {
        return TextMessageFormat_1.TextMessageFormat.write(JSON.stringify(handshakeRequest));
    }
    parseHandshakeResponse(data) {
        let messageData;
        let remainingData;
        if ((0, Utils_1.isArrayBuffer)(data)) {
            // Format is binary but still need to read JSON text from handshake response
            const binaryData = new Uint8Array(data);
            const separatorIndex = binaryData.indexOf(TextMessageFormat_1.TextMessageFormat.RecordSeparatorCode);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
            remainingData = (binaryData.byteLength > responseLength) ? binaryData.slice(responseLength).buffer : null;
        }
        else {
            const textData = data;
            const separatorIndex = textData.indexOf(TextMessageFormat_1.TextMessageFormat.RecordSeparator);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = (textData.length > responseLength) ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        const messages = TextMessageFormat_1.TextMessageFormat.parse(messageData);
        const response = JSON.parse(messages[0]);
        if (response.type) {
            throw new Error("Expected a handshake response from the server.");
        }
        const responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [remainingData, responseMessage];
    }
}
exports.HandshakeProtocol = HandshakeProtocol;

},{"./TextMessageFormat":22,"./Utils":23}],8:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderNames = void 0;
class HeaderNames {
}
exports.HeaderNames = HeaderNames;
HeaderNames.Authorization = "Authorization";
HeaderNames.Cookie = "Cookie";

},{}],9:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = exports.HttpResponse = void 0;
/** Represents an HTTP response. */
class HttpResponse {
    constructor(statusCode, statusText, content) {
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
}
exports.HttpResponse = HttpResponse;
/** Abstraction over an HTTP client.
 *
 * This class provides an abstraction over an HTTP client so that a different implementation can be provided on different platforms.
 */
class HttpClient {
    get(url, options) {
        return this.send({
            ...options,
            method: "GET",
            url,
        });
    }
    post(url, options) {
        return this.send({
            ...options,
            method: "POST",
            url,
        });
    }
    delete(url, options) {
        return this.send({
            ...options,
            method: "DELETE",
            url,
        });
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */
    // @ts-ignore
    getCookieString(url) {
        return "";
    }
}
exports.HttpClient = HttpClient;

},{}],10:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportSendQueue = exports.HttpConnection = void 0;
const AccessTokenHttpClient_1 = require("./AccessTokenHttpClient");
const DefaultHttpClient_1 = require("./DefaultHttpClient");
const Errors_1 = require("./Errors");
const ILogger_1 = require("./ILogger");
const ITransport_1 = require("./ITransport");
const LongPollingTransport_1 = require("./LongPollingTransport");
const ServerSentEventsTransport_1 = require("./ServerSentEventsTransport");
const Utils_1 = require("./Utils");
const WebSocketTransport_1 = require("./WebSocketTransport");
const MAX_REDIRECTS = 100;
/** @private */
class HttpConnection {
    constructor(url, options = {}) {
        this._stopPromiseResolver = () => { };
        this.features = {};
        this._negotiateVersion = 1;
        Utils_1.Arg.isRequired(url, "url");
        this._logger = (0, Utils_1.createLogger)(options.logger);
        this.baseUrl = this._resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) {
            options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        }
        else {
            throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        }
        options.timeout = options.timeout === undefined ? 100 * 1000 : options.timeout;
        let webSocketModule = null;
        let eventSourceModule = null;
        if (Utils_1.Platform.isNode && typeof require !== "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!Utils_1.Platform.isNode && typeof WebSocket !== "undefined" && !options.WebSocket) {
            options.WebSocket = WebSocket;
        }
        else if (Utils_1.Platform.isNode && !options.WebSocket) {
            if (webSocketModule) {
                options.WebSocket = webSocketModule;
            }
        }
        if (!Utils_1.Platform.isNode && typeof EventSource !== "undefined" && !options.EventSource) {
            options.EventSource = EventSource;
        }
        else if (Utils_1.Platform.isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") {
                options.EventSource = eventSourceModule;
            }
        }
        this._httpClient = new AccessTokenHttpClient_1.AccessTokenHttpClient(options.httpClient || new DefaultHttpClient_1.DefaultHttpClient(this._logger), options.accessTokenFactory);
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */;
        this._connectionStarted = false;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async start(transferFormat) {
        transferFormat = transferFormat || ITransport_1.TransferFormat.Binary;
        Utils_1.Arg.isIn(transferFormat, ITransport_1.TransferFormat, "transferFormat");
        this._logger.log(ILogger_1.LogLevel.Debug, `Starting connection with transfer format '${ITransport_1.TransferFormat[transferFormat]}'.`);
        if (this._connectionState !== "Disconnected" /* ConnectionState.Disconnected */) {
            return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
        }
        this._connectionState = "Connecting" /* ConnectionState.Connecting */;
        this._startInternalPromise = this._startInternal(transferFormat);
        await this._startInternalPromise;
        // The TypeScript compiler thinks that connectionState must be Connecting here. The TypeScript compiler is wrong.
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "Failed to start the HttpConnection before stop() was called.";
            this._logger.log(ILogger_1.LogLevel.Error, message);
            // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
            await this._stopPromise;
            return Promise.reject(new Errors_1.AbortError(message));
        }
        else if (this._connectionState !== "Connected" /* ConnectionState.Connected */) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
            this._logger.log(ILogger_1.LogLevel.Error, message);
            return Promise.reject(new Errors_1.AbortError(message));
        }
        this._connectionStarted = true;
    }
    send(data) {
        if (this._connectionState !== "Connected" /* ConnectionState.Connected */) {
            return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        }
        if (!this._sendQueue) {
            this._sendQueue = new TransportSendQueue(this.transport);
        }
        // Transport will not be null if state is connected
        return this._sendQueue.send(data);
    }
    async stop(error) {
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */) {
            this._logger.log(ILogger_1.LogLevel.Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */) {
            this._logger.log(ILogger_1.LogLevel.Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        this._connectionState = "Disconnecting" /* ConnectionState.Disconnecting */;
        this._stopPromise = new Promise((resolve) => {
            // Don't complete stop() until stopConnection() completes.
            this._stopPromiseResolver = resolve;
        });
        // stopInternal should never throw so just observe it.
        await this._stopInternal(error);
        await this._stopPromise;
    }
    async _stopInternal(error) {
        // Set error as soon as possible otherwise there is a race between
        // the transport closing and providing an error and the error from a close message
        // We would prefer the close message error.
        this._stopError = error;
        try {
            await this._startInternalPromise;
        }
        catch (e) {
            // This exception is returned to the user as a rejected Promise from the start method.
        }
        // The transport's onclose will trigger stopConnection which will run our onclose event.
        // The transport should always be set if currently connected. If it wasn't set, it's likely because
        // stop was called during start() and start() failed.
        if (this.transport) {
            try {
                await this.transport.stop();
            }
            catch (e) {
                this._logger.log(ILogger_1.LogLevel.Error, `HttpConnection.transport.stop() threw error '${e}'.`);
                this._stopConnection();
            }
            this.transport = undefined;
        }
        else {
            this._logger.log(ILogger_1.LogLevel.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
        }
    }
    async _startInternal(transferFormat) {
        // Store the original base url and the access token factory since they may change
        // as part of negotiating
        let url = this.baseUrl;
        this._accessTokenFactory = this._options.accessTokenFactory;
        this._httpClient._accessTokenFactory = this._accessTokenFactory;
        try {
            if (this._options.skipNegotiation) {
                if (this._options.transport === ITransport_1.HttpTransportType.WebSockets) {
                    // No need to add a connection ID in this case
                    this.transport = this._constructTransport(ITransport_1.HttpTransportType.WebSockets);
                    // We should just call connect directly in this case.
                    // No fallback or negotiate in this case.
                    await this._startTransport(url, transferFormat);
                }
                else {
                    throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
                }
            }
            else {
                let negotiateResponse = null;
                let redirects = 0;
                do {
                    negotiateResponse = await this._getNegotiationResponse(url);
                    // the user tries to stop the connection when it is being started
                    if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ || this._connectionState === "Disconnected" /* ConnectionState.Disconnected */) {
                        throw new Errors_1.AbortError("The connection was stopped during negotiation.");
                    }
                    if (negotiateResponse.error) {
                        throw new Error(negotiateResponse.error);
                    }
                    if (negotiateResponse.ProtocolVersion) {
                        throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                    }
                    if (negotiateResponse.url) {
                        url = negotiateResponse.url;
                    }
                    if (negotiateResponse.accessToken) {
                        // Replace the current access token factory with one that uses
                        // the returned access token
                        const accessToken = negotiateResponse.accessToken;
                        this._accessTokenFactory = () => accessToken;
                        // set the factory to undefined so the AccessTokenHttpClient won't retry with the same token, since we know it won't change until a connection restart
                        this._httpClient._accessToken = accessToken;
                        this._httpClient._accessTokenFactory = undefined;
                    }
                    redirects++;
                } while (negotiateResponse.url && redirects < MAX_REDIRECTS);
                if (redirects === MAX_REDIRECTS && negotiateResponse.url) {
                    throw new Error("Negotiate redirection limit exceeded.");
                }
                await this._createTransport(url, this._options.transport, negotiateResponse, transferFormat);
            }
            if (this.transport instanceof LongPollingTransport_1.LongPollingTransport) {
                this.features.inherentKeepAlive = true;
            }
            if (this._connectionState === "Connecting" /* ConnectionState.Connecting */) {
                // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                this._logger.log(ILogger_1.LogLevel.Debug, "The HttpConnection connected successfully.");
                this._connectionState = "Connected" /* ConnectionState.Connected */;
            }
            // stop() is waiting on us via this.startInternalPromise so keep this.transport around so it can clean up.
            // This is the only case startInternal can exit in neither the connected nor disconnected state because stopConnection()
            // will transition to the disconnected state. start() will wait for the transition using the stopPromise.
        }
        catch (e) {
            this._logger.log(ILogger_1.LogLevel.Error, "Failed to start the connection: " + e);
            this._connectionState = "Disconnected" /* ConnectionState.Disconnected */;
            this.transport = undefined;
            // if start fails, any active calls to stop assume that start will complete the stop promise
            this._stopPromiseResolver();
            return Promise.reject(e);
        }
    }
    async _getNegotiationResponse(url) {
        const headers = {};
        const [name, value] = (0, Utils_1.getUserAgentHeader)();
        headers[name] = value;
        const negotiateUrl = this._resolveNegotiateUrl(url);
        this._logger.log(ILogger_1.LogLevel.Debug, `Sending negotiation request: ${negotiateUrl}.`);
        try {
            const response = await this._httpClient.post(negotiateUrl, {
                content: "",
                headers: { ...headers, ...this._options.headers },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials,
            });
            if (response.statusCode !== 200) {
                return Promise.reject(new Error(`Unexpected status code returned from negotiate '${response.statusCode}'`));
            }
            const negotiateResponse = JSON.parse(response.content);
            if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) {
                // Negotiate version 0 doesn't use connectionToken
                // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
                negotiateResponse.connectionToken = negotiateResponse.connectionId;
            }
            if (negotiateResponse.useStatefulReconnect && this._options._useStatefulReconnect !== true) {
                return Promise.reject(new Errors_1.FailedToNegotiateWithServerError("Client didn't negotiate Stateful Reconnect but the server did."));
            }
            return negotiateResponse;
        }
        catch (e) {
            let errorMessage = "Failed to complete negotiation with the server: " + e;
            if (e instanceof Errors_1.HttpError) {
                if (e.statusCode === 404) {
                    errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
                }
            }
            this._logger.log(ILogger_1.LogLevel.Error, errorMessage);
            return Promise.reject(new Errors_1.FailedToNegotiateWithServerError(errorMessage));
        }
    }
    _createConnectUrl(url, connectionToken) {
        if (!connectionToken) {
            return url;
        }
        return url + (url.indexOf("?") === -1 ? "?" : "&") + `id=${connectionToken}`;
    }
    async _createTransport(url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        let connectUrl = this._createConnectUrl(url, negotiateResponse.connectionToken);
        if (this._isITransport(requestedTransport)) {
            this._logger.log(ILogger_1.LogLevel.Debug, "Connection was provided an instance of ITransport, using that directly.");
            this.transport = requestedTransport;
            await this._startTransport(connectUrl, requestedTransferFormat);
            this.connectionId = negotiateResponse.connectionId;
            return;
        }
        const transportExceptions = [];
        const transports = negotiateResponse.availableTransports || [];
        let negotiate = negotiateResponse;
        for (const endpoint of transports) {
            const transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, (negotiate === null || negotiate === void 0 ? void 0 : negotiate.useStatefulReconnect) === true);
            if (transportOrError instanceof Error) {
                // Store the error and continue, we don't want to cause a re-negotiate in these cases
                transportExceptions.push(`${endpoint.transport} failed:`);
                transportExceptions.push(transportOrError);
            }
            else if (this._isITransport(transportOrError)) {
                this.transport = transportOrError;
                if (!negotiate) {
                    try {
                        negotiate = await this._getNegotiationResponse(url);
                    }
                    catch (ex) {
                        return Promise.reject(ex);
                    }
                    connectUrl = this._createConnectUrl(url, negotiate.connectionToken);
                }
                try {
                    await this._startTransport(connectUrl, requestedTransferFormat);
                    this.connectionId = negotiate.connectionId;
                    return;
                }
                catch (ex) {
                    this._logger.log(ILogger_1.LogLevel.Error, `Failed to start the transport '${endpoint.transport}': ${ex}`);
                    negotiate = undefined;
                    transportExceptions.push(new Errors_1.FailedToStartTransportError(`${endpoint.transport} failed: ${ex}`, ITransport_1.HttpTransportType[endpoint.transport]));
                    if (this._connectionState !== "Connecting" /* ConnectionState.Connecting */) {
                        const message = "Failed to select transport before stop() was called.";
                        this._logger.log(ILogger_1.LogLevel.Debug, message);
                        return Promise.reject(new Errors_1.AbortError(message));
                    }
                }
            }
        }
        if (transportExceptions.length > 0) {
            return Promise.reject(new Errors_1.AggregateErrors(`Unable to connect to the server with any of the available transports. ${transportExceptions.join(" ")}`, transportExceptions));
        }
        return Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
    }
    _constructTransport(transport) {
        switch (transport) {
            case ITransport_1.HttpTransportType.WebSockets:
                if (!this._options.WebSocket) {
                    throw new Error("'WebSocket' is not supported in your environment.");
                }
                return new WebSocketTransport_1.WebSocketTransport(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
            case ITransport_1.HttpTransportType.ServerSentEvents:
                if (!this._options.EventSource) {
                    throw new Error("'EventSource' is not supported in your environment.");
                }
                return new ServerSentEventsTransport_1.ServerSentEventsTransport(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
            case ITransport_1.HttpTransportType.LongPolling:
                return new LongPollingTransport_1.LongPollingTransport(this._httpClient, this._logger, this._options);
            default:
                throw new Error(`Unknown transport: ${transport}.`);
        }
    }
    _startTransport(url, transferFormat) {
        this.transport.onreceive = this.onreceive;
        if (this.features.reconnect) {
            this.transport.onclose = async (e) => {
                let callStop = false;
                if (this.features.reconnect) {
                    try {
                        this.features.disconnected();
                        await this.transport.connect(url, transferFormat);
                        await this.features.resend();
                    }
                    catch {
                        callStop = true;
                    }
                }
                else {
                    this._stopConnection(e);
                    return;
                }
                if (callStop) {
                    this._stopConnection(e);
                }
            };
        }
        else {
            this.transport.onclose = (e) => this._stopConnection(e);
        }
        return this.transport.connect(url, transferFormat);
    }
    _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, useStatefulReconnect) {
        const transport = ITransport_1.HttpTransportType[endpoint.transport];
        if (transport === null || transport === undefined) {
            this._logger.log(ILogger_1.LogLevel.Debug, `Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
            return new Error(`Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
        }
        else {
            if (transportMatches(requestedTransport, transport)) {
                const transferFormats = endpoint.transferFormats.map((s) => ITransport_1.TransferFormat[s]);
                if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                    if ((transport === ITransport_1.HttpTransportType.WebSockets && !this._options.WebSocket) ||
                        (transport === ITransport_1.HttpTransportType.ServerSentEvents && !this._options.EventSource)) {
                        this._logger.log(ILogger_1.LogLevel.Debug, `Skipping transport '${ITransport_1.HttpTransportType[transport]}' because it is not supported in your environment.'`);
                        return new Errors_1.UnsupportedTransportError(`'${ITransport_1.HttpTransportType[transport]}' is not supported in your environment.`, transport);
                    }
                    else {
                        this._logger.log(ILogger_1.LogLevel.Debug, `Selecting transport '${ITransport_1.HttpTransportType[transport]}'.`);
                        try {
                            this.features.reconnect = transport === ITransport_1.HttpTransportType.WebSockets ? useStatefulReconnect : undefined;
                            return this._constructTransport(transport);
                        }
                        catch (ex) {
                            return ex;
                        }
                    }
                }
                else {
                    this._logger.log(ILogger_1.LogLevel.Debug, `Skipping transport '${ITransport_1.HttpTransportType[transport]}' because it does not support the requested transfer format '${ITransport_1.TransferFormat[requestedTransferFormat]}'.`);
                    return new Error(`'${ITransport_1.HttpTransportType[transport]}' does not support ${ITransport_1.TransferFormat[requestedTransferFormat]}.`);
                }
            }
            else {
                this._logger.log(ILogger_1.LogLevel.Debug, `Skipping transport '${ITransport_1.HttpTransportType[transport]}' because it was disabled by the client.`);
                return new Errors_1.DisabledTransportError(`'${ITransport_1.HttpTransportType[transport]}' is disabled by the client.`, transport);
            }
        }
    }
    _isITransport(transport) {
        return transport && typeof (transport) === "object" && "connect" in transport;
    }
    _stopConnection(error) {
        this._logger.log(ILogger_1.LogLevel.Debug, `HttpConnection.stopConnection(${error}) called while in state ${this._connectionState}.`);
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this._stopError || error;
        this._stopError = undefined;
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */) {
            this._logger.log(ILogger_1.LogLevel.Debug, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is already in the disconnected state.`);
            return;
        }
        if (this._connectionState === "Connecting" /* ConnectionState.Connecting */) {
            this._logger.log(ILogger_1.LogLevel.Warning, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is still in the connecting state.`);
            throw new Error(`HttpConnection.stopConnection(${error}) was called while the connection is still in the connecting state.`);
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */) {
            // A call to stop() induced this call to stopConnection and needs to be completed.
            // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
            this._stopPromiseResolver();
        }
        if (error) {
            this._logger.log(ILogger_1.LogLevel.Error, `Connection disconnected with error '${error}'.`);
        }
        else {
            this._logger.log(ILogger_1.LogLevel.Information, "Connection disconnected.");
        }
        if (this._sendQueue) {
            this._sendQueue.stop().catch((e) => {
                this._logger.log(ILogger_1.LogLevel.Error, `TransportSendQueue.stop() threw error '${e}'.`);
            });
            this._sendQueue = undefined;
        }
        this.connectionId = undefined;
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */;
        if (this._connectionStarted) {
            this._connectionStarted = false;
            try {
                if (this.onclose) {
                    this.onclose(error);
                }
            }
            catch (e) {
                this._logger.log(ILogger_1.LogLevel.Error, `HttpConnection.onclose(${error}) threw error '${e}'.`);
            }
        }
    }
    _resolveUrl(url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) {
            return url;
        }
        if (!Utils_1.Platform.isBrowser) {
            throw new Error(`Cannot resolve '${url}'.`);
        }
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        const aTag = window.document.createElement("a");
        aTag.href = url;
        this._logger.log(ILogger_1.LogLevel.Information, `Normalizing '${url}' to '${aTag.href}'.`);
        return aTag.href;
    }
    _resolveNegotiateUrl(url) {
        const negotiateUrl = new URL(url);
        if (negotiateUrl.pathname.endsWith('/')) {
            negotiateUrl.pathname += "negotiate";
        }
        else {
            negotiateUrl.pathname += "/negotiate";
        }
        const searchParams = new URLSearchParams(negotiateUrl.searchParams);
        if (!searchParams.has("negotiateVersion")) {
            searchParams.append("negotiateVersion", this._negotiateVersion.toString());
        }
        if (searchParams.has("useStatefulReconnect")) {
            if (searchParams.get("useStatefulReconnect") === "true") {
                this._options._useStatefulReconnect = true;
            }
        }
        else if (this._options._useStatefulReconnect === true) {
            searchParams.append("useStatefulReconnect", "true");
        }
        negotiateUrl.search = searchParams.toString();
        return negotiateUrl.toString();
    }
}
exports.HttpConnection = HttpConnection;
function transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || ((actualTransport & requestedTransport) !== 0);
}
/** @private */
class TransportSendQueue {
    constructor(_transport) {
        this._transport = _transport;
        this._buffer = [];
        this._executing = true;
        this._sendBufferedData = new PromiseSource();
        this._transportResult = new PromiseSource();
        this._sendLoopPromise = this._sendLoop();
    }
    send(data) {
        this._bufferData(data);
        if (!this._transportResult) {
            this._transportResult = new PromiseSource();
        }
        return this._transportResult.promise;
    }
    stop() {
        this._executing = false;
        this._sendBufferedData.resolve();
        return this._sendLoopPromise;
    }
    _bufferData(data) {
        if (this._buffer.length && typeof (this._buffer[0]) !== typeof (data)) {
            throw new Error(`Expected data to be of type ${typeof (this._buffer)} but was of type ${typeof (data)}`);
        }
        this._buffer.push(data);
        this._sendBufferedData.resolve();
    }
    async _sendLoop() {
        while (true) {
            await this._sendBufferedData.promise;
            if (!this._executing) {
                if (this._transportResult) {
                    this._transportResult.reject("Connection stopped.");
                }
                break;
            }
            this._sendBufferedData = new PromiseSource();
            const transportResult = this._transportResult;
            this._transportResult = undefined;
            const data = typeof (this._buffer[0]) === "string" ?
                this._buffer.join("") :
                TransportSendQueue._concatBuffers(this._buffer);
            this._buffer.length = 0;
            try {
                await this._transport.send(data);
                transportResult.resolve();
            }
            catch (error) {
                transportResult.reject(error);
            }
        }
    }
    static _concatBuffers(arrayBuffers) {
        const totalLength = arrayBuffers.map((b) => b.byteLength).reduce((a, b) => a + b);
        const result = new Uint8Array(totalLength);
        let offset = 0;
        for (const item of arrayBuffers) {
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    }
}
exports.TransportSendQueue = TransportSendQueue;
class PromiseSource {
    constructor() {
        this.promise = new Promise((resolve, reject) => [this._resolver, this._rejecter] = [resolve, reject]);
    }
    resolve() {
        this._resolver();
    }
    reject(reason) {
        this._rejecter(reason);
    }
}

},{"./AccessTokenHttpClient":2,"./DefaultHttpClient":3,"./Errors":5,"./ILogger":14,"./ITransport":15,"./LongPollingTransport":18,"./ServerSentEventsTransport":20,"./Utils":23,"./WebSocketTransport":24}],11:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubConnection = exports.HubConnectionState = void 0;
const HandshakeProtocol_1 = require("./HandshakeProtocol");
const Errors_1 = require("./Errors");
const IHubProtocol_1 = require("./IHubProtocol");
const ILogger_1 = require("./ILogger");
const Subject_1 = require("./Subject");
const Utils_1 = require("./Utils");
const MessageBuffer_1 = require("./MessageBuffer");
const DEFAULT_TIMEOUT_IN_MS = 30 * 1000;
const DEFAULT_PING_INTERVAL_IN_MS = 15 * 1000;
const DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE = 100000;
/** Describes the current state of the {@link HubConnection} to the server. */
var HubConnectionState;
(function (HubConnectionState) {
    /** The hub connection is disconnected. */
    HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */
    HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */
    HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */
    HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */
    HubConnectionState["Reconnecting"] = "Reconnecting";
})(HubConnectionState = exports.HubConnectionState || (exports.HubConnectionState = {}));
/** Represents a connection to a SignalR Hub. */
class HubConnection {
    /** @internal */
    // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    static create(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize) {
        return new HubConnection(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize);
    }
    constructor(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize) {
        this._nextKeepAlive = 0;
        this._freezeEventListener = () => {
            this._logger.log(ILogger_1.LogLevel.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
        };
        Utils_1.Arg.isRequired(connection, "connection");
        Utils_1.Arg.isRequired(logger, "logger");
        Utils_1.Arg.isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = serverTimeoutInMilliseconds !== null && serverTimeoutInMilliseconds !== void 0 ? serverTimeoutInMilliseconds : DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = keepAliveIntervalInMilliseconds !== null && keepAliveIntervalInMilliseconds !== void 0 ? keepAliveIntervalInMilliseconds : DEFAULT_PING_INTERVAL_IN_MS;
        this._statefulReconnectBufferSize = statefulReconnectBufferSize !== null && statefulReconnectBufferSize !== void 0 ? statefulReconnectBufferSize : DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE;
        this._logger = logger;
        this._protocol = protocol;
        this.connection = connection;
        this._reconnectPolicy = reconnectPolicy;
        this._handshakeProtocol = new HandshakeProtocol_1.HandshakeProtocol();
        this.connection.onreceive = (data) => this._processIncomingData(data);
        this.connection.onclose = (error) => this._connectionClosed(error);
        this._callbacks = {};
        this._methods = {};
        this._closedCallbacks = [];
        this._reconnectingCallbacks = [];
        this._reconnectedCallbacks = [];
        this._invocationId = 0;
        this._receivedHandshakeResponse = false;
        this._connectionState = HubConnectionState.Disconnected;
        this._connectionStarted = false;
        this._cachedPingMessage = this._protocol.writeMessage({ type: IHubProtocol_1.MessageType.Ping });
    }
    /** Indicates the state of the {@link HubConnection} to the server. */
    get state() {
        return this._connectionState;
    }
    /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
     *  in the disconnected state or if the negotiation step was skipped.
     */
    get connectionId() {
        return this.connection ? (this.connection.connectionId || null) : null;
    }
    /** Indicates the url of the {@link HubConnection} to the server. */
    get baseUrl() {
        return this.connection.baseUrl || "";
    }
    /**
     * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
     * Reconnecting states.
     * @param {string} url The url to connect to.
     */
    set baseUrl(url) {
        if (this._connectionState !== HubConnectionState.Disconnected && this._connectionState !== HubConnectionState.Reconnecting) {
            throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
        }
        if (!url) {
            throw new Error("The HubConnection url must be a valid url.");
        }
        this.connection.baseUrl = url;
    }
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */
    start() {
        this._startPromise = this._startWithStateTransitions();
        return this._startPromise;
    }
    async _startWithStateTransitions() {
        if (this._connectionState !== HubConnectionState.Disconnected) {
            return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
        }
        this._connectionState = HubConnectionState.Connecting;
        this._logger.log(ILogger_1.LogLevel.Debug, "Starting HubConnection.");
        try {
            await this._startInternal();
            if (Utils_1.Platform.isBrowser) {
                // Log when the browser freezes the tab so users know why their connection unexpectedly stopped working
                window.document.addEventListener("freeze", this._freezeEventListener);
            }
            this._connectionState = HubConnectionState.Connected;
            this._connectionStarted = true;
            this._logger.log(ILogger_1.LogLevel.Debug, "HubConnection connected successfully.");
        }
        catch (e) {
            this._connectionState = HubConnectionState.Disconnected;
            this._logger.log(ILogger_1.LogLevel.Debug, `HubConnection failed to start successfully because of error '${e}'.`);
            return Promise.reject(e);
        }
    }
    async _startInternal() {
        this._stopDuringStartError = undefined;
        this._receivedHandshakeResponse = false;
        // Set up the promise before any connection is (re)started otherwise it could race with received messages
        const handshakePromise = new Promise((resolve, reject) => {
            this._handshakeResolver = resolve;
            this._handshakeRejecter = reject;
        });
        await this.connection.start(this._protocol.transferFormat);
        try {
            let version = this._protocol.version;
            if (!this.connection.features.reconnect) {
                // Stateful Reconnect starts with HubProtocol version 2, newer clients connecting to older servers will fail to connect due to
                // the handshake only supporting version 1, so we will try to send version 1 during the handshake to keep old servers working.
                version = 1;
            }
            const handshakeRequest = {
                protocol: this._protocol.name,
                version,
            };
            this._logger.log(ILogger_1.LogLevel.Debug, "Sending handshake request.");
            await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));
            this._logger.log(ILogger_1.LogLevel.Information, `Using HubProtocol '${this._protocol.name}'.`);
            // defensively cleanup timeout in case we receive a message from the server before we finish start
            this._cleanupTimeout();
            this._resetTimeoutPeriod();
            this._resetKeepAliveInterval();
            await handshakePromise;
            // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
            // being rejected on close, because this continuation can run after both the handshake completed successfully
            // and the connection was closed.
            if (this._stopDuringStartError) {
                // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
                // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
                // will cause the calling continuation to get scheduled to run later.
                // eslint-disable-next-line @typescript-eslint/no-throw-literal
                throw this._stopDuringStartError;
            }
            const useStatefulReconnect = this.connection.features.reconnect || false;
            if (useStatefulReconnect) {
                this._messageBuffer = new MessageBuffer_1.MessageBuffer(this._protocol, this.connection, this._statefulReconnectBufferSize);
                this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer);
                this.connection.features.resend = () => {
                    if (this._messageBuffer) {
                        return this._messageBuffer._resend();
                    }
                };
            }
            if (!this.connection.features.inherentKeepAlive) {
                await this._sendMessage(this._cachedPingMessage);
            }
        }
        catch (e) {
            this._logger.log(ILogger_1.LogLevel.Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`);
            this._cleanupTimeout();
            this._cleanupPingTimer();
            // HttpConnection.stop() should not complete until after the onclose callback is invoked.
            // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
            await this.connection.stop(e);
            throw e;
        }
    }
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */
    async stop() {
        // Capture the start promise before the connection might be restarted in an onclose callback.
        const startPromise = this._startPromise;
        this.connection.features.reconnect = false;
        this._stopPromise = this._stopInternal();
        await this._stopPromise;
        try {
            // Awaiting undefined continues immediately
            await startPromise;
        }
        catch (e) {
            // This exception is returned to the user as a rejected Promise from the start method.
        }
    }
    _stopInternal(error) {
        if (this._connectionState === HubConnectionState.Disconnected) {
            this._logger.log(ILogger_1.LogLevel.Debug, `Call to HubConnection.stop(${error}) ignored because it is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === HubConnectionState.Disconnecting) {
            this._logger.log(ILogger_1.LogLevel.Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        const state = this._connectionState;
        this._connectionState = HubConnectionState.Disconnecting;
        this._logger.log(ILogger_1.LogLevel.Debug, "Stopping HubConnection.");
        if (this._reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this._logger.log(ILogger_1.LogLevel.Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this._reconnectDelayHandle);
            this._reconnectDelayHandle = undefined;
            this._completeClose();
            return Promise.resolve();
        }
        if (state === HubConnectionState.Connected) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._sendCloseMessage();
        }
        this._cleanupTimeout();
        this._cleanupPingTimer();
        this._stopDuringStartError = error || new Errors_1.AbortError("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    }
    async _sendCloseMessage() {
        try {
            await this._sendWithProtocol(this._createCloseMessage());
        }
        catch {
            // Ignore, this is a best effort attempt to let the server know the client closed gracefully.
        }
    }
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */
    stream(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds);
        // eslint-disable-next-line prefer-const
        let promiseQueue;
        const subject = new Subject_1.Subject();
        subject.cancelCallback = () => {
            const cancelInvocation = this._createCancelInvocation(invocationDescriptor.invocationId);
            delete this._callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(() => {
                return this._sendWithProtocol(cancelInvocation);
            });
        };
        this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error) => {
            if (error) {
                subject.error(error);
                return;
            }
            else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === IHubProtocol_1.MessageType.Completion) {
                    if (invocationEvent.error) {
                        subject.error(new Error(invocationEvent.error));
                    }
                    else {
                        subject.complete();
                    }
                }
                else {
                    subject.next((invocationEvent.item));
                }
            }
        };
        promiseQueue = this._sendWithProtocol(invocationDescriptor)
            .catch((e) => {
            subject.error(e);
            delete this._callbacks[invocationDescriptor.invocationId];
        });
        this._launchStreams(streams, promiseQueue);
        return subject;
    }
    _sendMessage(message) {
        this._resetKeepAliveInterval();
        return this.connection.send(message);
    }
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */
    _sendWithProtocol(message) {
        if (this._messageBuffer) {
            return this._messageBuffer._send(message);
        }
        else {
            return this._sendMessage(this._protocol.writeMessage(message));
        }
    }
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */
    send(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));
        this._launchStreams(streams, sendPromise);
        return sendPromise;
    }
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */
    invoke(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);
        const p = new Promise((resolve, reject) => {
            // invocationId will always have a value for a non-blocking invocation
            this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error) => {
                if (error) {
                    reject(error);
                    return;
                }
                else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === IHubProtocol_1.MessageType.Completion) {
                        if (invocationEvent.error) {
                            reject(new Error(invocationEvent.error));
                        }
                        else {
                            resolve(invocationEvent.result);
                        }
                    }
                    else {
                        reject(new Error(`Unexpected message type: ${invocationEvent.type}`));
                    }
                }
            };
            const promiseQueue = this._sendWithProtocol(invocationDescriptor)
                .catch((e) => {
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete this._callbacks[invocationDescriptor.invocationId];
            });
            this._launchStreams(streams, promiseQueue);
        });
        return p;
    }
    on(methodName, newMethod) {
        if (!methodName || !newMethod) {
            return;
        }
        methodName = methodName.toLowerCase();
        if (!this._methods[methodName]) {
            this._methods[methodName] = [];
        }
        // Preventing adding the same handler multiple times.
        if (this._methods[methodName].indexOf(newMethod) !== -1) {
            return;
        }
        this._methods[methodName].push(newMethod);
    }
    off(methodName, method) {
        if (!methodName) {
            return;
        }
        methodName = methodName.toLowerCase();
        const handlers = this._methods[methodName];
        if (!handlers) {
            return;
        }
        if (method) {
            const removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) {
                    delete this._methods[methodName];
                }
            }
        }
        else {
            delete this._methods[methodName];
        }
    }
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */
    onclose(callback) {
        if (callback) {
            this._closedCallbacks.push(callback);
        }
    }
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */
    onreconnecting(callback) {
        if (callback) {
            this._reconnectingCallbacks.push(callback);
        }
    }
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */
    onreconnected(callback) {
        if (callback) {
            this._reconnectedCallbacks.push(callback);
        }
    }
    _processIncomingData(data) {
        this._cleanupTimeout();
        if (!this._receivedHandshakeResponse) {
            data = this._processHandshakeResponse(data);
            this._receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            const messages = this._protocol.parseMessages(data, this._logger);
            for (const message of messages) {
                if (this._messageBuffer && !this._messageBuffer._shouldProcessMessage(message)) {
                    // Don't process the message, we are either waiting for a SequenceMessage or received a duplicate message
                    continue;
                }
                switch (message.type) {
                    case IHubProtocol_1.MessageType.Invocation:
                        this._invokeClientMethod(message)
                            .catch((e) => {
                            this._logger.log(ILogger_1.LogLevel.Error, `Invoke client method threw error: ${(0, Utils_1.getErrorString)(e)}`);
                        });
                        break;
                    case IHubProtocol_1.MessageType.StreamItem:
                    case IHubProtocol_1.MessageType.Completion: {
                        const callback = this._callbacks[message.invocationId];
                        if (callback) {
                            if (message.type === IHubProtocol_1.MessageType.Completion) {
                                delete this._callbacks[message.invocationId];
                            }
                            try {
                                callback(message);
                            }
                            catch (e) {
                                this._logger.log(ILogger_1.LogLevel.Error, `Stream callback threw error: ${(0, Utils_1.getErrorString)(e)}`);
                            }
                        }
                        break;
                    }
                    case IHubProtocol_1.MessageType.Ping:
                        // Don't care about pings
                        break;
                    case IHubProtocol_1.MessageType.Close: {
                        this._logger.log(ILogger_1.LogLevel.Information, "Close message received from server.");
                        const error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                        if (message.allowReconnect === true) {
                            // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            this.connection.stop(error);
                        }
                        else {
                            // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this._stopPromise = this._stopInternal(error);
                        }
                        break;
                    }
                    case IHubProtocol_1.MessageType.Ack:
                        if (this._messageBuffer) {
                            this._messageBuffer._ack(message);
                        }
                        break;
                    case IHubProtocol_1.MessageType.Sequence:
                        if (this._messageBuffer) {
                            this._messageBuffer._resetSequence(message);
                        }
                        break;
                    default:
                        this._logger.log(ILogger_1.LogLevel.Warning, `Invalid message type: ${message.type}.`);
                        break;
                }
            }
        }
        this._resetTimeoutPeriod();
    }
    _processHandshakeResponse(data) {
        let responseMessage;
        let remainingData;
        try {
            [remainingData, responseMessage] = this._handshakeProtocol.parseHandshakeResponse(data);
        }
        catch (e) {
            const message = "Error parsing handshake response: " + e;
            this._logger.log(ILogger_1.LogLevel.Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            const message = "Server returned handshake error: " + responseMessage.error;
            this._logger.log(ILogger_1.LogLevel.Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        }
        else {
            this._logger.log(ILogger_1.LogLevel.Debug, "Server handshake complete.");
        }
        this._handshakeResolver();
        return remainingData;
    }
    _resetKeepAliveInterval() {
        if (this.connection.features.inherentKeepAlive) {
            return;
        }
        // Set the time we want the next keep alive to be sent
        // Timer will be setup on next message receive
        this._nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;
        this._cleanupPingTimer();
    }
    _resetTimeoutPeriod() {
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this._timeoutHandle = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds);
            // Set keepAlive timer if there isn't one
            if (this._pingServerHandle === undefined) {
                let nextPing = this._nextKeepAlive - new Date().getTime();
                if (nextPing < 0) {
                    nextPing = 0;
                }
                // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute
                this._pingServerHandle = setTimeout(async () => {
                    if (this._connectionState === HubConnectionState.Connected) {
                        try {
                            await this._sendMessage(this._cachedPingMessage);
                        }
                        catch {
                            // We don't care about the error. It should be seen elsewhere in the client.
                            // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
                            this._cleanupPingTimer();
                        }
                    }
                }, nextPing);
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    serverTimeout() {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    }
    async _invokeClientMethod(invocationMessage) {
        const methodName = invocationMessage.target.toLowerCase();
        const methods = this._methods[methodName];
        if (!methods) {
            this._logger.log(ILogger_1.LogLevel.Warning, `No client method with the name '${methodName}' found.`);
            // No handlers provided by client but the server is expecting a response still, so we send an error
            if (invocationMessage.invocationId) {
                this._logger.log(ILogger_1.LogLevel.Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                await this._sendWithProtocol(this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null));
            }
            return;
        }
        // Avoid issues with handlers removing themselves thus modifying the list while iterating through it
        const methodsCopy = methods.slice();
        // Server expects a response
        const expectsResponse = invocationMessage.invocationId ? true : false;
        // We preserve the last result or exception but still call all handlers
        let res;
        let exception;
        let completionMessage;
        for (const m of methodsCopy) {
            try {
                const prevRes = res;
                res = await m.apply(this, invocationMessage.arguments);
                if (expectsResponse && res && prevRes) {
                    this._logger.log(ILogger_1.LogLevel.Error, `Multiple results provided for '${methodName}'. Sending error to server.`);
                    completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `Client provided multiple results.`, null);
                }
                // Ignore exception if we got a result after, the exception will be logged
                exception = undefined;
            }
            catch (e) {
                exception = e;
                this._logger.log(ILogger_1.LogLevel.Error, `A callback for the method '${methodName}' threw error '${e}'.`);
            }
        }
        if (completionMessage) {
            await this._sendWithProtocol(completionMessage);
        }
        else if (expectsResponse) {
            // If there is an exception that means either no result was given or a handler after a result threw
            if (exception) {
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `${exception}`, null);
            }
            else if (res !== undefined) {
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, null, res);
            }
            else {
                this._logger.log(ILogger_1.LogLevel.Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                // Client didn't provide a result or throw from a handler, server expects a response so we send an error
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null);
            }
            await this._sendWithProtocol(completionMessage);
        }
        else {
            if (res) {
                this._logger.log(ILogger_1.LogLevel.Error, `Result given for '${methodName}' method but server is not expecting a result.`);
            }
        }
    }
    _connectionClosed(error) {
        this._logger.log(ILogger_1.LogLevel.Debug, `HubConnection.connectionClosed(${error}) called while in state ${this._connectionState}.`);
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this._stopDuringStartError = this._stopDuringStartError || error || new Errors_1.AbortError("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this._handshakeResolver) {
            this._handshakeResolver();
        }
        this._cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this._cleanupTimeout();
        this._cleanupPingTimer();
        if (this._connectionState === HubConnectionState.Disconnecting) {
            this._completeClose(error);
        }
        else if (this._connectionState === HubConnectionState.Connected && this._reconnectPolicy) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._reconnect(error);
        }
        else if (this._connectionState === HubConnectionState.Connected) {
            this._completeClose(error);
        }
        // If none of the above if conditions were true were called the HubConnection must be in either:
        // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
        // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
        //    and potentially continue the reconnect() loop.
        // 3. The Disconnected state in which case we're already done.
    }
    _completeClose(error) {
        if (this._connectionStarted) {
            this._connectionState = HubConnectionState.Disconnected;
            this._connectionStarted = false;
            if (this._messageBuffer) {
                this._messageBuffer._dispose(error !== null && error !== void 0 ? error : new Error("Connection closed."));
                this._messageBuffer = undefined;
            }
            if (Utils_1.Platform.isBrowser) {
                window.document.removeEventListener("freeze", this._freezeEventListener);
            }
            try {
                this._closedCallbacks.forEach((c) => c.apply(this, [error]));
            }
            catch (e) {
                this._logger.log(ILogger_1.LogLevel.Error, `An onclose callback called with error '${error}' threw error '${e}'.`);
            }
        }
    }
    async _reconnect(error) {
        const reconnectStartTime = Date.now();
        let previousReconnectAttempts = 0;
        let retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
        let nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, 0, retryError);
        if (nextRetryDelay === null) {
            this._logger.log(ILogger_1.LogLevel.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
            this._completeClose(error);
            return;
        }
        this._connectionState = HubConnectionState.Reconnecting;
        if (error) {
            this._logger.log(ILogger_1.LogLevel.Information, `Connection reconnecting because of error '${error}'.`);
        }
        else {
            this._logger.log(ILogger_1.LogLevel.Information, "Connection reconnecting.");
        }
        if (this._reconnectingCallbacks.length !== 0) {
            try {
                this._reconnectingCallbacks.forEach((c) => c.apply(this, [error]));
            }
            catch (e) {
                this._logger.log(ILogger_1.LogLevel.Error, `An onreconnecting callback called with error '${error}' threw error '${e}'.`);
            }
            // Exit early if an onreconnecting callback called connection.stop().
            if (this._connectionState !== HubConnectionState.Reconnecting) {
                this._logger.log(ILogger_1.LogLevel.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                return;
            }
        }
        while (nextRetryDelay !== null) {
            this._logger.log(ILogger_1.LogLevel.Information, `Reconnect attempt number ${previousReconnectAttempts} will start in ${nextRetryDelay} ms.`);
            await new Promise((resolve) => {
                this._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
            });
            this._reconnectDelayHandle = undefined;
            if (this._connectionState !== HubConnectionState.Reconnecting) {
                this._logger.log(ILogger_1.LogLevel.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                return;
            }
            try {
                await this._startInternal();
                this._connectionState = HubConnectionState.Connected;
                this._logger.log(ILogger_1.LogLevel.Information, "HubConnection reconnected successfully.");
                if (this._reconnectedCallbacks.length !== 0) {
                    try {
                        this._reconnectedCallbacks.forEach((c) => c.apply(this, [this.connection.connectionId]));
                    }
                    catch (e) {
                        this._logger.log(ILogger_1.LogLevel.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${e}'.`);
                    }
                }
                return;
            }
            catch (e) {
                this._logger.log(ILogger_1.LogLevel.Information, `Reconnect attempt failed because of error '${e}'.`);
                if (this._connectionState !== HubConnectionState.Reconnecting) {
                    this._logger.log(ILogger_1.LogLevel.Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`);
                    // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.
                    if (this._connectionState === HubConnectionState.Disconnecting) {
                        this._completeClose();
                    }
                    return;
                }
                retryError = e instanceof Error ? e : new Error(e.toString());
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, Date.now() - reconnectStartTime, retryError);
            }
        }
        this._logger.log(ILogger_1.LogLevel.Information, `Reconnect retries have been exhausted after ${Date.now() - reconnectStartTime} ms and ${previousReconnectAttempts} failed attempts. Connection disconnecting.`);
        this._completeClose();
    }
    _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this._reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds,
                previousRetryCount,
                retryReason,
            });
        }
        catch (e) {
            this._logger.log(ILogger_1.LogLevel.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${previousRetryCount}, ${elapsedMilliseconds}) threw error '${e}'.`);
            return null;
        }
    }
    _cancelCallbacksWithError(error) {
        const callbacks = this._callbacks;
        this._callbacks = {};
        Object.keys(callbacks)
            .forEach((key) => {
            const callback = callbacks[key];
            try {
                callback(null, error);
            }
            catch (e) {
                this._logger.log(ILogger_1.LogLevel.Error, `Stream 'error' callback called with '${error}' threw error: ${(0, Utils_1.getErrorString)(e)}`);
            }
        });
    }
    _cleanupPingTimer() {
        if (this._pingServerHandle) {
            clearTimeout(this._pingServerHandle);
            this._pingServerHandle = undefined;
        }
    }
    _cleanupTimeout() {
        if (this._timeoutHandle) {
            clearTimeout(this._timeoutHandle);
        }
    }
    _createInvocation(methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) {
                return {
                    arguments: args,
                    streamIds,
                    target: methodName,
                    type: IHubProtocol_1.MessageType.Invocation,
                };
            }
            else {
                return {
                    arguments: args,
                    target: methodName,
                    type: IHubProtocol_1.MessageType.Invocation,
                };
            }
        }
        else {
            const invocationId = this._invocationId;
            this._invocationId++;
            if (streamIds.length !== 0) {
                return {
                    arguments: args,
                    invocationId: invocationId.toString(),
                    streamIds,
                    target: methodName,
                    type: IHubProtocol_1.MessageType.Invocation,
                };
            }
            else {
                return {
                    arguments: args,
                    invocationId: invocationId.toString(),
                    target: methodName,
                    type: IHubProtocol_1.MessageType.Invocation,
                };
            }
        }
    }
    _launchStreams(streams, promiseQueue) {
        if (streams.length === 0) {
            return;
        }
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) {
            promiseQueue = Promise.resolve();
        }
        // We want to iterate over the keys, since the keys are the stream ids
        // eslint-disable-next-line guard-for-in
        for (const streamId in streams) {
            streams[streamId].subscribe({
                complete: () => {
                    promiseQueue = promiseQueue.then(() => this._sendWithProtocol(this._createCompletionMessage(streamId)));
                },
                error: (err) => {
                    let message;
                    if (err instanceof Error) {
                        message = err.message;
                    }
                    else if (err && err.toString) {
                        message = err.toString();
                    }
                    else {
                        message = "Unknown error";
                    }
                    promiseQueue = promiseQueue.then(() => this._sendWithProtocol(this._createCompletionMessage(streamId, message)));
                },
                next: (item) => {
                    promiseQueue = promiseQueue.then(() => this._sendWithProtocol(this._createStreamItemMessage(streamId, item)));
                },
            });
        }
    }
    _replaceStreamingParams(args) {
        const streams = [];
        const streamIds = [];
        for (let i = 0; i < args.length; i++) {
            const argument = args[i];
            if (this._isObservable(argument)) {
                const streamId = this._invocationId;
                this._invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [streams, streamIds];
    }
    _isObservable(arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    }
    _createStreamInvocation(methodName, args, streamIds) {
        const invocationId = this._invocationId;
        this._invocationId++;
        if (streamIds.length !== 0) {
            return {
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds,
                target: methodName,
                type: IHubProtocol_1.MessageType.StreamInvocation,
            };
        }
        else {
            return {
                arguments: args,
                invocationId: invocationId.toString(),
                target: methodName,
                type: IHubProtocol_1.MessageType.StreamInvocation,
            };
        }
    }
    _createCancelInvocation(id) {
        return {
            invocationId: id,
            type: IHubProtocol_1.MessageType.CancelInvocation,
        };
    }
    _createStreamItemMessage(id, item) {
        return {
            invocationId: id,
            item,
            type: IHubProtocol_1.MessageType.StreamItem,
        };
    }
    _createCompletionMessage(id, error, result) {
        if (error) {
            return {
                error,
                invocationId: id,
                type: IHubProtocol_1.MessageType.Completion,
            };
        }
        return {
            invocationId: id,
            result,
            type: IHubProtocol_1.MessageType.Completion,
        };
    }
    _createCloseMessage() {
        return { type: IHubProtocol_1.MessageType.Close };
    }
}
exports.HubConnection = HubConnection;

},{"./Errors":5,"./HandshakeProtocol":7,"./IHubProtocol":13,"./ILogger":14,"./MessageBuffer":19,"./Subject":21,"./Utils":23}],12:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubConnectionBuilder = void 0;
const DefaultReconnectPolicy_1 = require("./DefaultReconnectPolicy");
const HttpConnection_1 = require("./HttpConnection");
const HubConnection_1 = require("./HubConnection");
const ILogger_1 = require("./ILogger");
const JsonHubProtocol_1 = require("./JsonHubProtocol");
const Loggers_1 = require("./Loggers");
const Utils_1 = require("./Utils");
const LogLevelNameMapping = {
    trace: ILogger_1.LogLevel.Trace,
    debug: ILogger_1.LogLevel.Debug,
    info: ILogger_1.LogLevel.Information,
    information: ILogger_1.LogLevel.Information,
    warn: ILogger_1.LogLevel.Warning,
    warning: ILogger_1.LogLevel.Warning,
    error: ILogger_1.LogLevel.Error,
    critical: ILogger_1.LogLevel.Critical,
    none: ILogger_1.LogLevel.None,
};
function parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    const mapping = LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") {
        return mapping;
    }
    else {
        throw new Error(`Unknown log level: ${name}`);
    }
}
/** A builder for configuring {@link @microsoft/signalr.HubConnection} instances. */
class HubConnectionBuilder {
    configureLogging(logging) {
        Utils_1.Arg.isRequired(logging, "logging");
        if (isLogger(logging)) {
            this.logger = logging;
        }
        else if (typeof logging === "string") {
            const logLevel = parseLogLevel(logging);
            this.logger = new Utils_1.ConsoleLogger(logLevel);
        }
        else {
            this.logger = new Utils_1.ConsoleLogger(logging);
        }
        return this;
    }
    withUrl(url, transportTypeOrOptions) {
        Utils_1.Arg.isRequired(url, "url");
        Utils_1.Arg.isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") {
            this.httpConnectionOptions = { ...this.httpConnectionOptions, ...transportTypeOrOptions };
        }
        else {
            this.httpConnectionOptions = {
                ...this.httpConnectionOptions,
                transport: transportTypeOrOptions,
            };
        }
        return this;
    }
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */
    withHubProtocol(protocol) {
        Utils_1.Arg.isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    }
    withAutomaticReconnect(retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) {
            throw new Error("A reconnectPolicy has already been set.");
        }
        if (!retryDelaysOrReconnectPolicy) {
            this.reconnectPolicy = new DefaultReconnectPolicy_1.DefaultReconnectPolicy();
        }
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) {
            this.reconnectPolicy = new DefaultReconnectPolicy_1.DefaultReconnectPolicy(retryDelaysOrReconnectPolicy);
        }
        else {
            this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        }
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */
    withServerTimeout(milliseconds) {
        Utils_1.Arg.isRequired(milliseconds, "milliseconds");
        this._serverTimeoutInMilliseconds = milliseconds;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */
    withKeepAliveInterval(milliseconds) {
        Utils_1.Arg.isRequired(milliseconds, "milliseconds");
        this._keepAliveIntervalInMilliseconds = milliseconds;
        return this;
    }
    /** Enables and configures options for the Stateful Reconnect feature.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */
    withStatefulReconnect(options) {
        if (this.httpConnectionOptions === undefined) {
            this.httpConnectionOptions = {};
        }
        this.httpConnectionOptions._useStatefulReconnect = true;
        this._statefulReconnectBufferSize = options === null || options === void 0 ? void 0 : options.bufferSize;
        return this;
    }
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */
    build() {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        const httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) {
            // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
            httpConnectionOptions.logger = this.logger;
        }
        // Now create the connection
        if (!this.url) {
            throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        }
        const connection = new HttpConnection_1.HttpConnection(this.url, httpConnectionOptions);
        return HubConnection_1.HubConnection.create(connection, this.logger || Loggers_1.NullLogger.instance, this.protocol || new JsonHubProtocol_1.JsonHubProtocol(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
    }
}
exports.HubConnectionBuilder = HubConnectionBuilder;
function isLogger(logger) {
    return logger.log !== undefined;
}

},{"./DefaultReconnectPolicy":4,"./HttpConnection":10,"./HubConnection":11,"./ILogger":14,"./JsonHubProtocol":16,"./Loggers":17,"./Utils":23}],13:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
/** Defines the type of a Hub Message. */
var MessageType;
(function (MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */
    MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */
    MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */
    MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */
    MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */
    MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */
    MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */
    MessageType[MessageType["Close"] = 7] = "Close";
    MessageType[MessageType["Ack"] = 8] = "Ack";
    MessageType[MessageType["Sequence"] = 9] = "Sequence";
})(MessageType = exports.MessageType || (exports.MessageType = {}));

},{}],14:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */
var LogLevel;
(function (LogLevel) {
    /** Log level for very low severity diagnostic messages. */
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */
    LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */
    LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */
    LogLevel[LogLevel["None"] = 6] = "None";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));

},{}],15:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferFormat = exports.HttpTransportType = void 0;
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */
var HttpTransportType;
(function (HttpTransportType) {
    /** Specifies no transport preference. */
    HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */
    HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */
    HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */
    HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})(HttpTransportType = exports.HttpTransportType || (exports.HttpTransportType = {}));
/** Specifies the transfer format for a connection. */
var TransferFormat;
(function (TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})(TransferFormat = exports.TransferFormat || (exports.TransferFormat = {}));

},{}],16:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonHubProtocol = void 0;
const IHubProtocol_1 = require("./IHubProtocol");
const ILogger_1 = require("./ILogger");
const ITransport_1 = require("./ITransport");
const Loggers_1 = require("./Loggers");
const TextMessageFormat_1 = require("./TextMessageFormat");
const JSON_HUB_PROTOCOL_NAME = "json";
/** Implements the JSON Hub Protocol. */
class JsonHubProtocol {
    constructor() {
        /** @inheritDoc */
        this.name = JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */
        this.version = 2;
        /** @inheritDoc */
        this.transferFormat = ITransport_1.TransferFormat.Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */
    parseMessages(input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") {
            throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        }
        if (!input) {
            return [];
        }
        if (logger === null) {
            logger = Loggers_1.NullLogger.instance;
        }
        // Parse the messages
        const messages = TextMessageFormat_1.TextMessageFormat.parse(input);
        const hubMessages = [];
        for (const message of messages) {
            const parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") {
                throw new Error("Invalid payload.");
            }
            switch (parsedMessage.type) {
                case IHubProtocol_1.MessageType.Invocation:
                    this._isInvocationMessage(parsedMessage);
                    break;
                case IHubProtocol_1.MessageType.StreamItem:
                    this._isStreamItemMessage(parsedMessage);
                    break;
                case IHubProtocol_1.MessageType.Completion:
                    this._isCompletionMessage(parsedMessage);
                    break;
                case IHubProtocol_1.MessageType.Ping:
                    // Single value, no need to validate
                    break;
                case IHubProtocol_1.MessageType.Close:
                    // All optional values, no need to validate
                    break;
                case IHubProtocol_1.MessageType.Ack:
                    this._isAckMessage(parsedMessage);
                    break;
                case IHubProtocol_1.MessageType.Sequence:
                    this._isSequenceMessage(parsedMessage);
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log(ILogger_1.LogLevel.Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */
    writeMessage(message) {
        return TextMessageFormat_1.TextMessageFormat.write(JSON.stringify(message));
    }
    _isInvocationMessage(message) {
        this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) {
            this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
        }
    }
    _isStreamItemMessage(message) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) {
            throw new Error("Invalid payload for StreamItem message.");
        }
    }
    _isCompletionMessage(message) {
        if (message.result && message.error) {
            throw new Error("Invalid payload for Completion message.");
        }
        if (!message.result && message.error) {
            this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        }
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
    _isAckMessage(message) {
        if (typeof message.sequenceId !== 'number') {
            throw new Error("Invalid SequenceId for Ack message.");
        }
    }
    _isSequenceMessage(message) {
        if (typeof message.sequenceId !== 'number') {
            throw new Error("Invalid SequenceId for Sequence message.");
        }
    }
    _assertNotEmptyString(value, errorMessage) {
        if (typeof value !== "string" || value === "") {
            throw new Error(errorMessage);
        }
    }
}
exports.JsonHubProtocol = JsonHubProtocol;

},{"./IHubProtocol":13,"./ILogger":14,"./ITransport":15,"./Loggers":17,"./TextMessageFormat":22}],17:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullLogger = void 0;
/** A logger that does nothing when log messages are sent to it. */
class NullLogger {
    constructor() { }
    /** @inheritDoc */
    // eslint-disable-next-line
    log(_logLevel, _message) {
    }
}
exports.NullLogger = NullLogger;
/** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */
NullLogger.instance = new NullLogger();

},{}],18:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongPollingTransport = void 0;
const AbortController_1 = require("./AbortController");
const Errors_1 = require("./Errors");
const ILogger_1 = require("./ILogger");
const ITransport_1 = require("./ITransport");
const Utils_1 = require("./Utils");
// Not exported from 'index', this type is internal.
/** @private */
class LongPollingTransport {
    // This is an internal type, not exported from 'index' so this is really just internal.
    get pollAborted() {
        return this._pollAbort.aborted;
    }
    constructor(httpClient, logger, options) {
        this._httpClient = httpClient;
        this._logger = logger;
        this._pollAbort = new AbortController_1.AbortController();
        this._options = options;
        this._running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        Utils_1.Arg.isRequired(url, "url");
        Utils_1.Arg.isRequired(transferFormat, "transferFormat");
        Utils_1.Arg.isIn(transferFormat, ITransport_1.TransferFormat, "transferFormat");
        this._url = url;
        this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) Connecting.");
        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
        if (transferFormat === ITransport_1.TransferFormat.Binary &&
            (typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string")) {
            throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
        }
        const [name, value] = (0, Utils_1.getUserAgentHeader)();
        const headers = { [name]: value, ...this._options.headers };
        const pollOptions = {
            abortSignal: this._pollAbort.signal,
            headers,
            timeout: 100000,
            withCredentials: this._options.withCredentials,
        };
        if (transferFormat === ITransport_1.TransferFormat.Binary) {
            pollOptions.responseType = "arraybuffer";
        }
        // Make initial long polling request
        // Server uses first long polling request to finish initializing connection and it returns without data
        const pollUrl = `${url}&_=${Date.now()}`;
        this._logger.log(ILogger_1.LogLevel.Trace, `(LongPolling transport) polling: ${pollUrl}.`);
        const response = await this._httpClient.get(pollUrl, pollOptions);
        if (response.statusCode !== 200) {
            this._logger.log(ILogger_1.LogLevel.Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
            // Mark running as false so that the poll immediately ends and runs the close logic
            this._closeError = new Errors_1.HttpError(response.statusText || "", response.statusCode);
            this._running = false;
        }
        else {
            this._running = true;
        }
        this._receiving = this._poll(this._url, pollOptions);
    }
    async _poll(url, pollOptions) {
        try {
            while (this._running) {
                try {
                    const pollUrl = `${url}&_=${Date.now()}`;
                    this._logger.log(ILogger_1.LogLevel.Trace, `(LongPolling transport) polling: ${pollUrl}.`);
                    const response = await this._httpClient.get(pollUrl, pollOptions);
                    if (response.statusCode === 204) {
                        this._logger.log(ILogger_1.LogLevel.Information, "(LongPolling transport) Poll terminated by server.");
                        this._running = false;
                    }
                    else if (response.statusCode !== 200) {
                        this._logger.log(ILogger_1.LogLevel.Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
                        // Unexpected status code
                        this._closeError = new Errors_1.HttpError(response.statusText || "", response.statusCode);
                        this._running = false;
                    }
                    else {
                        // Process the response
                        if (response.content) {
                            this._logger.log(ILogger_1.LogLevel.Trace, `(LongPolling transport) data received. ${(0, Utils_1.getDataDetail)(response.content, this._options.logMessageContent)}.`);
                            if (this.onreceive) {
                                this.onreceive(response.content);
                            }
                        }
                        else {
                            // This is another way timeout manifest.
                            this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
                        }
                    }
                }
                catch (e) {
                    if (!this._running) {
                        // Log but disregard errors that occur after stopping
                        this._logger.log(ILogger_1.LogLevel.Trace, `(LongPolling transport) Poll errored after shutdown: ${e.message}`);
                    }
                    else {
                        if (e instanceof Errors_1.TimeoutError) {
                            // Ignore timeouts and reissue the poll.
                            this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
                        }
                        else {
                            // Close the connection with the error as the result.
                            this._closeError = e;
                            this._running = false;
                        }
                    }
                }
            }
        }
        finally {
            this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) Polling complete.");
            // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
            // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
            if (!this.pollAborted) {
                this._raiseOnClose();
            }
        }
    }
    async send(data) {
        if (!this._running) {
            return Promise.reject(new Error("Cannot send until the transport is connected"));
        }
        return (0, Utils_1.sendMessage)(this._logger, "LongPolling", this._httpClient, this._url, data, this._options);
    }
    async stop() {
        this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) Stopping polling.");
        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
        this._running = false;
        this._pollAbort.abort();
        try {
            await this._receiving;
            // Send DELETE to clean up long polling on the server
            this._logger.log(ILogger_1.LogLevel.Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
            const headers = {};
            const [name, value] = (0, Utils_1.getUserAgentHeader)();
            headers[name] = value;
            const deleteOptions = {
                headers: { ...headers, ...this._options.headers },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials,
            };
            let error;
            try {
                await this._httpClient.delete(this._url, deleteOptions);
            }
            catch (err) {
                error = err;
            }
            if (error) {
                if (error instanceof Errors_1.HttpError) {
                    if (error.statusCode === 404) {
                        this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.");
                    }
                    else {
                        this._logger.log(ILogger_1.LogLevel.Trace, `(LongPolling transport) Error sending a DELETE request: ${error}`);
                    }
                }
            }
            else {
                this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) DELETE request accepted.");
            }
        }
        finally {
            this._logger.log(ILogger_1.LogLevel.Trace, "(LongPolling transport) Stop finished.");
            // Raise close event here instead of in polling
            // It needs to happen after the DELETE request is sent
            this._raiseOnClose();
        }
    }
    _raiseOnClose() {
        if (this.onclose) {
            let logMessage = "(LongPolling transport) Firing onclose event.";
            if (this._closeError) {
                logMessage += " Error: " + this._closeError;
            }
            this._logger.log(ILogger_1.LogLevel.Trace, logMessage);
            this.onclose(this._closeError);
        }
    }
}
exports.LongPollingTransport = LongPollingTransport;

},{"./AbortController":1,"./Errors":5,"./ILogger":14,"./ITransport":15,"./Utils":23}],19:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBuffer = void 0;
const IHubProtocol_1 = require("./IHubProtocol");
const Utils_1 = require("./Utils");
/** @private */
class MessageBuffer {
    constructor(protocol, connection, bufferSize) {
        this._bufferSize = 100000;
        this._messages = [];
        this._totalMessageCount = 0;
        this._waitForSequenceMessage = false;
        // Message IDs start at 1 and always increment by 1
        this._nextReceivingSequenceId = 1;
        this._latestReceivedSequenceId = 0;
        this._bufferedByteCount = 0;
        this._reconnectInProgress = false;
        this._protocol = protocol;
        this._connection = connection;
        this._bufferSize = bufferSize;
    }
    async _send(message) {
        const serializedMessage = this._protocol.writeMessage(message);
        let backpressurePromise = Promise.resolve();
        // Only count invocation messages. Acks, pings, etc. don't need to be resent on reconnect
        if (this._isInvocationMessage(message)) {
            this._totalMessageCount++;
            let backpressurePromiseResolver = () => { };
            let backpressurePromiseRejector = () => { };
            if ((0, Utils_1.isArrayBuffer)(serializedMessage)) {
                this._bufferedByteCount += serializedMessage.byteLength;
            }
            else {
                this._bufferedByteCount += serializedMessage.length;
            }
            if (this._bufferedByteCount >= this._bufferSize) {
                backpressurePromise = new Promise((resolve, reject) => {
                    backpressurePromiseResolver = resolve;
                    backpressurePromiseRejector = reject;
                });
            }
            this._messages.push(new BufferedItem(serializedMessage, this._totalMessageCount, backpressurePromiseResolver, backpressurePromiseRejector));
        }
        try {
            // If this is set it means we are reconnecting or resending
            // We don't want to send on a disconnected connection
            // And we don't want to send if resend is running since that would mean sending
            // this message twice
            if (!this._reconnectInProgress) {
                await this._connection.send(serializedMessage);
            }
        }
        catch {
            this._disconnected();
        }
        await backpressurePromise;
    }
    _ack(ackMessage) {
        let newestAckedMessage = -1;
        // Find index of newest message being acked
        for (let index = 0; index < this._messages.length; index++) {
            const element = this._messages[index];
            if (element._id <= ackMessage.sequenceId) {
                newestAckedMessage = index;
                if ((0, Utils_1.isArrayBuffer)(element._message)) {
                    this._bufferedByteCount -= element._message.byteLength;
                }
                else {
                    this._bufferedByteCount -= element._message.length;
                }
                // resolve items that have already been sent and acked
                element._resolver();
            }
            else if (this._bufferedByteCount < this._bufferSize) {
                // resolve items that now fall under the buffer limit but haven't been acked
                element._resolver();
            }
            else {
                break;
            }
        }
        if (newestAckedMessage !== -1) {
            // We're removing everything including the message pointed to, so add 1
            this._messages = this._messages.slice(newestAckedMessage + 1);
        }
    }
    _shouldProcessMessage(message) {
        if (this._waitForSequenceMessage) {
            if (message.type !== IHubProtocol_1.MessageType.Sequence) {
                return false;
            }
            else {
                this._waitForSequenceMessage = false;
                return true;
            }
        }
        // No special processing for acks, pings, etc.
        if (!this._isInvocationMessage(message)) {
            return true;
        }
        const currentId = this._nextReceivingSequenceId;
        this._nextReceivingSequenceId++;
        if (currentId <= this._latestReceivedSequenceId) {
            if (currentId === this._latestReceivedSequenceId) {
                // Should only hit this if we just reconnected and the server is sending
                // Messages it has buffered, which would mean it hasn't seen an Ack for these messages
                this._ackTimer();
            }
            // Ignore, this is a duplicate message
            return false;
        }
        this._latestReceivedSequenceId = currentId;
        // Only start the timer for sending an Ack message when we have a message to ack. This also conveniently solves
        // timer throttling by not having a recursive timer, and by starting the timer via a network call (recv)
        this._ackTimer();
        return true;
    }
    _resetSequence(message) {
        if (message.sequenceId > this._nextReceivingSequenceId) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
            return;
        }
        this._nextReceivingSequenceId = message.sequenceId;
    }
    _disconnected() {
        this._reconnectInProgress = true;
        this._waitForSequenceMessage = true;
    }
    async _resend() {
        const sequenceId = this._messages.length !== 0
            ? this._messages[0]._id
            : this._totalMessageCount + 1;
        await this._connection.send(this._protocol.writeMessage({ type: IHubProtocol_1.MessageType.Sequence, sequenceId }));
        // Get a local variable to the _messages, just in case messages are acked while resending
        // Which would slice the _messages array (which creates a new copy)
        const messages = this._messages;
        for (const element of messages) {
            await this._connection.send(element._message);
        }
        this._reconnectInProgress = false;
    }
    _dispose(error) {
        error !== null && error !== void 0 ? error : (error = new Error("Unable to reconnect to server."));
        // Unblock backpressure if any
        for (const element of this._messages) {
            element._rejector(error);
        }
    }
    _isInvocationMessage(message) {
        // There is no way to check if something implements an interface.
        // So we individually check the messages in a switch statement.
        // To make sure we don't miss any message types we rely on the compiler
        // seeing the function returns a value and it will do the
        // exhaustive check for us on the switch statement, since we don't use 'case default'
        switch (message.type) {
            case IHubProtocol_1.MessageType.Invocation:
            case IHubProtocol_1.MessageType.StreamItem:
            case IHubProtocol_1.MessageType.Completion:
            case IHubProtocol_1.MessageType.StreamInvocation:
            case IHubProtocol_1.MessageType.CancelInvocation:
                return true;
            case IHubProtocol_1.MessageType.Close:
            case IHubProtocol_1.MessageType.Sequence:
            case IHubProtocol_1.MessageType.Ping:
            case IHubProtocol_1.MessageType.Ack:
                return false;
        }
    }
    _ackTimer() {
        if (this._ackTimerHandle === undefined) {
            this._ackTimerHandle = setTimeout(async () => {
                try {
                    if (!this._reconnectInProgress) {
                        await this._connection.send(this._protocol.writeMessage({ type: IHubProtocol_1.MessageType.Ack, sequenceId: this._latestReceivedSequenceId }));
                    }
                    // Ignore errors, that means the connection is closed and we don't care about the Ack message anymore.
                }
                catch { }
                clearTimeout(this._ackTimerHandle);
                this._ackTimerHandle = undefined;
                // 1 second delay so we don't spam Ack messages if there are many messages being received at once.
            }, 1000);
        }
    }
}
exports.MessageBuffer = MessageBuffer;
class BufferedItem {
    constructor(message, id, resolver, rejector) {
        this._message = message;
        this._id = id;
        this._resolver = resolver;
        this._rejector = rejector;
    }
}

},{"./IHubProtocol":13,"./Utils":23}],20:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerSentEventsTransport = void 0;
const ILogger_1 = require("./ILogger");
const ITransport_1 = require("./ITransport");
const Utils_1 = require("./Utils");
/** @private */
class ServerSentEventsTransport {
    constructor(httpClient, accessToken, logger, options) {
        this._httpClient = httpClient;
        this._accessToken = accessToken;
        this._logger = logger;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        Utils_1.Arg.isRequired(url, "url");
        Utils_1.Arg.isRequired(transferFormat, "transferFormat");
        Utils_1.Arg.isIn(transferFormat, ITransport_1.TransferFormat, "transferFormat");
        this._logger.log(ILogger_1.LogLevel.Trace, "(SSE transport) Connecting.");
        // set url before accessTokenFactory because this._url is only for send and we set the auth header instead of the query string for send
        this._url = url;
        if (this._accessToken) {
            url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`;
        }
        return new Promise((resolve, reject) => {
            let opened = false;
            if (transferFormat !== ITransport_1.TransferFormat.Text) {
                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                return;
            }
            let eventSource;
            if (Utils_1.Platform.isBrowser || Utils_1.Platform.isWebWorker) {
                eventSource = new this._options.EventSource(url, { withCredentials: this._options.withCredentials });
            }
            else {
                // Non-browser passes cookies via the dictionary
                const cookies = this._httpClient.getCookieString(url);
                const headers = {};
                headers.Cookie = cookies;
                const [name, value] = (0, Utils_1.getUserAgentHeader)();
                headers[name] = value;
                eventSource = new this._options.EventSource(url, { withCredentials: this._options.withCredentials, headers: { ...headers, ...this._options.headers } });
            }
            try {
                eventSource.onmessage = (e) => {
                    if (this.onreceive) {
                        try {
                            this._logger.log(ILogger_1.LogLevel.Trace, `(SSE transport) data received. ${(0, Utils_1.getDataDetail)(e.data, this._options.logMessageContent)}.`);
                            this.onreceive(e.data);
                        }
                        catch (error) {
                            this._close(error);
                            return;
                        }
                    }
                };
                // @ts-ignore: not using event on purpose
                eventSource.onerror = (e) => {
                    // EventSource doesn't give any useful information about server side closes.
                    if (opened) {
                        this._close();
                    }
                    else {
                        reject(new Error("EventSource failed to connect. The connection could not be found on the server,"
                            + " either the connection ID is not present on the server, or a proxy is refusing/buffering the connection."
                            + " If you have multiple servers check that sticky sessions are enabled."));
                    }
                };
                eventSource.onopen = () => {
                    this._logger.log(ILogger_1.LogLevel.Information, `SSE connected to ${this._url}`);
                    this._eventSource = eventSource;
                    opened = true;
                    resolve();
                };
            }
            catch (e) {
                reject(e);
                return;
            }
        });
    }
    async send(data) {
        if (!this._eventSource) {
            return Promise.reject(new Error("Cannot send until the transport is connected"));
        }
        return (0, Utils_1.sendMessage)(this._logger, "SSE", this._httpClient, this._url, data, this._options);
    }
    stop() {
        this._close();
        return Promise.resolve();
    }
    _close(e) {
        if (this._eventSource) {
            this._eventSource.close();
            this._eventSource = undefined;
            if (this.onclose) {
                this.onclose(e);
            }
        }
    }
}
exports.ServerSentEventsTransport = ServerSentEventsTransport;

},{"./ILogger":14,"./ITransport":15,"./Utils":23}],21:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subject = void 0;
const Utils_1 = require("./Utils");
/** Stream implementation to stream items to the server. */
class Subject {
    constructor() {
        this.observers = [];
    }
    next(item) {
        for (const observer of this.observers) {
            observer.next(item);
        }
    }
    error(err) {
        for (const observer of this.observers) {
            if (observer.error) {
                observer.error(err);
            }
        }
    }
    complete() {
        for (const observer of this.observers) {
            if (observer.complete) {
                observer.complete();
            }
        }
    }
    subscribe(observer) {
        this.observers.push(observer);
        return new Utils_1.SubjectSubscription(this, observer);
    }
}
exports.Subject = Subject;

},{"./Utils":23}],22:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMessageFormat = void 0;
// Not exported from index
/** @private */
class TextMessageFormat {
    static write(output) {
        return `${output}${TextMessageFormat.RecordSeparator}`;
    }
    static parse(input) {
        if (input[input.length - 1] !== TextMessageFormat.RecordSeparator) {
            throw new Error("Message is incomplete.");
        }
        const messages = input.split(TextMessageFormat.RecordSeparator);
        messages.pop();
        return messages;
    }
}
exports.TextMessageFormat = TextMessageFormat;
TextMessageFormat.RecordSeparatorCode = 0x1e;
TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);

},{}],23:[function(require,module,exports){
(function (process,global){(function (){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalThis = exports.getErrorString = exports.constructUserAgent = exports.getUserAgentHeader = exports.ConsoleLogger = exports.SubjectSubscription = exports.createLogger = exports.sendMessage = exports.isArrayBuffer = exports.formatArrayBuffer = exports.getDataDetail = exports.Platform = exports.Arg = exports.VERSION = void 0;
const ILogger_1 = require("./ILogger");
const Loggers_1 = require("./Loggers");
// Version token that will be replaced by the prepack command
/** The version of the SignalR client. */
exports.VERSION = "8.0.7";
/** @private */
class Arg {
    static isRequired(val, name) {
        if (val === null || val === undefined) {
            throw new Error(`The '${name}' argument is required.`);
        }
    }
    static isNotEmpty(val, name) {
        if (!val || val.match(/^\s*$/)) {
            throw new Error(`The '${name}' argument should not be empty.`);
        }
    }
    static isIn(val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) {
            throw new Error(`Unknown ${name} value: ${val}.`);
        }
    }
}
exports.Arg = Arg;
/** @private */
class Platform {
    // react-native has a window but no document so we should check both
    static get isBrowser() {
        return !Platform.isNode && typeof window === "object" && typeof window.document === "object";
    }
    // WebWorkers don't have a window object so the isBrowser check would fail
    static get isWebWorker() {
        return !Platform.isNode && typeof self === "object" && "importScripts" in self;
    }
    // react-native has a window but no document
    static get isReactNative() {
        return !Platform.isNode && typeof window === "object" && typeof window.document === "undefined";
    }
    // Node apps shouldn't have a window object, but WebWorkers don't either
    // so we need to check for both WebWorker and window
    static get isNode() {
        return typeof process !== "undefined" && process.release && process.release.name === "node";
    }
}
exports.Platform = Platform;
/** @private */
function getDataDetail(data, includeContent) {
    let detail = "";
    if (isArrayBuffer(data)) {
        detail = `Binary data of length ${data.byteLength}`;
        if (includeContent) {
            detail += `. Content: '${formatArrayBuffer(data)}'`;
        }
    }
    else if (typeof data === "string") {
        detail = `String data of length ${data.length}`;
        if (includeContent) {
            detail += `. Content: '${data}'`;
        }
    }
    return detail;
}
exports.getDataDetail = getDataDetail;
/** @private */
function formatArrayBuffer(data) {
    const view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    let str = "";
    view.forEach((num) => {
        const pad = num < 16 ? "0" : "";
        str += `0x${pad}${num.toString(16)} `;
    });
    // Trim of trailing space.
    return str.substr(0, str.length - 1);
}
exports.formatArrayBuffer = formatArrayBuffer;
// Also in signalr-protocol-msgpack/Utils.ts
/** @private */
function isArrayBuffer(val) {
    return val && typeof ArrayBuffer !== "undefined" &&
        (val instanceof ArrayBuffer ||
            // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
            (val.constructor && val.constructor.name === "ArrayBuffer"));
}
exports.isArrayBuffer = isArrayBuffer;
/** @private */
async function sendMessage(logger, transportName, httpClient, url, content, options) {
    const headers = {};
    const [name, value] = getUserAgentHeader();
    headers[name] = value;
    logger.log(ILogger_1.LogLevel.Trace, `(${transportName} transport) sending data. ${getDataDetail(content, options.logMessageContent)}.`);
    const responseType = isArrayBuffer(content) ? "arraybuffer" : "text";
    const response = await httpClient.post(url, {
        content,
        headers: { ...headers, ...options.headers },
        responseType,
        timeout: options.timeout,
        withCredentials: options.withCredentials,
    });
    logger.log(ILogger_1.LogLevel.Trace, `(${transportName} transport) request complete. Response status: ${response.statusCode}.`);
}
exports.sendMessage = sendMessage;
/** @private */
function createLogger(logger) {
    if (logger === undefined) {
        return new ConsoleLogger(ILogger_1.LogLevel.Information);
    }
    if (logger === null) {
        return Loggers_1.NullLogger.instance;
    }
    if (logger.log !== undefined) {
        return logger;
    }
    return new ConsoleLogger(logger);
}
exports.createLogger = createLogger;
/** @private */
class SubjectSubscription {
    constructor(subject, observer) {
        this._subject = subject;
        this._observer = observer;
    }
    dispose() {
        const index = this._subject.observers.indexOf(this._observer);
        if (index > -1) {
            this._subject.observers.splice(index, 1);
        }
        if (this._subject.observers.length === 0 && this._subject.cancelCallback) {
            this._subject.cancelCallback().catch((_) => { });
        }
    }
}
exports.SubjectSubscription = SubjectSubscription;
/** @private */
class ConsoleLogger {
    constructor(minimumLogLevel) {
        this._minLevel = minimumLogLevel;
        this.out = console;
    }
    log(logLevel, message) {
        if (logLevel >= this._minLevel) {
            const msg = `[${new Date().toISOString()}] ${ILogger_1.LogLevel[logLevel]}: ${message}`;
            switch (logLevel) {
                case ILogger_1.LogLevel.Critical:
                case ILogger_1.LogLevel.Error:
                    this.out.error(msg);
                    break;
                case ILogger_1.LogLevel.Warning:
                    this.out.warn(msg);
                    break;
                case ILogger_1.LogLevel.Information:
                    this.out.info(msg);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.out.log(msg);
                    break;
            }
        }
    }
}
exports.ConsoleLogger = ConsoleLogger;
/** @private */
function getUserAgentHeader() {
    let userAgentHeaderName = "X-SignalR-User-Agent";
    if (Platform.isNode) {
        userAgentHeaderName = "User-Agent";
    }
    return [userAgentHeaderName, constructUserAgent(exports.VERSION, getOsName(), getRuntime(), getRuntimeVersion())];
}
exports.getUserAgentHeader = getUserAgentHeader;
/** @private */
function constructUserAgent(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    let userAgent = "Microsoft SignalR/";
    const majorAndMinor = version.split(".");
    userAgent += `${majorAndMinor[0]}.${majorAndMinor[1]}`;
    userAgent += ` (${version}; `;
    if (os && os !== "") {
        userAgent += `${os}; `;
    }
    else {
        userAgent += "Unknown OS; ";
    }
    userAgent += `${runtime}`;
    if (runtimeVersion) {
        userAgent += `; ${runtimeVersion}`;
    }
    else {
        userAgent += "; Unknown Runtime Version";
    }
    userAgent += ")";
    return userAgent;
}
exports.constructUserAgent = constructUserAgent;
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function getOsName() {
    if (Platform.isNode) {
        switch (process.platform) {
            case "win32":
                return "Windows NT";
            case "darwin":
                return "macOS";
            case "linux":
                return "Linux";
            default:
                return process.platform;
        }
    }
    else {
        return "";
    }
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function getRuntimeVersion() {
    if (Platform.isNode) {
        return process.versions.node;
    }
    return undefined;
}
function getRuntime() {
    if (Platform.isNode) {
        return "NodeJS";
    }
    else {
        return "Browser";
    }
}
/** @private */
function getErrorString(e) {
    if (e.stack) {
        return e.stack;
    }
    else if (e.message) {
        return e.message;
    }
    return `${e}`;
}
exports.getErrorString = getErrorString;
/** @private */
function getGlobalThis() {
    // globalThis is semi-new and not available in Node until v12
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw new Error("could not find global");
}
exports.getGlobalThis = getGlobalThis;

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./ILogger":14,"./Loggers":17,"_process":27}],24:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketTransport = void 0;
const HeaderNames_1 = require("./HeaderNames");
const ILogger_1 = require("./ILogger");
const ITransport_1 = require("./ITransport");
const Utils_1 = require("./Utils");
/** @private */
class WebSocketTransport {
    constructor(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers) {
        this._logger = logger;
        this._accessTokenFactory = accessTokenFactory;
        this._logMessageContent = logMessageContent;
        this._webSocketConstructor = webSocketConstructor;
        this._httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this._headers = headers;
    }
    async connect(url, transferFormat) {
        Utils_1.Arg.isRequired(url, "url");
        Utils_1.Arg.isRequired(transferFormat, "transferFormat");
        Utils_1.Arg.isIn(transferFormat, ITransport_1.TransferFormat, "transferFormat");
        this._logger.log(ILogger_1.LogLevel.Trace, "(WebSockets transport) Connecting.");
        let token;
        if (this._accessTokenFactory) {
            token = await this._accessTokenFactory();
        }
        return new Promise((resolve, reject) => {
            url = url.replace(/^http/, "ws");
            let webSocket;
            const cookies = this._httpClient.getCookieString(url);
            let opened = false;
            if (Utils_1.Platform.isNode || Utils_1.Platform.isReactNative) {
                const headers = {};
                const [name, value] = (0, Utils_1.getUserAgentHeader)();
                headers[name] = value;
                if (token) {
                    headers[HeaderNames_1.HeaderNames.Authorization] = `Bearer ${token}`;
                }
                if (cookies) {
                    headers[HeaderNames_1.HeaderNames.Cookie] = cookies;
                }
                // Only pass headers when in non-browser environments
                webSocket = new this._webSocketConstructor(url, undefined, {
                    headers: { ...headers, ...this._headers },
                });
            }
            else {
                if (token) {
                    url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token)}`;
                }
            }
            if (!webSocket) {
                // Chrome is not happy with passing 'undefined' as protocol
                webSocket = new this._webSocketConstructor(url);
            }
            if (transferFormat === ITransport_1.TransferFormat.Binary) {
                webSocket.binaryType = "arraybuffer";
            }
            webSocket.onopen = (_event) => {
                this._logger.log(ILogger_1.LogLevel.Information, `WebSocket connected to ${url}.`);
                this._webSocket = webSocket;
                opened = true;
                resolve();
            };
            webSocket.onerror = (event) => {
                let error = null;
                // ErrorEvent is a browser only type we need to check if the type exists before using it
                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                    error = event.error;
                }
                else {
                    error = "There was an error with the transport";
                }
                this._logger.log(ILogger_1.LogLevel.Information, `(WebSockets transport) ${error}.`);
            };
            webSocket.onmessage = (message) => {
                this._logger.log(ILogger_1.LogLevel.Trace, `(WebSockets transport) data received. ${(0, Utils_1.getDataDetail)(message.data, this._logMessageContent)}.`);
                if (this.onreceive) {
                    try {
                        this.onreceive(message.data);
                    }
                    catch (error) {
                        this._close(error);
                        return;
                    }
                }
            };
            webSocket.onclose = (event) => {
                // Don't call close handler if connection was never established
                // We'll reject the connect call instead
                if (opened) {
                    this._close(event);
                }
                else {
                    let error = null;
                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                        error = event.error;
                    }
                    else {
                        error = "WebSocket failed to connect. The connection could not be found on the server,"
                            + " either the endpoint may not be a SignalR endpoint,"
                            + " the connection ID is not present on the server, or there is a proxy blocking WebSockets."
                            + " If you have multiple servers check that sticky sessions are enabled.";
                    }
                    reject(new Error(error));
                }
            };
        });
    }
    send(data) {
        if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
            this._logger.log(ILogger_1.LogLevel.Trace, `(WebSockets transport) sending data. ${(0, Utils_1.getDataDetail)(data, this._logMessageContent)}.`);
            this._webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    }
    stop() {
        if (this._webSocket) {
            // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
            // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
            this._close(undefined);
        }
        return Promise.resolve();
    }
    _close(event) {
        // webSocket will be null if the transport did not start successfully
        if (this._webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this._webSocket.onclose = () => { };
            this._webSocket.onmessage = () => { };
            this._webSocket.onerror = () => { };
            this._webSocket.close();
            this._webSocket = undefined;
        }
        this._logger.log(ILogger_1.LogLevel.Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) {
                this.onclose(new Error(`WebSocket closed with status code: ${event.code} (${event.reason || "no reason given"}).`));
            }
            else if (event instanceof Error) {
                this.onclose(event);
            }
            else {
                this.onclose();
            }
        }
    }
    _isCloseEvent(event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    }
}
exports.WebSocketTransport = WebSocketTransport;

},{"./HeaderNames":8,"./ILogger":14,"./ITransport":15,"./Utils":23}],25:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.XhrHttpClient = void 0;
const Errors_1 = require("./Errors");
const HttpClient_1 = require("./HttpClient");
const ILogger_1 = require("./ILogger");
const Utils_1 = require("./Utils");
class XhrHttpClient extends HttpClient_1.HttpClient {
    constructor(logger) {
        super();
        this._logger = logger;
    }
    /** @inheritDoc */
    send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new Errors_1.AbortError());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            if (request.content === "") {
                request.content = undefined;
            }
            if (request.content) {
                // Explicitly setting the Content-Type header for React Native on Android platform.
                if ((0, Utils_1.isArrayBuffer)(request.content)) {
                    xhr.setRequestHeader("Content-Type", "application/octet-stream");
                }
                else {
                    xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
                }
            }
            const headers = request.headers;
            if (headers) {
                Object.keys(headers)
                    .forEach((header) => {
                    xhr.setRequestHeader(header, headers[header]);
                });
            }
            if (request.responseType) {
                xhr.responseType = request.responseType;
            }
            if (request.abortSignal) {
                request.abortSignal.onabort = () => {
                    xhr.abort();
                    reject(new Errors_1.AbortError());
                };
            }
            if (request.timeout) {
                xhr.timeout = request.timeout;
            }
            xhr.onload = () => {
                if (request.abortSignal) {
                    request.abortSignal.onabort = null;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(new HttpClient_1.HttpResponse(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                }
                else {
                    reject(new Errors_1.HttpError(xhr.response || xhr.responseText || xhr.statusText, xhr.status));
                }
            };
            xhr.onerror = () => {
                this._logger.log(ILogger_1.LogLevel.Warning, `Error from HTTP request. ${xhr.status}: ${xhr.statusText}.`);
                reject(new Errors_1.HttpError(xhr.statusText, xhr.status));
            };
            xhr.ontimeout = () => {
                this._logger.log(ILogger_1.LogLevel.Warning, `Timeout from HTTP request.`);
                reject(new Errors_1.TimeoutError());
            };
            xhr.send(request.content);
        });
    }
}
exports.XhrHttpClient = XhrHttpClient;

},{"./Errors":5,"./HttpClient":9,"./ILogger":14,"./Utils":23}],26:[function(require,module,exports){
"use strict";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = exports.Subject = exports.JsonHubProtocol = exports.NullLogger = exports.TransferFormat = exports.HttpTransportType = exports.LogLevel = exports.MessageType = exports.HubConnectionBuilder = exports.HubConnectionState = exports.HubConnection = exports.DefaultHttpClient = exports.HttpResponse = exports.HttpClient = exports.TimeoutError = exports.HttpError = exports.AbortError = void 0;
var Errors_1 = require("./Errors");
Object.defineProperty(exports, "AbortError", { enumerable: true, get: function () { return Errors_1.AbortError; } });
Object.defineProperty(exports, "HttpError", { enumerable: true, get: function () { return Errors_1.HttpError; } });
Object.defineProperty(exports, "TimeoutError", { enumerable: true, get: function () { return Errors_1.TimeoutError; } });
var HttpClient_1 = require("./HttpClient");
Object.defineProperty(exports, "HttpClient", { enumerable: true, get: function () { return HttpClient_1.HttpClient; } });
Object.defineProperty(exports, "HttpResponse", { enumerable: true, get: function () { return HttpClient_1.HttpResponse; } });
var DefaultHttpClient_1 = require("./DefaultHttpClient");
Object.defineProperty(exports, "DefaultHttpClient", { enumerable: true, get: function () { return DefaultHttpClient_1.DefaultHttpClient; } });
var HubConnection_1 = require("./HubConnection");
Object.defineProperty(exports, "HubConnection", { enumerable: true, get: function () { return HubConnection_1.HubConnection; } });
Object.defineProperty(exports, "HubConnectionState", { enumerable: true, get: function () { return HubConnection_1.HubConnectionState; } });
var HubConnectionBuilder_1 = require("./HubConnectionBuilder");
Object.defineProperty(exports, "HubConnectionBuilder", { enumerable: true, get: function () { return HubConnectionBuilder_1.HubConnectionBuilder; } });
var IHubProtocol_1 = require("./IHubProtocol");
Object.defineProperty(exports, "MessageType", { enumerable: true, get: function () { return IHubProtocol_1.MessageType; } });
var ILogger_1 = require("./ILogger");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return ILogger_1.LogLevel; } });
var ITransport_1 = require("./ITransport");
Object.defineProperty(exports, "HttpTransportType", { enumerable: true, get: function () { return ITransport_1.HttpTransportType; } });
Object.defineProperty(exports, "TransferFormat", { enumerable: true, get: function () { return ITransport_1.TransferFormat; } });
var Loggers_1 = require("./Loggers");
Object.defineProperty(exports, "NullLogger", { enumerable: true, get: function () { return Loggers_1.NullLogger; } });
var JsonHubProtocol_1 = require("./JsonHubProtocol");
Object.defineProperty(exports, "JsonHubProtocol", { enumerable: true, get: function () { return JsonHubProtocol_1.JsonHubProtocol; } });
var Subject_1 = require("./Subject");
Object.defineProperty(exports, "Subject", { enumerable: true, get: function () { return Subject_1.Subject; } });
var Utils_1 = require("./Utils");
Object.defineProperty(exports, "VERSION", { enumerable: true, get: function () { return Utils_1.VERSION; } });

},{"./DefaultHttpClient":3,"./Errors":5,"./HttpClient":9,"./HubConnection":11,"./HubConnectionBuilder":12,"./IHubProtocol":13,"./ILogger":14,"./ITransport":15,"./JsonHubProtocol":16,"./Loggers":17,"./Subject":21,"./Utils":23}],27:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],28:[function(require,module,exports){
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared", "./EngineEntryPointBidder", "./PortalClientAPI", "./ForAllShared", "./EngineEntryPointBidder", "./PortalModels"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Client = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var EngineEntryPointBidder_1 = require("./EngineEntryPointBidder");
    var PortalClientAPI_1 = require("./PortalClientAPI");
    __exportStar(require("./ForAllShared"), exports);
    var EngineEntryPointBidder_2 = require("./EngineEntryPointBidder");
    Object.defineProperty(exports, "Commands", { enumerable: true, get: function () { return EngineEntryPointBidder_2.Commands; } });
    var PortalModels_1 = require("./PortalModels");
    Object.defineProperty(exports, "PortalModels", { enumerable: true, get: function () { return PortalModels_1.PortalModels; } });
    //export {Events as AnEvents, Commands as AnCommands};
    var Client = /** @class */ (function () {
        /**
         * Constructor - creates a new Client object which serves as a wrapper for the
         * AuctionNow Engine and Portal Repository and creates an abstracted Event Handler
         * @param configuration Options Bag for properties needed to instantiate a new engine and portal repository
         */
        function Client(configuration) {
            var _this = this;
            this.configuration = configuration;
            this.eventProcessor = new EventProcessor();
            /**
             * default null logger
             */
            this.logger = {
                LogVerbose: function (auctionId, itemId) {
                    var verbose = [];
                    for (var _i = 2; _i < arguments.length; _i++) {
                        verbose[_i - 2] = arguments[_i];
                    }
                },
                LogError: function (auctionId, itemId) {
                    var error = [];
                    for (var _i = 2; _i < arguments.length; _i++) {
                        error[_i - 2] = arguments[_i];
                    }
                },
                LogWarning: function (auctionId, itemId) {
                    var warning = [];
                    for (var _i = 2; _i < arguments.length; _i++) {
                        warning[_i - 2] = arguments[_i];
                    }
                },
                LogMetric: function (auctionId, itemId, name, value) { },
                BeginDependency: function () {
                    var data = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        data[_i] = arguments[_i];
                    }
                    return null;
                },
                EndDependency: function (auctionId, itemId, handle, success) { },
                BeginEvent: function () {
                    var data = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        data[_i] = arguments[_i];
                    }
                    return null;
                },
                EndEvent: function (auctionId, itemId, handle, success) { },
                RequestCorrelationId: function () { return ""; }
            };
            /**
             * default null lifetime notifications
             */
            this.lifetimeNotifications = {
                LoggingInUser: function () { },
                UserLoggedIn: function () { },
                CreatingSystemChannel: function () { },
                SystemChannelCreated: function () { },
                JoinError: function (auctionId, errorMessage) { },
                StartingChannels: function (auctionId, url) { },
                StartedChannels: function (auctionId, url) { },
                AttendeeJoiningTimeIssue: function (auctionId) { },
                JoiningCommand: function (auctionId) { },
                FiredJoiningCommand: function (auctionId) { },
                SystemChannelJoining: function (auctionId) { },
                SystemChannelJoined: function (auctionId) { },
                ReplayStarted: function (auctionId) { },
                ReplayEnded: function (auctionId) { },
                ProcessingEventsQueue: function (auctionId) { },
                ProcessedEventsQueue: function (auctionId) { },
            };
            /**
             * default null channel notifications
             */
            this.channelNotifications = {
                Connected: function () { },
                Disconnected: function () { },
                Slow: function () { },
                Error: function () { },
                Reconnecting: function () { },
                Reconnected: function () { }
            };
            this.test = function () { return console.log("TEST WORKED"); };
            /**
             * Starts the engine associated with this client
             * This will set a property on the engine object (IsStarted) to true
             * once the engine is ready to start joining auctions
             * @returns {Promise<void>}
             */
            this.start = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.engine.Start(this.configuration.systemHubUrl, null)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
            /**
             * JOIN methods
             */
            /**
             * Join and auction using the Internal Auction ID
             *
             * @param {string} internalAuctionId
             * @returns {void}
             * @memberof Client
             */
            this.joinWithInternalAuctionId = function (internalAuctionId) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.engine.JoinAuction(internalAuctionId, null, this.channelNotifications, false, true)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
            /**
             * Join and auction using External Auction Information
             *
             * @param {string} tenant
             * @param {string} externalAuctionId
             * @returns {void}
             * @memberof Client
             */
            this.join = function (tenant, externalAuctionId) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.engine.JoinAuctionUsingExternalInfo(tenant, externalAuctionId, this.channelNotifications, false, true)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
            /**
             * Leave an auction specified by Internal Auction ID
             *
             * @param {string} internalAuctionId
             * @returns {void}
             * @memberof Client
             */
            this.leave = function (internalAuctionId) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.engine.LeaveAuction(internalAuctionId)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
            /**
             * Specify a function to use for a specific plugin role
             * Valid Plugin Names are:
             * - Logger
             * - LifetimeNotifications
             * - ChannelNotifications
             *
             * @param {string} pluginName
             * @param {*} plugin
             * @returns {void}
             * @memberof Client
             */
            this.use = function (pluginName, plugin) {
                if (pluginName === "Logger") {
                    if (plugin === "console") {
                        var consoleLogger = {
                            LogVerbose: function (auctionId, itemId) {
                                var verbose = [];
                                for (var _i = 2; _i < arguments.length; _i++) {
                                    verbose[_i - 2] = arguments[_i];
                                }
                                return console.log.apply(console, __spreadArrays(["LogVerbose", auctionId, itemId], verbose));
                            },
                            RequestCorrelationId: function () { return "correlationId"; },
                            BeginDependency: function () {
                                var data = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    data[_i] = arguments[_i];
                                }
                                console.log.apply(console, __spreadArrays(["BeginDependency"], data));
                                return null;
                            },
                            LogError: function (auctionId, itemId) {
                                var error = [];
                                for (var _i = 2; _i < arguments.length; _i++) {
                                    error[_i - 2] = arguments[_i];
                                }
                                return console.log.apply(console, __spreadArrays(["LogError", auctionId, itemId], error));
                            },
                            LogWarning: function (auctionId, itemId) {
                                var warning = [];
                                for (var _i = 2; _i < arguments.length; _i++) {
                                    warning[_i - 2] = arguments[_i];
                                }
                                return console.log.apply(console, __spreadArrays(["LogWarning", auctionId, itemId], warning));
                            },
                            EndDependency: function (auctionId, itemId, handle, success) {
                                return console.log("EndDependency", auctionId, itemId, handle, success);
                            },
                            BeginEvent: function () {
                                var data = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    data[_i] = arguments[_i];
                                }
                                console.log.apply(console, __spreadArrays(["BeginEvent"], data));
                                return null;
                            },
                            EndEvent: function (auctionId, itemId, handle) {
                                return console.log("EndEvent", auctionId, itemId, handle);
                            },
                            LogMetric: function (auctionId, itemId, name, value) { return console.log("LogMetric", auctionId, itemId, name, value); }
                        };
                        _this.updatePluginMethods(_this.logger, consoleLogger);
                    }
                    else {
                        //todo: validate logger
                        _this.updatePluginMethods(_this.logger, plugin);
                    }
                }
                if (pluginName === "LifetimeNotifications") {
                    //todo: validate lifetime notifications
                    _this.updatePluginMethods(_this.lifetimeNotifications, plugin);
                }
                if (pluginName === "ChannelNotifications") {
                    //todo: validate channel notifications
                    _this.updatePluginMethods(_this.channelNotifications, plugin);
                }
            };
            /**
             * Add an Event handler for a specific Event Name
             *
             * @param {string} eventName
             * @param {Function} handler
             * @returns {void}
             * @memberof Client
             */
            this.on = function (eventName, handler) {
                _this.eventProcessor.handlers.push(new EventProcessorHandler(eventName.toLowerCase(), handler));
                console.log(_this.eventProcessor.handlers);
            };
            /**
             * Remove an Event Handler for a specific Event Name
             *
             * @param {string} eventName
             * @returns {void}
             * @memberof Client
             */
            this.off = function (eventName) {
                var handlerIndex = _this.eventProcessor.handlers.findIndex(function (handler) {
                    return handler.eventName === eventName.toLowerCase();
                });
                _this.eventProcessor.handlers.splice(handlerIndex, 1);
            };
            /**
             * Exposer Bidder/Seller Commands as methods
             */
            /**
             * Place Bid
             * sends a bid for a specific auction item
             * item must be on the block
             * bid amounts must be in $25 increments
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {number} amount
             * @returns {void}
             * @memberof Client
             */
            this.placeBid = function (internalAuctionId, internalItemId, amount, bidderId) {
                var command = new EngineEntryPointBidder_1.Commands.PlaceBidCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.GetBidderId(bidderId);
                command.Amount = amount;
                var val = val | Math.pow(2, 0);
                val = val | Math.pow(2, 11);
                val = val | Math.pow(2, 14);
                val = val | Math.pow(2, 19);
                command.BidMask = val.toString();
                _this.engine.FireCommand(command);
            };
            /**
             * Place Jump Bid
             * sends a bid for a specific auction item
             * item must be on the block
             * bid amounts must be in $25 increments
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {number} amount
             * @returns {void}
             * @memberof Client
             */
            this.placeJumpBid = function (internalAuctionId, internalItemId, amount, bidderId) {
                var command = new EngineEntryPointBidder_1.Commands.PlaceBidCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.GetBidderId(bidderId);
                command.Amount = amount;
                var val = val | Math.pow(2, 0);
                val = val | Math.pow(2, 8);
                val = val | Math.pow(2, 14);
                val = val | Math.pow(2, 19);
                command.BidMask = val.toString();
                _this.engine.FireCommand(command);
            };
            /**
             * Place AutoBid
             * sends a bid amount that will be applied automatically
             * when the item is on the block
             * bid must be in $25 increments
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {number} amount
             * @returns {void}
             * @memberof Client
             */
            this.placeAutoBid = function (internalAuctionId, internalItemId, amount, bidderId) {
                var command = new EngineEntryPointBidder_1.Commands.PlaceAutoBidCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.GetBidderId(bidderId);
                command.Amount = amount;
                _this.engine.FireCommand(command);
            };
            /**
             * Modify AutoBid
             * modify a previous placed AutoBid
             * bid must be in $25 increments
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {number} amount
             * @returns {void}
             * @memberof Client
             */
            this.modifyAutoBid = function (internalAuctionId, internalItemId, amount, bidderId) {
                var command = new EngineEntryPointBidder_1.Commands.ModifyAutoBidCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.GetBidderId(bidderId);
                command.Amount = amount;
                _this.engine.FireCommand(command);
            };
            /**
             * Remove AutoBid
             * removes an existing AutoBid
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.removeAutoBid = function (internalAuctionId, internalItemId, bidderId) {
                var command = new EngineEntryPointBidder_1.Commands.RemoveAutoBidCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.GetBidderId(bidderId);
                _this.engine.FireCommand(command);
            };
            /**
             * Sends a message to the clerk
             * either FreeForm (messageType = 2)
             * or by Key (messageType = 1)
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {string} message
             * @param {Shared.MessageType} [messageType]
             * @returns {void}
             * @memberof Client
             */
            this.messageToClerk = function (internalAuctionId, internalItemId, message, messageType) {
                var command = new EngineEntryPointBidder_1.Commands.MessageToClerkCommand(internalAuctionId, internalItemId);
                command.MessageType = messageType || ForAllShared_1.Shared.MessageType.FreeForm;
                command.Message = message;
                _this.engine.FireCommand(command);
            };
            /**
             * Rep Info to Clerk
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.repInfoToClerk = function (internalAuctionId, internalItemId) {
                var command = new EngineEntryPointBidder_1.Commands.RepInfoToClerkCommand(internalAuctionId, internalItemId);
                _this.engine.FireCommand(command);
            };
            /**
             * Specify if an item has a seller rep online
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {boolean} isRepped
             * @returns {void}
             * @memberof Client
             */
            this.sellerReppingOnline = function (internalAuctionId, internalItemId, isRepped) {
                var command = new EngineEntryPointBidder_1.Commands.SellerReppingOnlineCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.configuration.bidderId;
                command.IsRepped = isRepped;
                _this.engine.FireCommand(command);
            };
            /**
             * Start a negotiation for a specific auction item
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {number} amount
             * @returns {void}
             * @memberof Client
             */
            this.createNegotiationOffer = function (internalAuctionId, internalItemId, amount) {
                var command = new EngineEntryPointBidder_1.Commands.CreateNegotiationOfferCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.configuration.bidderId;
                command.OfferAmount = amount;
                _this.engine.FireCommand(command);
            };
            /**
             * Anwer an an offer with a counter amount
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {number} amount
             * @returns {void}
             * @memberof Client
             */
            this.answerNegotiationOffer = function (internalAuctionId, internalItemId, amount) {
                var command = new EngineEntryPointBidder_1.Commands.AnswerNegotiationOfferCommand(internalAuctionId, internalItemId);
                command.OfferAnswer = amount;
                _this.engine.FireCommand(command);
            };
            /**
             * Send a sell confirmation for a negotiated offer
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.negotiationSellIt = function (internalAuctionId, internalItemId) {
                var command = new EngineEntryPointBidder_1.Commands.NegotiationSellItCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.configuration.bidderId;
                _this.engine.FireCommand(command);
            };
            /**
             * Send a call for a negotiated offer
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.negotiationCall = function (internalAuctionId, internalItemId) {
                var command = new EngineEntryPointBidder_1.Commands.NegotiationCallCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.configuration.bidderId;
                _this.engine.FireCommand(command);
            };
            /**
             * Rerun a negotiation
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.negotiationRerun = function (internalAuctionId, internalItemId) {
                var command = new EngineEntryPointBidder_1.Commands.NegotiationRerunCommand(internalAuctionId, internalItemId);
                command.SelectedBidderId = _this.configuration.bidderId;
                _this.engine.FireCommand(command);
            };
            /**
             * Add or Update a note for an auction item
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {string} message
             * @returns {void}
             * @memberof Client
             */
            this.addUpdateItemNote = function (internalAuctionId, internalItemId, message) {
                var command = new EngineEntryPointBidder_1.Commands.AddOrUpdateNotesCommand(internalAuctionId, internalItemId);
                command.Message = message;
                _this.engine.FireCommand(command);
            };
            /**
             * Add or Update a consignor note for an auction item
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @param {string} message
             * @returns {void}
             * @memberof Client
             */
            this.addUpdateConsignorNote = function (internalAuctionId, internalItemId, message) {
                var command = new EngineEntryPointBidder_1.Commands.AddOrUpdateConsginorNotesCommand(internalAuctionId, internalItemId);
                command.Message = message;
                _this.engine.FireCommand(command);
            };
            /**
             * Remove a note for an auction item
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.removeItemNote = function (internalAuctionId, internalItemId) {
                var command = new EngineEntryPointBidder_1.Commands.RemoveNotesCommand(internalAuctionId, internalItemId);
                _this.engine.FireCommand(command);
            };
            /**
             * Add an auction item to this user's watch list
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.addToWatchList = function (internalAuctionId, internalItemId, bidderId) {
                var command = new EngineEntryPointBidder_1.Commands.ModifyWatchListCommand(internalAuctionId);
                command.WatchItemIds = [internalItemId];
                command.UnWatchItemIds = [];
                command.Roleid = _this.GetBidderId(bidderId);
                _this.engine.FireCommand(command);
            };
            /**
             * Remove an auction item from this user's watch list
             *
             * @param {string} internalAuctionId
             * @param {string} internalItemId
             * @returns {void}
             * @memberof Client
             */
            this.removeFromWatchList = function (internalAuctionId, internalItemId, bidderId) {
                var command = new EngineEntryPointBidder_1.Commands.ModifyWatchListCommand(internalAuctionId);
                command.WatchItemIds = [];
                command.UnWatchItemIds = [internalItemId];
                command.Roleid = _this.GetBidderId(bidderId);
                _this.engine.FireCommand(command);
            };
            // instantiate portal repository
            if (!this.configuration.portalApiUrl) {
                throw new Error("Portal API URL (portalApiUrl) missing from configuration");
            }
            if (!this.configuration.systemHubUrl) {
                throw new Error("System Hub URL (systemHubUrl) missing from configuration");
            }
            if (!this.configuration.bearerToken) {
                throw new Error("BearerToken (bearerToken) missing from configuration");
            }
            this.auctionService = new PortalClientAPI_1.Portal.PortalRepository(this.configuration.portalApiUrl, this.configuration.bearerToken, this.configuration.portalJoinApiApiUrl);
            // instantiate auction now engine
            this.engine = new EngineEntryPointBidder_1.CoreEngine.Engine(new EngineEntryPointBidder_1.SignalRChannels.SignalRChannelFactory(this.configuration.bearerToken), this.logger, this.auctionService, this.lifetimeNotifications);
            this.engine.AddEventProcessor(this.eventProcessor);
        }
        Client.prototype.updatePluginMethods = function (plugin, newPlugin) {
            for (var property in plugin) {
                if (newPlugin[property]) {
                    plugin[property] = newPlugin[property];
                }
                else {
                    plugin[property] = function () { };
                }
            }
        };
        Client.prototype.GetBidderId = function (bidderId) {
            if (typeof bidderId !== 'undefined') {
                return bidderId;
            }
            return this.configuration.bidderId;
        };
        return Client;
    }());
    exports.Client = Client;
    /**
     * Event Processor that works on a subscription model
     * A collection of handlers associated with event names is managed by the client
     * using conventional .on and .off methods
     * An optional "all" event handler can be specified to allow for common event handling code (e.g. logging)
     *
     * @class EventProcessor
     * @implements {Shared.IEventProcessor}
     */
    var EventProcessor = /** @class */ (function () {
        function EventProcessor() {
            this.handlers = [];
        }
        /**
         *
         *
         * @param {Shared.DomainEvent} event
         * @param {string} channelName
         * @returns {Promise<void>}
         * @memberof EventProcessor
         */
        EventProcessor.prototype.Process = function (event, channelName) {
            // check to see if we have a handler that should be run for all events
            var allEventsProcessorHandler = this.handlers.find(function (handler) {
                return handler.eventName === "all";
            });
            if (allEventsProcessorHandler) {
                allEventsProcessorHandler.handler(event);
            }
            // look for a handler for this specific event
            var eventProcessorHandler = this.handlers.find(function (handler) {
                return handler.eventName === event._eventName.toLowerCase();
            });
            if (eventProcessorHandler) {
                eventProcessorHandler.handler(event);
            }
            return;
        };
        return EventProcessor;
    }());
    /**
     * associates event names with handler functions
     *
     * @class EventProcessorHandler
     */
    var EventProcessorHandler = /** @class */ (function () {
        function EventProcessorHandler(eventName, handler) {
            this.eventName = eventName;
            this.handler = handler;
        }
        return EventProcessorHandler;
    }());
    /**
     * Configuration Bag for initializing the client
     *
     * @class AuctionNowConfiguration
     */
    var AuctionNowConfiguration = /** @class */ (function () {
        function AuctionNowConfiguration() {
        }
        return AuctionNowConfiguration;
    }());
});
},{"./EngineEntryPointBidder":31,"./ForAllShared":34,"./PortalClientAPI":36,"./PortalModels":37}],29:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Commands = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var Commands;
    (function (Commands) {
        var PlaceBidCommand = /** @class */ (function (_super) {
            __extends(PlaceBidCommand, _super);
            function PlaceBidCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "PlaceBidBidder", internalAuctionId, internalItemId) || this;
            }
            return PlaceBidCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.PlaceBidCommand = PlaceBidCommand;
        var PlaceAutoBidCommand = /** @class */ (function (_super) {
            __extends(PlaceAutoBidCommand, _super);
            function PlaceAutoBidCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "PlaceAutoBid", internalAuctionId, internalItemId) || this;
            }
            return PlaceAutoBidCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.PlaceAutoBidCommand = PlaceAutoBidCommand;
        var ModifyAutoBidCommand = /** @class */ (function (_super) {
            __extends(ModifyAutoBidCommand, _super);
            function ModifyAutoBidCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "ModifyAutoBid", internalAuctionId, internalItemId) || this;
            }
            return ModifyAutoBidCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.ModifyAutoBidCommand = ModifyAutoBidCommand;
        var MessageToClerkCommand = /** @class */ (function (_super) {
            __extends(MessageToClerkCommand, _super);
            function MessageToClerkCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "MessageToClerkCommand", internalAuctionId, internalItemId) || this;
            }
            return MessageToClerkCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.MessageToClerkCommand = MessageToClerkCommand;
        var RepInfoToClerkCommand = /** @class */ (function (_super) {
            __extends(RepInfoToClerkCommand, _super);
            function RepInfoToClerkCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "RepInfoToClerkCommand", internalAuctionId, internalItemId) || this;
            }
            return RepInfoToClerkCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.RepInfoToClerkCommand = RepInfoToClerkCommand;
        var RemoveAutoBidCommand = /** @class */ (function (_super) {
            __extends(RemoveAutoBidCommand, _super);
            function RemoveAutoBidCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "RemoveAutoBid", internalAuctionId, internalItemId) || this;
            }
            return RemoveAutoBidCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.RemoveAutoBidCommand = RemoveAutoBidCommand;
        var SellerReppingOnlineCommand = /** @class */ (function (_super) {
            __extends(SellerReppingOnlineCommand, _super);
            function SellerReppingOnlineCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "SellerReppingOnline", internalAuctionId, internalItemId) || this;
            }
            return SellerReppingOnlineCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.SellerReppingOnlineCommand = SellerReppingOnlineCommand;
        var ReserveTogglePreBlockCommand = /** @class */ (function (_super) {
            __extends(ReserveTogglePreBlockCommand, _super);
            function ReserveTogglePreBlockCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "ReserveTogglePreBlockCommand", internalAuctionId, internalItemId) || this;
            }
            return ReserveTogglePreBlockCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.ReserveTogglePreBlockCommand = ReserveTogglePreBlockCommand;
        var CreateNegotiationOfferCommand = /** @class */ (function (_super) {
            __extends(CreateNegotiationOfferCommand, _super);
            function CreateNegotiationOfferCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "CreateNegotiationOfferCommand", internalAuctionId, internalItemId) || this;
            }
            return CreateNegotiationOfferCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.CreateNegotiationOfferCommand = CreateNegotiationOfferCommand;
        var NegotiationSellItCommand = /** @class */ (function (_super) {
            __extends(NegotiationSellItCommand, _super);
            function NegotiationSellItCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "NegotiationSellItCommand", internalAuctionId, internalItemId) || this;
            }
            return NegotiationSellItCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.NegotiationSellItCommand = NegotiationSellItCommand;
        var NegotiationCallCommand = /** @class */ (function (_super) {
            __extends(NegotiationCallCommand, _super);
            function NegotiationCallCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "NegotiationCallCommand", internalAuctionId, internalItemId) || this;
            }
            return NegotiationCallCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.NegotiationCallCommand = NegotiationCallCommand;
        var NegotiationRerunCommand = /** @class */ (function (_super) {
            __extends(NegotiationRerunCommand, _super);
            function NegotiationRerunCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "NegotiationRerunCommand", internalAuctionId, internalItemId) || this;
            }
            return NegotiationRerunCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.NegotiationRerunCommand = NegotiationRerunCommand;
        var AnswerNegotiationOfferCommand = /** @class */ (function (_super) {
            __extends(AnswerNegotiationOfferCommand, _super);
            function AnswerNegotiationOfferCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "AnswerNegotiationOfferCommand", internalAuctionId, internalItemId) || this;
            }
            return AnswerNegotiationOfferCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.AnswerNegotiationOfferCommand = AnswerNegotiationOfferCommand;
        var AddOrUpdateNotesCommand = /** @class */ (function (_super) {
            __extends(AddOrUpdateNotesCommand, _super);
            function AddOrUpdateNotesCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "AddOrUpdateNotes", internalAuctionId, internalItemId) || this;
            }
            return AddOrUpdateNotesCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.AddOrUpdateNotesCommand = AddOrUpdateNotesCommand;
        var AddOrUpdateConsginorNotesCommand = /** @class */ (function (_super) {
            __extends(AddOrUpdateConsginorNotesCommand, _super);
            function AddOrUpdateConsginorNotesCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "AddOrUpdateConsginorNotes", internalAuctionId, internalItemId) || this;
            }
            return AddOrUpdateConsginorNotesCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.AddOrUpdateConsginorNotesCommand = AddOrUpdateConsginorNotesCommand;
        var RemoveNotesCommand = /** @class */ (function (_super) {
            __extends(RemoveNotesCommand, _super);
            function RemoveNotesCommand(internalAuctionId, internalItemId) {
                return _super.call(this, "RemoveNotes", internalAuctionId, internalItemId) || this;
            }
            return RemoveNotesCommand;
        }(ForAllShared_1.Shared.ItemCommand));
        Commands.RemoveNotesCommand = RemoveNotesCommand;
        var ModifyWatchListCommand = /** @class */ (function (_super) {
            __extends(ModifyWatchListCommand, _super);
            function ModifyWatchListCommand(internalAuctionId) {
                return _super.call(this, internalAuctionId, "ModifyWatchList") || this;
            }
            return ModifyWatchListCommand;
        }(ForAllShared_1.Shared.Command));
        Commands.ModifyWatchListCommand = ModifyWatchListCommand;
        var KickVCBUserCommand = /** @class */ (function (_super) {
            __extends(KickVCBUserCommand, _super);
            function KickVCBUserCommand(internalAuctionId) {
                return _super.call(this, internalAuctionId, "KickVCBUser") || this;
            }
            return KickVCBUserCommand;
        }(ForAllShared_1.Shared.Command));
        Commands.KickVCBUserCommand = KickVCBUserCommand;
        var AddUsertoVCBCommand = /** @class */ (function (_super) {
            __extends(AddUsertoVCBCommand, _super);
            function AddUsertoVCBCommand(internalAuctionId) {
                return _super.call(this, internalAuctionId, "AddUsertoVCB") || this;
            }
            return AddUsertoVCBCommand;
        }(ForAllShared_1.Shared.Command));
        Commands.AddUsertoVCBCommand = AddUsertoVCBCommand;
        var CheckDuplicateLoginUsersVCBCommand = /** @class */ (function (_super) {
            __extends(CheckDuplicateLoginUsersVCBCommand, _super);
            function CheckDuplicateLoginUsersVCBCommand(internalAuctionId) {
                return _super.call(this, internalAuctionId, "CheckDuplicateLoginUsersVCB") || this;
            }
            return CheckDuplicateLoginUsersVCBCommand;
        }(ForAllShared_1.Shared.Command));
        Commands.CheckDuplicateLoginUsersVCBCommand = CheckDuplicateLoginUsersVCBCommand;
        var RemoveUserVCBCommand = /** @class */ (function (_super) {
            __extends(RemoveUserVCBCommand, _super);
            function RemoveUserVCBCommand(internalAuctionId) {
                return _super.call(this, internalAuctionId, "RemoveUserVCB") || this;
            }
            return RemoveUserVCBCommand;
        }(ForAllShared_1.Shared.Command));
        Commands.RemoveUserVCBCommand = RemoveUserVCBCommand;
    })(Commands = exports.Commands || (exports.Commands = {}));
});
},{"./ForAllShared":34}],30:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BidderAuctionModifier = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var BidderAuctionModifier = /** @class */ (function (_super) {
        __extends(BidderAuctionModifier, _super);
        function BidderAuctionModifier(auctionId) {
            var _this = _super.call(this, auctionId) || this;
            _this.Users = [];
            _this.AutoBids = [];
            _this.WatchList = [];
            _this.Notes = [];
            _this.Audio = null;
            _this.ConsignorInfo = [];
            return _this;
        }
        BidderAuctionModifier.prototype.SetSelectedUsers = function (users) {
            this.Users = users;
            this.CallObservers("Users");
        };
        BidderAuctionModifier.prototype.WatchListsLoaded = function () {
            this.CallObservers("WatchListLoaded");
        };
        BidderAuctionModifier.prototype.NotesLoaded = function () {
            this.CallObservers("NotesLoaded");
        };
        BidderAuctionModifier.prototype.AutoBidsLoaded = function () {
            this.CallObservers("AutoBidsLoaded");
        };
        BidderAuctionModifier.prototype.ConsignorInfoLoaded = function () {
            this.CallObservers("ConsignorInfoLoaded");
        };
        BidderAuctionModifier.prototype.NotesRemoved = function (itemId) {
            var index = this.Notes.findIndex(function (p) { return p.InternalAuctionItemId === itemId; });
            var note = this.Notes[index];
            this.Notes.splice(index, 1);
            this.CallObservers("Notes");
        };
        BidderAuctionModifier.prototype.NotesAdded = function (itemId, message) {
            var note = new ForAllShared_1.Shared.NoteResult(itemId, message);
            var index = this.Notes.findIndex(function (p) { return p.InternalAuctionItemId === itemId; });
            if (index >= 0) {
                this.Notes.splice(index, 1);
            }
            this.Notes.push(note);
            this.CallObservers("Notes");
        };
        BidderAuctionModifier.prototype.WatchListModified = function (removed, itemId) {
            if (removed) {
                var index = this.WatchList.findIndex(function (p) { return p === itemId; });
                this.WatchList.splice(index, 1);
            }
            else {
                this.WatchList.push(itemId);
            }
            this.CallObservers("WatchList");
        };
        BidderAuctionModifier.prototype.AutoBidModified = function (itemId, amount, bidderId, currentHighBidAmount) {
            var prevautoBid = this.CheckPrevAutoBid(itemId);
            var autoBid = new ForAllShared_1.Shared.AutoBidResult(itemId, amount, bidderId, currentHighBidAmount, prevautoBid.WinnerBidderId);
            this.AutoBids.push(autoBid);
            this.CallObservers("AutoBids");
        };
        BidderAuctionModifier.prototype.AutoBidPlaced = function (itemId, amount, bidderId, currentHighBidAmount) {
            this.InternalAutoBidRemove(itemId);
            var autoBid = new ForAllShared_1.Shared.AutoBidResult(itemId, amount, bidderId, currentHighBidAmount, "");
            this.AutoBids.push(autoBid);
            this.CallObservers("AutoBids");
        };
        BidderAuctionModifier.prototype.HighAutoBid = function (itemId, WinnerBidderId) {
            var prevautoBid = this.CheckPrevAutoBid(itemId);
            var autoBid = new ForAllShared_1.Shared.AutoBidResult(itemId, prevautoBid.Amount, prevautoBid.BidderId, prevautoBid.CurrentHighBidAmount, WinnerBidderId);
            this.AutoBids.push(autoBid);
            this.CallObservers("AutoBids");
        };
        BidderAuctionModifier.prototype.CheckPrevAutoBid = function (itemId) {
            var prevautoBid = this.AutoBids.find(function (m) { return m.InternalAuctionItemId == itemId; });
            this.InternalAutoBidRemove(itemId);
            if (!prevautoBid) {
                prevautoBid = { InternalAuctionItemId: itemId,
                    Amount: 0,
                    CurrentHighBidAmount: 0,
                    BidderId: "",
                    WinnerBidderId: ""
                };
            }
            return prevautoBid;
        };
        BidderAuctionModifier.prototype.AutoBidRemoved = function (itemId) {
            this.InternalAutoBidRemove(itemId);
        };
        BidderAuctionModifier.prototype.SecurityChanged = function (items) {
            var _loop_1 = function (item) {
                var found = this_1.AuctionItems.find(function (p) { return p.ItemId === item.ItemId; });
                if (found != null) {
                    found.UserCanBid = item.UserCanBid;
                    found.UserCanClerk = item.UserCanClerk;
                    found.UserCanSell = item.UserCanSell;
                    found.CanAutoBid = item.CanAutoBid;
                    found.UserIsViewOnly = item.UserIsViewOnly;
                }
            };
            var this_1 = this;
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                _loop_1(item);
            }
            this.CallObservers("Security");
        };
        BidderAuctionModifier.prototype.InternalAutoBidRemove = function (itemId) {
            var index = this.AutoBids.findIndex(function (p) { return p.InternalAuctionItemId === itemId; });
            //const autoBid = this.AutoBids[index];
            if (index >= 0) {
                this.AutoBids.splice(index, 1);
                this.CallObservers("AutoBids");
            }
        };
        return BidderAuctionModifier;
    }(ForAllShared_1.Shared.AuctionModifierBase));
    exports.BidderAuctionModifier = BidderAuctionModifier;
});
},{"./ForAllShared":34}],31:[function(require,module,exports){
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared", "./BidderSellerCommands", "./SignalRChannelsBidderSeller", "./StandaloneDataRepository", "./BidderSellerShared", "./EngineShared", "./LiveBiddingClientBidderEngine"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require("./ForAllShared"), exports);
    __exportStar(require("./BidderSellerCommands"), exports);
    __exportStar(require("./SignalRChannelsBidderSeller"), exports);
    __exportStar(require("./StandaloneDataRepository"), exports);
    __exportStar(require("./BidderSellerShared"), exports);
    __exportStar(require("./EngineShared"), exports);
    __exportStar(require("./LiveBiddingClientBidderEngine"), exports);
});
},{"./BidderSellerCommands":29,"./BidderSellerShared":30,"./EngineShared":32,"./ForAllShared":34,"./LiveBiddingClientBidderEngine":35,"./SignalRChannelsBidderSeller":40,"./StandaloneDataRepository":42}],32:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseInternalEventProcessor = exports.BaseEngine = exports.ChannelNotifications = exports.AuctionChannelNotifications = exports.InstantEventQueue = exports.Helpers = exports.AuctionMapping = exports.CommandProcessor = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var CommandProcessor = /** @class */ (function () {
        function CommandProcessor(factory, eventQueue, logger, auction, channelNotifications, eventNotifications) {
            this.factory = factory;
            this.eventQueue = eventQueue;
            this.logger = logger;
            this.auction = auction;
            this.channelNotifications = channelNotifications;
            this.eventNotifications = eventNotifications;
            this._queueCommands = false;
            this._commandQueue = [];
            this._isProcessing = false;
        }
        CommandProcessor.prototype.FailoverTo = function (uri) {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.eventNotifications.FailingOver(this.auction.InternalAuctionId, uri);
                            this.comChannels.forEach(function (p) { try {
                                p.Stop();
                            }
                            catch (e) { } });
                            _a = this;
                            return [4 /*yield*/, this.factory.FailOver(this.comChannels, uri, this.auction.InternalAuctionId, this.eventQueue, this.logger, this.channelNotifications)];
                        case 1:
                            _a.comChannels = _b.sent();
                            this.eventNotifications.FailedOver(this.auction.InternalAuctionId, uri);
                            return [2 /*return*/];
                    }
                });
            });
        };
        CommandProcessor.prototype.Start = function (uri) {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.eventNotifications.StartingChannels(this.auction.InternalAuctionId, uri);
                            _a = this;
                            return [4 /*yield*/, this.factory.CreateChannels(uri, this.auction.InternalAuctionId, this.eventQueue, this.logger, this.channelNotifications)];
                        case 1:
                            _a.comChannels = _b.sent();
                            this.eventNotifications.StartedChannels(this.auction.InternalAuctionId, uri);
                            return [2 /*return*/];
                    }
                });
            });
        };
        CommandProcessor.prototype.Stop = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, c;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(this.comChannels != null)) return [3 /*break*/, 4];
                            _i = 0, _a = this.comChannels;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            c = _a[_i];
                            return [4 /*yield*/, c.Stop()];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CommandProcessor.prototype.Process = function (command) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this._queueCommands) {
                                if (this._isProcessing) {
                                    this._commandQueue.push(command);
                                    return [2 /*return*/];
                                }
                            }
                            return [4 /*yield*/, this.TryProcessCommand(command)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CommandProcessor.prototype.TryProcessCommand = function (command) {
            return __awaiter(this, void 0, void 0, function () {
                var handle, _i, _a, c, e_1, itemId, p;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this._isProcessing = true;
                            this.logger.LogVerbose(command.InternalAuctionId, "PC", command.CommandName);
                            handle = this.logger.BeginEvent("PC", command.CommandName);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 6, 7, 8]);
                            if (!(this.comChannels != null)) return [3 /*break*/, 5];
                            _i = 0, _a = this.comChannels;
                            _b.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            c = _a[_i];
                            return [4 /*yield*/, c.Process(command)];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            e_1 = _b.sent();
                            this.logger.LogError(command.InternalAuctionId, "PCE", e_1);
                            throw e_1;
                        case 7:
                            this._isProcessing = false;
                            itemId = "";
                            if (command instanceof ForAllShared_1.Shared.ItemCommand) {
                                itemId = command.ItemId;
                            }
                            this.logger.EndEvent(command.InternalAuctionId, itemId, handle);
                            return [7 /*endfinally*/];
                        case 8:
                            if (!this._queueCommands) return [3 /*break*/, 11];
                            _b.label = 9;
                        case 9:
                            if (!(this._commandQueue.length > 0)) return [3 /*break*/, 11];
                            p = this._commandQueue.pop();
                            return [4 /*yield*/, this.TryProcessCommand(p)];
                        case 10:
                            _b.sent();
                            return [3 /*break*/, 9];
                        case 11: return [2 /*return*/];
                    }
                });
            });
        };
        return CommandProcessor;
    }());
    exports.CommandProcessor = CommandProcessor;
    var AuctionMapping = /** @class */ (function () {
        function AuctionMapping(JoinedAuction, CommandProcessor, InternalEventProcessor) {
            this.JoinedAuction = JoinedAuction;
            this.CommandProcessor = CommandProcessor;
            this.InternalEventProcessor = InternalEventProcessor;
        }
        AuctionMapping.prototype.Dispose = function () {
            return __awaiter(this, void 0, void 0, function () {
                var ex_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, this.CommandProcessor.Stop()];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            ex_1 = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            this.CommandProcessor = null;
                            this.InternalEventProcessor = null;
                            this.JoinedAuction = null;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        return AuctionMapping;
    }());
    exports.AuctionMapping = AuctionMapping;
    var Helpers = /** @class */ (function () {
        function Helpers() {
        }
        Helpers.BuildAuctionsUri = function (uriBase, auctions) {
            return uriBase + "?auctions=" + encodeURIComponent(JSON.stringify(auctions.map(function (p) { return ({ T: p.Tenant, Id: p.ExternalAuctionId }); })));
        };
        Helpers.AuctionInfosFromUri = function (uri) {
            var data = Helpers.GetQueryVariable("auctions", uri);
            if (data == null) {
                return [this.AuctionInfoFromUri(uri)];
            }
            var auctions = JSON.parse(data);
            var res = [];
            auctions.forEach(function (element) {
                res.push({ Tenant: element.T, ExternalAuctionId: element.Id, Lang: element.Lang, Timezone: element.Timezone, Tokentenant: element.Tokentenant, Token: element.Token });
            });
            return res;
        };
        Helpers.AuctionInfoFromUri = function (uri) {
            var tenant = Helpers.GetQueryVariable("tenant", uri);
            var auctionId = Helpers.GetQueryVariable("id", uri);
            var lang = Helpers.GetQueryVariable("lang", uri);
            var timezone = Helpers.GetQueryVariable("timezone", uri);
            var tokentenant = Helpers.GetQueryVariable("tokentenant", uri);
            var token = Helpers.GetQueryVariable("token", uri);
            return { Tenant: tenant, ExternalAuctionId: auctionId, Lang: lang, Timezone: timezone, Tokentenant: tokentenant, Token: token };
        };
        Helpers.GetQueryVariable = function (variable, uri) {
            var query = uri.substring(uri.indexOf("?") + 1);
            var vars = query.split("&");
            for (var _i = 0, vars_1 = vars; _i < vars_1.length; _i++) {
                var v = vars_1[_i];
                var pair = v.split("=");
                if (decodeURIComponent(pair[0]) === variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
            console.log("Query variable %s not found", variable);
            return null;
        };
        return Helpers;
    }());
    exports.Helpers = Helpers;
    /**
     * Ensures events are queued during replay events and processed immediately afterwards.
     * */
    var InstantEventQueue = /** @class */ (function () {
        function InstantEventQueue(cb, useQueue, eventNotifications) {
            this.eventNotifications = eventNotifications;
            this._events = [];
            this.CB = cb;
            this._useQueue = useQueue;
        }
        InstantEventQueue.prototype.Dispose = function () {
            this._events = null;
            this.eventNotifications = null;
            this.CB = null;
        };
        InstantEventQueue.prototype.ProcessQueue = function () {
            return __awaiter(this, void 0, void 0, function () {
                var ev;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this._events) {
                                return [2 /*return*/];
                            }
                            this._events.sort(this.EventSorter);
                            ev = this._events.shift();
                            _a.label = 1;
                        case 1:
                            if (!(ev != null)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.CallCB(ev)];
                        case 2:
                            _a.sent();
                            ev = this._events.shift();
                            return [3 /*break*/, 1];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        InstantEventQueue.prototype.CallCB = function (ev) {
            return __awaiter(this, void 0, void 0, function () {
                var e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.CB(ev)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            e_2 = _a.sent();
                            throw e_2;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**Queues the event if needed */
        InstantEventQueue.prototype.Enqueue = function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var e;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!this._useQueue) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.CallCB(event)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            if (event instanceof ForAllShared_1.Events.ReplayEventStarted) {
                                this._replayEnded = false;
                            }
                            if (!this._replayEnded) return [3 /*break*/, 7];
                            if (!this._processingEvent) return [3 /*break*/, 3];
                            this._events.push(event);
                            return [3 /*break*/, 6];
                        case 3:
                            this._processingEvent = true;
                            return [4 /*yield*/, this.CallCB(event)];
                        case 4:
                            _a.sent();
                            return [4 /*yield*/, this.ProcessQueue()];
                        case 5:
                            _a.sent();
                            this._processingEvent = false;
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                        case 7:
                            if (!(event instanceof ForAllShared_1.Events.AuctionJoinedEvent || event instanceof ForAllShared_1.Events.FailOverEvent || event instanceof ForAllShared_1.Events.SelectedUsersEvent || event instanceof ForAllShared_1.Events.LeaveAuctionConfirmationEvent)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.CallCB(event)];
                        case 8:
                            _a.sent();
                            return [2 /*return*/];
                        case 9:
                            if (!(event instanceof ForAllShared_1.Events.ReplayEventStarted)) return [3 /*break*/, 11];
                            this.eventNotifications.ReplayStarted(event.InternalAuctionId);
                            return [4 /*yield*/, this.CallCB(event)];
                        case 10:
                            _a.sent();
                            return [2 /*return*/];
                        case 11:
                            if (!(event instanceof ForAllShared_1.Events.ReplayEventEnded)) return [3 /*break*/, 13];
                            this.eventNotifications.ReplayEnded(event.InternalAuctionId);
                            this._processingEvent = true;
                            this._replayEnded = true;
                            this._events.push(event);
                            this.eventNotifications.ProcessingEventsQueue(event.InternalAuctionId);
                            return [4 /*yield*/, this.ProcessQueue()];
                        case 12:
                            _a.sent();
                            this.eventNotifications.ProcessedEventsQueue(event.InternalAuctionId);
                            this._processingEvent = false;
                            return [2 /*return*/];
                        case 13:
                            if (event instanceof ForAllShared_1.Shared.InternalReplayedEventsBatch) {
                                e = event;
                                e.Events.forEach(function (p) { return _this._events.push(p); });
                            }
                            else {
                                this._events.push(event);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        InstantEventQueue.prototype.EventSorter = function (a, b) {
            if (a instanceof ForAllShared_1.Events.ReplayEventEnded) {
                return 1;
            }
            else if (b instanceof ForAllShared_1.Events.ReplayEventEnded)
                return -1;
            if (a.Order > b.Order)
                return 1;
            else if (a.Order < b.Order)
                return -1;
            else
                return 0;
        };
        return InstantEventQueue;
    }());
    exports.InstantEventQueue = InstantEventQueue;
    var AuctionChannelNotifications = /** @class */ (function () {
        function AuctionChannelNotifications(auctionId) {
            this.auctionId = auctionId;
        }
        AuctionChannelNotifications.prototype.Disconnected = function (channel) {
        };
        AuctionChannelNotifications.prototype.Slow = function (channel) {
        };
        AuctionChannelNotifications.prototype.Error = function (channel, msg) {
        };
        AuctionChannelNotifications.prototype.Reconnecting = function (channel) {
        };
        AuctionChannelNotifications.prototype.Connected = function (channel) {
        };
        AuctionChannelNotifications.prototype.Reconnected = function (channel) {
        };
        return AuctionChannelNotifications;
    }());
    exports.AuctionChannelNotifications = AuctionChannelNotifications;
    var ChannelNotifications = /** @class */ (function () {
        function ChannelNotifications() {
        }
        ChannelNotifications.prototype.Disconnected = function (channel) {
        };
        ChannelNotifications.prototype.Slow = function (channel) {
        };
        ChannelNotifications.prototype.Error = function (channel, msg) {
        };
        ChannelNotifications.prototype.Reconnecting = function (channel) {
        };
        ChannelNotifications.prototype.Connected = function (channel) {
        };
        ChannelNotifications.prototype.Reconnected = function (channel) {
        };
        return ChannelNotifications;
    }());
    exports.ChannelNotifications = ChannelNotifications;
    var BaseEngine = /** @class */ (function () {
        function BaseEngine(factory, logger, auctionRepo, eventNotifications, SessionKey) {
            if (SessionKey === void 0) { SessionKey = (new Date()).getTime().toString(); }
            this.factory = factory;
            this.logger = logger;
            this.auctionRepo = auctionRepo;
            this.eventNotifications = eventNotifications;
            this.SessionKey = SessionKey;
            this._eventProcessors = [];
            this._replayingEvents = false;
            this.IsStarted = false;
            factory.SetSessionKey(this.SessionKey);
        }
        BaseEngine.prototype.Ping = function (data) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._systemChannel.Ping(data)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/, ""];
                    }
                });
            });
        };
        BaseEngine.prototype.GetMappings = function () {
            return this._mappings;
        };
        BaseEngine.prototype.AddEventProcessor = function (eventProcessor) {
            this._eventProcessors.push(eventProcessor);
        };
        BaseEngine.prototype.RemoveEventProcessor = function (eventProcessor) {
            var i = this._eventProcessors.findIndex(function (v, i, ob) { return v === eventProcessor; });
            this._eventProcessors.splice(i, 1);
        };
        BaseEngine.prototype.IsReplayingEvents = function () {
            return this._replayingEvents;
        };
        BaseEngine.prototype.Start = function (uri, windowId) {
            return __awaiter(this, void 0, void 0, function () {
                var eventQueue, channelNotifications, _a;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this._mappings = {};
                            this.eventNotifications.LoggingInUser();
                            return [4 /*yield*/, this.CurrentRepository().LoginUser()];
                        case 1:
                            _b.sent();
                            this.eventNotifications.UserLoggedIn();
                            eventQueue = new InstantEventQueue(function (e) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.ProcessEvent(e, ForAllShared_1.Shared.Constants.SystemChannelName)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); }, false, this.eventNotifications);
                            channelNotifications = new ChannelNotifications();
                            this.eventNotifications.CreatingSystemChannel();
                            _a = this;
                            return [4 /*yield*/, this.factory.CreateSystemChannel(uri, eventQueue, this.logger, channelNotifications, windowId)];
                        case 2:
                            _a._systemChannel = _b.sent();
                            this.eventNotifications.SystemChannelCreated();
                            this.IsStarted = true;
                            console.log("ENGINE:Start:started");
                            return [2 /*return*/];
                    }
                });
            });
        };
        BaseEngine.prototype.Stop = function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b, _i, key;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = [];
                            for (_b in this._mappings)
                                _a.push(_b);
                            _i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            key = _a[_i];
                            return [4 /*yield*/, this._mappings[key].CommandProcessor.Stop()];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            this.eventNotifications.SystemChannelStopping();
                            return [4 /*yield*/, this._systemChannel.Stop()];
                        case 5:
                            _c.sent();
                            this.eventNotifications.SystemChannelStopped();
                            this._mappings = {};
                            this.IsStarted = false;
                            return [2 /*return*/];
                    }
                });
            });
        };
        BaseEngine.prototype.CreateCommand = function (c, internalAuctionId) {
            return new c(internalAuctionId);
        };
        BaseEngine.prototype.CreateItemCommand = function (c, internalAuctionId, internalItemId) {
            return new c(internalAuctionId, internalItemId);
        };
        BaseEngine.prototype.CreateItemCommandWithCurrentItem = function (c, internalAuctionId) {
            var auc = this.GetJoinedAuction(internalAuctionId);
            if (auc != null)
                return new c(internalAuctionId, auc.CurrentItemId);
        };
        BaseEngine.prototype.FireInternalCommand = function (command) {
            return __awaiter(this, void 0, void 0, function () {
                var internalCommandEvent;
                return __generator(this, function (_a) {
                    internalCommandEvent = new ForAllShared_1.Events.EventFromCommand(command.InternalAuctionId, "", -1, command);
                    this.ProcessEvent(internalCommandEvent, ForAllShared_1.Shared.Constants.InternalCommandEventChannelName);
                    return [2 /*return*/];
                });
            });
        };
        BaseEngine.prototype.FireCommand = function (command) {
            return __awaiter(this, void 0, void 0, function () {
                var map, e_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            map = this._mappings[command.InternalAuctionId];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, map.CommandProcessor.Process(command)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_3 = _a.sent();
                            throw e_3;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        BaseEngine.prototype.CurrentRepository = function () {
            return this.auctionRepo;
        };
        BaseEngine.prototype.CreateSignalRConnection = function (aucId, Url, notifications) {
            if (notifications === void 0) { notifications = null; }
            return __awaiter(this, void 0, void 0, function () {
                var eventQueue, auc, cp, e_4;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            eventQueue = function (useQueue) { return new InstantEventQueue(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.ProcessEvent(e, ForAllShared_1.Shared.Constants.AuctionChannelName)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, useQueue, _this.eventNotifications); };
                            if (notifications == null)
                                notifications = new AuctionChannelNotifications(aucId);
                            auc = this.CreateAuctionModifier(aucId);
                            cp = new CommandProcessor(this.factory, eventQueue, this.logger, auc, notifications, this.eventNotifications);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, cp.Start(Url)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_4 = _a.sent();
                            this.logger.LogError(aucId, "", "SignalR connection error ", e_4);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        ///Given a uri and auctionId join an auction
        // public JoinAuctionFromUri(uri: string, aucId: string, selectedUserRoles: Shared.ILiveUserRole[], checkforDuplicateLogIn: boolean, notifications: Shared.IChannelNotifications = null): Promise<void> {
        BaseEngine.prototype.JoinAuctionFromUri = function (uri, aucId, selectedUserRoles, notifications, isVehicleCentricFlag, isFromBidApi) {
            var _this = this;
            if (notifications === void 0) { notifications = null; }
            if (isVehicleCentricFlag === void 0) { isVehicleCentricFlag = false; }
            if (isFromBidApi === void 0) { isFromBidApi = false; }
            return new Promise(function (res, rej) { return __awaiter(_this, void 0, void 0, function () {
                var eventQueue, auc, cp, handle, join, e_5, e_6;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (uri == "") {
                                this.eventNotifications.AttendeeJoiningTimeIssue(aucId.toString());
                            }
                            this.logger.LogVerbose(aucId, "", "Joining Auction ", aucId.toString(), " at ", uri);
                            eventQueue = function (useQueue) { return new InstantEventQueue(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.ProcessEvent(e, ForAllShared_1.Shared.Constants.AuctionChannelName)];
                                        case 1:
                                            _a.sent();
                                            if (e instanceof ForAllShared_1.Events.AuctionJoinedEvent) {
                                                res();
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, useQueue, _this.eventNotifications); };
                            if (notifications == null)
                                notifications = new AuctionChannelNotifications(aucId);
                            auc = this.CreateAuctionModifier(aucId);
                            cp = new CommandProcessor(this.factory, eventQueue, this.logger, auc, notifications, this.eventNotifications);
                            if (this._mappings[aucId]) {
                                rej("Already joined auction, leave it first.");
                                return [2 /*return*/];
                            }
                            this._mappings[aucId] = new AuctionMapping(auc, cp, this.CreateEventProcessor(auc, this.logger, this.auctionRepo));
                            handle = this.logger.BeginEvent("Join ", aucId.toString());
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 10]);
                            return [4 /*yield*/, cp.Start(uri)];
                        case 2:
                            _a.sent();
                            this.eventNotifications.JoiningCommand(aucId.toString());
                            join = new ForAllShared_1.Shared.Commands.JoinCommand(auc.InternalAuctionId, isVehicleCentricFlag, isFromBidApi, selectedUserRoles);
                            //test
                            return [4 /*yield*/, this.FireCommand(join)];
                        case 3:
                            //test
                            _a.sent();
                            this.eventNotifications.FiredJoiningCommand(aucId.toString());
                            this.eventNotifications.SystemChannelJoining(aucId.toString());
                            return [4 /*yield*/, this._systemChannel.Process(join)];
                        case 4:
                            _a.sent();
                            this.eventNotifications.SystemChannelJoined(aucId.toString());
                            return [3 /*break*/, 10];
                        case 5:
                            e_5 = _a.sent();
                            this.eventNotifications.JoinError(aucId.toString(), e_5);
                            this.logger.LogError(aucId, "", "join auction command error ", e_5);
                            _a.label = 6;
                        case 6:
                            _a.trys.push([6, 8, , 9]);
                            return [4 /*yield*/, this.LeaveAuction(aucId)];
                        case 7:
                            _a.sent();
                            return [3 /*break*/, 9];
                        case 8:
                            e_6 = _a.sent();
                            return [3 /*break*/, 9];
                        case 9:
                            rej(e_5);
                            return [3 /*break*/, 10];
                        case 10:
                            this.logger.EndEvent(aucId, "", handle);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        BaseEngine.prototype.JoinAuctionAfterNewAPI = function (uri, aucId, selectedUserRoles, notifications) {
            var _this = this;
            return new Promise(function (res, rej) { return __awaiter(_this, void 0, void 0, function () {
                var eventQueue, auc, cp, handle, join, e_7, e_8;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose(aucId, "", "Joining After API Auction ", aucId.toString(), " at ", uri);
                            eventQueue = function (useQueue) { return new InstantEventQueue(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.ProcessEvent(e, ForAllShared_1.Shared.Constants.AuctionChannelName)];
                                        case 1:
                                            _a.sent();
                                            if (e instanceof ForAllShared_1.Events.AuctionJoinedEvent) {
                                                res();
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, useQueue, _this.eventNotifications); };
                            if (notifications == null)
                                notifications = new AuctionChannelNotifications(aucId);
                            auc = this.CreateAuctionModifier(aucId);
                            cp = new CommandProcessor(this.factory, eventQueue, this.logger, auc, notifications, this.eventNotifications);
                            if (this._mappings[aucId]) {
                                rej("Already joined auction, leave it first.");
                                return [2 /*return*/];
                            }
                            this._mappings[aucId] = new AuctionMapping(auc, cp, this.CreateEventProcessor(auc, this.logger, this.auctionRepo));
                            handle = this.logger.BeginEvent("Join ", aucId.toString());
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 10]);
                            return [4 /*yield*/, cp.Start(uri)];
                        case 2:
                            _a.sent();
                            this.eventNotifications.JoiningCommand(aucId.toString());
                            join = new ForAllShared_1.Shared.Commands.JoinAfterAPICommand(auc.InternalAuctionId, selectedUserRoles);
                            return [4 /*yield*/, this.FireCommand(join)];
                        case 3:
                            _a.sent();
                            this.eventNotifications.FiredJoiningCommand(aucId.toString());
                            this.eventNotifications.SystemChannelJoining(aucId.toString());
                            return [4 /*yield*/, this._systemChannel.Process(join)];
                        case 4:
                            _a.sent();
                            this.eventNotifications.SystemChannelJoined(aucId.toString());
                            return [3 /*break*/, 10];
                        case 5:
                            e_7 = _a.sent();
                            this.eventNotifications.JoinError(aucId.toString(), e_7);
                            this.logger.LogError(aucId, "", "join auction command error ", e_7);
                            _a.label = 6;
                        case 6:
                            _a.trys.push([6, 8, , 9]);
                            return [4 /*yield*/, this.LeaveAuction(aucId)];
                        case 7:
                            _a.sent();
                            return [3 /*break*/, 9];
                        case 8:
                            e_8 = _a.sent();
                            return [3 /*break*/, 9];
                        case 9:
                            rej(e_7);
                            return [3 /*break*/, 10];
                        case 10:
                            this.logger.EndEvent(aucId, "", handle);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        BaseEngine.prototype.LeaveAuction = function (aucId) {
            return __awaiter(this, void 0, void 0, function () {
                var handle, leave, e_9, mapping;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose(aucId, "", "Leaving Auction ", aucId.toString());
                            handle = this.logger.BeginEvent("Leaving ", aucId);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, 5, 7]);
                            leave = new ForAllShared_1.Shared.Commands.LeaveCommand(aucId);
                            return [4 /*yield*/, this.FireCommand(leave)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, this._systemChannel.Process(leave)];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 7];
                        case 4:
                            e_9 = _a.sent();
                            this.logger.LogError(aucId, "", "join auction command error ", e_9);
                            return [3 /*break*/, 7];
                        case 5:
                            mapping = this._mappings[aucId];
                            return [4 /*yield*/, mapping.Dispose()];
                        case 6:
                            _a.sent();
                            delete this._mappings[aucId];
                            return [7 /*endfinally*/];
                        case 7:
                            this.logger.EndEvent(aucId, "", handle);
                            return [2 /*return*/];
                    }
                });
            });
        };
        BaseEngine.prototype.KickDuplicateUser = function (aucId) {
            return __awaiter(this, void 0, void 0, function () {
                var handle, kickDuplicateUser, e_10, mapping;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose(aucId, "", "KickDuplicateUser Auction ", aucId.toString());
                            handle = this.logger.BeginEvent("KickDuplicateUser ", aucId);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, 5, 7]);
                            kickDuplicateUser = new ForAllShared_1.Shared.Commands.KickDuplicateUserCommand(aucId);
                            return [4 /*yield*/, this.FireCommand(kickDuplicateUser)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, this._systemChannel.Process(kickDuplicateUser)];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 7];
                        case 4:
                            e_10 = _a.sent();
                            this.logger.LogError(aucId, "", "KickDuplicateUser auction command error ", e_10);
                            return [3 /*break*/, 7];
                        case 5:
                            mapping = this._mappings[aucId];
                            return [4 /*yield*/, mapping.Dispose()];
                        case 6:
                            _a.sent();
                            delete this._mappings[aucId];
                            return [7 /*endfinally*/];
                        case 7:
                            this.logger.EndEvent(aucId, "", handle);
                            return [2 /*return*/];
                    }
                });
            });
        };
        //kick Duplicate User Test Function
        BaseEngine.prototype.KickDuplicateUserTest = function (aucId) {
            return __awaiter(this, void 0, void 0, function () {
                var handle, uri, kickDuplicateUser, e_11, mapping;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose(aucId, "", "KickDuplicateUserTest Auction ", aucId.toString());
                            handle = this.logger.BeginEvent("KickDuplicateUserTest ", aucId);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 7, 8, 10]);
                            return [4 /*yield*/, this.auctionRepo.GetUriForLive(aucId, false)];
                        case 2:
                            uri = _a.sent();
                            return [4 /*yield*/, this.CreateSignalRConnection(aucId, uri)];
                        case 3:
                            _a.sent();
                            kickDuplicateUser = new ForAllShared_1.Shared.Commands.KickDuplicateUserCommand(aucId);
                            return [4 /*yield*/, this.FireCommand(kickDuplicateUser)];
                        case 4:
                            _a.sent();
                            return [4 /*yield*/, this._systemChannel.Process(kickDuplicateUser)];
                        case 5:
                            _a.sent();
                            return [4 /*yield*/, this.JoinAuction(aucId, null, null, false)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 10];
                        case 7:
                            e_11 = _a.sent();
                            this.logger.LogError(aucId, "", "KickDuplicateUser command error ", e_11);
                            return [3 /*break*/, 10];
                        case 8:
                            mapping = this._mappings[aucId];
                            return [4 /*yield*/, mapping.Dispose()];
                        case 9:
                            _a.sent();
                            delete this._mappings[aucId];
                            return [7 /*endfinally*/];
                        case 10:
                            this.logger.EndEvent(aucId, "", handle);
                            return [2 /*return*/];
                    }
                });
            });
        };
        BaseEngine.prototype.KickGuestUser = function (aucId) {
            return __awaiter(this, void 0, void 0, function () {
                var handle, KickGuestUser, e_12, mapping;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose(aucId, "", "KickGuestUser Auction ", aucId.toString());
                            handle = this.logger.BeginEvent("KickGuestUser ", aucId);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, 5, 7]);
                            KickGuestUser = new ForAllShared_1.Shared.Commands.KickGuestUserCommand(aucId);
                            return [4 /*yield*/, this.FireCommand(KickGuestUser)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, this._systemChannel.Process(KickGuestUser)];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 7];
                        case 4:
                            e_12 = _a.sent();
                            this.logger.LogError(aucId, "", "KickGuestUser auction command error ", e_12);
                            return [3 /*break*/, 7];
                        case 5:
                            mapping = this._mappings[aucId];
                            return [4 /*yield*/, mapping.Dispose()];
                        case 6:
                            _a.sent();
                            delete this._mappings[aucId];
                            return [7 /*endfinally*/];
                        case 7:
                            this.logger.EndEvent(aucId, "", handle);
                            return [2 /*return*/];
                    }
                });
            });
        };
        ///Given a tenant and auctionId join an auction
        // public async JoinAuctionUsingExternalInfo(tenant: string, aucId: string, checkforDuplicateLogIn:boolean, notifications: Shared.IChannelNotifications = null): Promise<string> {
        BaseEngine.prototype.JoinAuctionUsingExternalInfo = function (tenant, aucId, notifications, isVehicleCentricFlag, isFromBidApi) {
            if (notifications === void 0) { notifications = null; }
            if (isVehicleCentricFlag === void 0) { isVehicleCentricFlag = false; }
            if (isFromBidApi === void 0) { isFromBidApi = false; }
            return __awaiter(this, void 0, void 0, function () {
                var lookup;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose("Get Uri ", aucId.toString());
                            return [4 /*yield*/, this.auctionRepo.GetInternalInformationUsingExternal(tenant, aucId, isFromBidApi)];
                        case 1:
                            lookup = _a.sent();
                            console.log("ENGINE:lookup", lookup);
                            return [4 /*yield*/, this.JoinAuctionFromUri(lookup.Uri, lookup.InternalAuctionId, null, notifications, isVehicleCentricFlag, isFromBidApi)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, lookup.InternalAuctionId];
                    }
                });
            });
        };
        ///Given a tenant and auctionId join an auction
        // public async JoinAuction(aucId: string, selectedUserRoles: Shared.ILiveUserRole[], checkforDuplicateLogIn: boolean,notifications: Shared.IChannelNotifications = null): Promise<void> {
        BaseEngine.prototype.JoinAuction = function (aucId, selectedUserRoles, notifications, isVehicleCentricFlag, isFromBidApi) {
            if (notifications === void 0) { notifications = null; }
            if (isVehicleCentricFlag === void 0) { isVehicleCentricFlag = false; }
            if (isFromBidApi === void 0) { isFromBidApi = false; }
            return __awaiter(this, void 0, void 0, function () {
                var uri;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose("Get Uri ", aucId.toString());
                            return [4 /*yield*/, this.auctionRepo.GetUriForLive(aucId, isFromBidApi)];
                        case 1:
                            uri = _a.sent();
                            return [2 /*return*/, this.JoinAuctionFromUri(uri, aucId, selectedUserRoles, notifications, isVehicleCentricFlag, isFromBidApi)];
                    }
                });
            });
        };
        BaseEngine.prototype.JoinAuctionWithAPI = function (aucId, userId, selectedUserRoles, notifications) {
            if (notifications === void 0) { notifications = null; }
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.LogVerbose("Get Uri ", aucId.toString());
                            return [4 /*yield*/, this.auctionRepo.GetJoinApiResponse(aucId, userId, this.SessionKey)];
                        case 1:
                            res = _a.sent();
                            if (res.StatusCode == 200) {
                                this.JoinAuctionAfterNewAPI(res.AuctionUri, aucId, selectedUserRoles, notifications);
                                return [2 /*return*/, res];
                            }
                            else {
                                return [2 /*return*/, res];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        Object.defineProperty(BaseEngine.prototype, "JoinedAuctions", {
            get: function () {
                var aucs = [];
                for (var o in this._mappings) {
                    aucs.push(this._mappings[o].JoinedAuction);
                }
                return aucs;
            },
            enumerable: false,
            configurable: true
        });
        BaseEngine.prototype.GetJoinedAuction = function (auctionId) {
            var auc = this._mappings[auctionId];
            if (auc) {
                return auc.JoinedAuction;
            }
            return null;
        };
        BaseEngine.prototype.ProcessEvent = function (event, channelName) {
            return __awaiter(this, void 0, void 0, function () {
                var cookies, i, spcook, cookies, i, spcook, map, aje, fail_1, aje, e_13, _i, _a, i_1, e_14;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(event instanceof ForAllShared_1.Events.UserBannedEvent)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.Stop()];
                        case 1:
                            _b.sent();
                            cookies = document.cookie.split(";");
                            for (i = 0; i < cookies.length; i++) {
                                spcook = cookies[i].split("=");
                                document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1900 00:00:01 UTC;";
                            }
                            window.location.reload(true);
                            return [3 /*break*/, 4];
                        case 2:
                            if (!(event instanceof ForAllShared_1.Events.UserKickedEvent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.Stop()];
                        case 3:
                            _b.sent();
                            cookies = document.cookie.split(";");
                            for (i = 0; i < cookies.length; i++) {
                                spcook = cookies[i].split("=");
                                document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1900 00:00:01 UTC;";
                            }
                            _b.label = 4;
                        case 4:
                            map = this._mappings[event.InternalAuctionId];
                            if (!(map != null)) return [3 /*break*/, 17];
                            if (!(event instanceof ForAllShared_1.Events.AuctionJoinedEvent)) return [3 /*break*/, 6];
                            aje = event;
                            this.auctionRepo.SetAuctionSessionToken(aje.InternalAuctionId, aje.AuctionSession);
                            this.auctionRepo.SetItemSessionToken(aje.InternalAuctionId, aje.ItemSession);
                            return [4 /*yield*/, map.InternalEventProcessor.Process(event, "")];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 13];
                        case 6:
                            if (!(event instanceof ForAllShared_1.Events.FailOverEvent)) return [3 /*break*/, 7];
                            fail_1 = event;
                            map.CommandProcessor.FailoverTo(fail_1.Uri);
                            return [2 /*return*/];
                        case 7:
                            if (!(event instanceof ForAllShared_1.Events.ReplayEventStarted)) return [3 /*break*/, 8];
                            this._replayingEvents = true;
                            return [3 /*break*/, 13];
                        case 8:
                            if (!(event instanceof ForAllShared_1.Events.ReplayEventEnded)) return [3 /*break*/, 9];
                            this._replayingEvents = false;
                            return [3 /*break*/, 13];
                        case 9:
                            if (!(event instanceof ForAllShared_1.Events.SelectedUsersEvent)) return [3 /*break*/, 11];
                            aje = event;
                            this._systemChannel.CreateGroupsForRoles(aje.LiveUserRoles.map(function (a) { return a.RoleId; }));
                            return [4 /*yield*/, map.InternalEventProcessor.Process(event, "")];
                        case 10:
                            _b.sent();
                            return [3 /*break*/, 13];
                        case 11: return [4 /*yield*/, map.InternalEventProcessor.Process(event, "")];
                        case 12:
                            _b.sent();
                            _b.label = 13;
                        case 13:
                            _b.trys.push([13, 15, 16, 17]);
                            return [4 /*yield*/, map.JoinedAuction.Process(event, channelName)];
                        case 14:
                            _b.sent();
                            return [3 /*break*/, 17];
                        case 15:
                            e_13 = _b.sent();
                            this.logger.LogError(event.InternalAuctionId, "", e_13);
                            return [3 /*break*/, 17];
                        case 16: return [7 /*endfinally*/];
                        case 17:
                            _i = 0, _a = this._eventProcessors;
                            _b.label = 18;
                        case 18:
                            if (!(_i < _a.length)) return [3 /*break*/, 24];
                            i_1 = _a[_i];
                            _b.label = 19;
                        case 19:
                            _b.trys.push([19, 21, 22, 23]);
                            return [4 /*yield*/, i_1.Process(event, channelName)];
                        case 20:
                            _b.sent();
                            return [3 /*break*/, 23];
                        case 21:
                            e_14 = _b.sent();
                            this.logger.LogError(event.InternalAuctionId, "", "Exception when using " + i_1.EventProcessorName + " \r\n " + e_14);
                            return [3 /*break*/, 23];
                        case 22: return [7 /*endfinally*/];
                        case 23:
                            _i++;
                            return [3 /*break*/, 18];
                        case 24: return [2 /*return*/];
                    }
                });
            });
        };
        return BaseEngine;
    }());
    exports.BaseEngine = BaseEngine;
    var BaseInternalEventProcessor = /** @class */ (function () {
        function BaseInternalEventProcessor(Auction, logger, repo, fireCommandService) {
            this.Auction = Auction;
            this.logger = logger;
            this.repo = repo;
            this.fireCommandService = fireCommandService;
            this._replayInProgress = false;
            this.EventProcessorName = "BaseInternalEventProcessor";
        }
        BaseInternalEventProcessor.prototype.Process = function (event, channelName) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (event instanceof ForAllShared_1.Events.ReplayEventStarted) {
                        this._replayInProgress = true;
                    }
                    if (event instanceof ForAllShared_1.Events.ReplayEventEnded) {
                        this._replayInProgress = false;
                    }
                    if (event instanceof ForAllShared_1.Events.AuctionJoinedEvent) {
                        this.Auction.SetItems(event.Items);
                    }
                    else if (event instanceof ForAllShared_1.Events.NavigatedToEvent) {
                        this.Auction.SetCurrentItem(event.InternalAuctionItemId);
                    }
                    else if (event instanceof ForAllShared_1.Events.SequenceNumberChangedEvent) {
                        this.Auction.ChangeSequences(event.Changes);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemsModifiedEvent) {
                        this.repo.SetItemSessionToken(event.InternalAuctionId, event.ItemSession);
                        this.Auction.ReloadItems(event.ItemsAdded, event.RemovedItemIds);
                    }
                    else if (event instanceof ForAllShared_1.Events.AskingAmountSetEvent) {
                        if (this.ShouldReplayCheck(event.InternalAuctionItemId)) {
                            return [2 /*return*/];
                        }
                        this.Auction.SetAskingAmount(event.Amount, event.JumpAmounts);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemIfBidEvent) {
                        this.Auction.SetIfBid(event.InternalAuctionItemId, event.BidderId, event.Amount);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemSoldEvent) {
                        this.Auction.SetSold(event.InternalAuctionItemId, event.BidderId, event.Amount);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemPassEvent) {
                        this.Auction.SetPassed(event.InternalAuctionItemId);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemReRunEvent) {
                        this.Auction.SetReRun(event.InternalAuctionItemId, event.BidderId, event.Amount);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemNoBidEvent) {
                        this.Auction.SetNoBid(event.InternalAuctionItemId);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemPulledEvent) {
                        this.Auction.SetPulled(event.InternalAuctionItemId);
                    }
                    else if (event instanceof ForAllShared_1.Events.BidAcceptedEvent) {
                        if (this.ShouldReplayCheck(event.InternalAuctionItemId)) {
                            return [2 /*return*/];
                        }
                        this.Auction.SetHighInformation(event.InternalAuctionItemId, event.BidderId, event.Display, event.Amount);
                    }
                    else if (event instanceof ForAllShared_1.Events.OverruledEvent) {
                        if (this.ShouldReplayCheck(event.InternalAuctionItemId)) {
                            return [2 /*return*/];
                        }
                        this.Auction.SetHighInformation(event.InternalAuctionItemId, event.NewBidderId, event.NewDisplay, event.NewAmount);
                    }
                    else if (event instanceof ForAllShared_1.Events.RetractedEvent) {
                        if (this.ShouldReplayCheck(event.InternalAuctionItemId)) {
                            return [2 /*return*/];
                        }
                        this.Auction.SetHighInformation(event.InternalAuctionItemId, event.NewBidderId, event.NewDisplay, event.NewAmount);
                    }
                    else if (event instanceof ForAllShared_1.Events.ItemResetEvent) {
                        if (this.ShouldReplayCheck(event.InternalAuctionItemId)) {
                            return [2 /*return*/];
                        }
                        this.Auction.SetHighInformation(event.InternalAuctionItemId, "", "", 0);
                    }
                    return [2 /*return*/];
                });
            });
        };
        BaseInternalEventProcessor.prototype.ShouldReplayCheck = function (internalAuctionItemId) {
            if (this._replayInProgress)
                return false;
            if (internalAuctionItemId != this.Auction.CurrentItemId) {
                this._replayInProgress = true;
                this.fireCommandService.FireCommand(new ForAllShared_1.Shared.Commands.ReplayFromCommand(this.Auction.InternalAuctionId));
                return true;
            }
            return false;
        };
        return BaseInternalEventProcessor;
    }());
    exports.BaseInternalEventProcessor = BaseInternalEventProcessor;
});
},{"./ForAllShared":34}],33:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./Shared"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Events = void 0;
    var Shared_1 = require("./Shared");
    var Events;
    (function (Events_1) {
        var ReplayEventStarted = /** @class */ (function (_super) {
            __extends(ReplayEventStarted, _super);
            function ReplayEventStarted() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ReplayEventStarted;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReplayEventStarted = ReplayEventStarted;
        var ReplayEventEnded = /** @class */ (function (_super) {
            __extends(ReplayEventEnded, _super);
            function ReplayEventEnded() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ReplayEventEnded;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReplayEventEnded = ReplayEventEnded;
        var AuctionAttendeeCountEvent = /** @class */ (function (_super) {
            __extends(AuctionAttendeeCountEvent, _super);
            function AuctionAttendeeCountEvent(internalAuctionId, internalAuctionItemId, order, Bidders, Sellers, Clerks) {
                var _this = _super.call(this, "", internalAuctionId, "", order) || this;
                _this.Bidders = Bidders;
                _this.Sellers = Sellers;
                _this.Clerks = Clerks;
                return _this;
            }
            return AuctionAttendeeCountEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionAttendeeCountEvent = AuctionAttendeeCountEvent;
        var WatchListSequenceUpdateEvent = /** @class */ (function (_super) {
            __extends(WatchListSequenceUpdateEvent, _super);
            function WatchListSequenceUpdateEvent(internalAuctionId, internalAuctionItemId, order, WatchList) {
                var _this = _super.call(this, "WatchListSequenceUpdateEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.WatchList = WatchList;
                return _this;
            }
            return WatchListSequenceUpdateEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.WatchListSequenceUpdateEvent = WatchListSequenceUpdateEvent;
        var WatchListUserItemsAwayEvent = /** @class */ (function (_super) {
            __extends(WatchListUserItemsAwayEvent, _super);
            function WatchListUserItemsAwayEvent(internalAuctionId, internalAuctionItemId, order, WatchList) {
                var _this = _super.call(this, "WatchListUserItemsAwayEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.WatchList = WatchList;
                return _this;
            }
            return WatchListUserItemsAwayEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.WatchListUserItemsAwayEvent = WatchListUserItemsAwayEvent;
        var AuctionStatisticsEvent = /** @class */ (function (_super) {
            __extends(AuctionStatisticsEvent, _super);
            function AuctionStatisticsEvent(internalAuctionId, internalAuctionItemId, order, ItemsSold, ItemsPulled, ItemsIfBid, ItemsNoBid, ItemsReRun, ItemsPassed, AverageTimeOnBlock) {
                var _this = _super.call(this, "AuctionStatisticsEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.ItemsSold = ItemsSold;
                _this.ItemsPulled = ItemsPulled;
                _this.ItemsIfBid = ItemsIfBid;
                _this.ItemsNoBid = ItemsNoBid;
                _this.ItemsReRun = ItemsReRun;
                _this.ItemsPassed = ItemsPassed;
                _this.AverageTimeOnBlock = AverageTimeOnBlock;
                return _this;
            }
            return AuctionStatisticsEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionStatisticsEvent = AuctionStatisticsEvent;
        var AutoBidValidationEvent = /** @class */ (function (_super) {
            __extends(AutoBidValidationEvent, _super);
            function AutoBidValidationEvent(auctionId, itemId, order, Amount) {
                var _this = _super.call(this, "AutoBidValidationEvent", auctionId, itemId, order) || this;
                _this.Amount = Amount;
                return _this;
            }
            return AutoBidValidationEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AutoBidValidationEvent = AutoBidValidationEvent;
        var FailOverEvent = /** @class */ (function (_super) {
            __extends(FailOverEvent, _super);
            function FailOverEvent(internalAuctionId, internalAuctionItemId, order, Uri) {
                var _this = _super.call(this, "FailOverEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.Uri = Uri;
                return _this;
            }
            return FailOverEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.FailOverEvent = FailOverEvent;
        var SecurityChangedEvent = /** @class */ (function (_super) {
            __extends(SecurityChangedEvent, _super);
            function SecurityChangedEvent(internalAuctionId, internalAuctionItemId, order, Items) {
                var _this = _super.call(this, "SecurityChangedEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.Items = Items;
                return _this;
            }
            return SecurityChangedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.SecurityChangedEvent = SecurityChangedEvent;
        var AuctionJoinedEvent = /** @class */ (function (_super) {
            __extends(AuctionJoinedEvent, _super);
            function AuctionJoinedEvent(internalAuctionId, internalAuctionItemId, order, AuctionSession, ItemSession, Items, UserRole) {
                var _this = _super.call(this, "AuctionJoinedEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.AuctionSession = AuctionSession;
                _this.ItemSession = ItemSession;
                _this.Items = Items;
                _this.UserRole = UserRole;
                return _this;
            }
            return AuctionJoinedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionJoinedEvent = AuctionJoinedEvent;
        var BiddingActivatedEvent = /** @class */ (function (_super) {
            __extends(BiddingActivatedEvent, _super);
            function BiddingActivatedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return BiddingActivatedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BiddingActivatedEvent = BiddingActivatedEvent;
        var AutoBidModifiedEvent = /** @class */ (function (_super) {
            __extends(AutoBidModifiedEvent, _super);
            function AutoBidModifiedEvent(auctionId, itemId, order, Amount, BidderId, CurrentHighBidAmount) {
                var _this = _super.call(this, "AutoBidModifiedEvent", auctionId, itemId, order) || this;
                _this.Amount = Amount;
                _this.BidderId = BidderId;
                _this.CurrentHighBidAmount = CurrentHighBidAmount;
                return _this;
            }
            return AutoBidModifiedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AutoBidModifiedEvent = AutoBidModifiedEvent;
        var AutoBidPlacedEvent = /** @class */ (function (_super) {
            __extends(AutoBidPlacedEvent, _super);
            function AutoBidPlacedEvent(auctionId, itemId, order, Amount, BidderId, CurrentHighBidAmount) {
                var _this = _super.call(this, "AutoBidPlacedEvent", auctionId, itemId, order) || this;
                _this.Amount = Amount;
                _this.BidderId = BidderId;
                _this.CurrentHighBidAmount = CurrentHighBidAmount;
                return _this;
            }
            return AutoBidPlacedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AutoBidPlacedEvent = AutoBidPlacedEvent;
        var HighAutoBidEvent = /** @class */ (function (_super) {
            __extends(HighAutoBidEvent, _super);
            function HighAutoBidEvent(internalAuctionId, internalAuctionItemId, order, WinningBidderId, CurrentHighBidAmount) {
                var _this = _super.call(this, "HighAutoBidEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.WinningBidderId = WinningBidderId;
                _this.CurrentHighBidAmount = CurrentHighBidAmount;
                return _this;
            }
            return HighAutoBidEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.HighAutoBidEvent = HighAutoBidEvent;
        var GuaranteedSaleEvent = /** @class */ (function (_super) {
            __extends(GuaranteedSaleEvent, _super);
            function GuaranteedSaleEvent(internalAuctionId, internalAuctionItemId, order, ReserveOffFlag) {
                var _this = _super.call(this, "GuaranteedSaleEvent", internalAuctionId, internalAuctionItemId, order) || this;
                _this.ReserveOffFlag = ReserveOffFlag;
                return _this;
            }
            return GuaranteedSaleEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.GuaranteedSaleEvent = GuaranteedSaleEvent;
        var UserBannedEvent = /** @class */ (function (_super) {
            __extends(UserBannedEvent, _super);
            function UserBannedEvent(order, UserId) {
                var _this = _super.call(this, "UserBannedEvent", "NONE", "", order) || this;
                _this.UserId = UserId;
                return _this;
            }
            return UserBannedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.UserBannedEvent = UserBannedEvent;
        var UserKickedEvent = /** @class */ (function (_super) {
            __extends(UserKickedEvent, _super);
            function UserKickedEvent(order, UserId, Code) {
                var _this = _super.call(this, "UserKickedEvent", "NONE", "", order) || this;
                _this.UserId = UserId;
                _this.Code = Code;
                return _this;
            }
            return UserKickedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.UserKickedEvent = UserKickedEvent;
        var UserSuspendEvent = /** @class */ (function (_super) {
            __extends(UserSuspendEvent, _super);
            function UserSuspendEvent(order, UserId, Tenants) {
                var _this = _super.call(this, "UserSuspendEvent", "NONE", "", order) || this;
                _this.UserId = UserId;
                _this.Tenants = Tenants;
                return _this;
            }
            return UserSuspendEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.UserSuspendEvent = UserSuspendEvent;
        var LeaveVCBEvent = /** @class */ (function (_super) {
            __extends(LeaveVCBEvent, _super);
            function LeaveVCBEvent(order, User, SessionKey) {
                var _this = _super.call(this, "LeaveVCBEvent", "NONE", "", order) || this;
                _this.User = User;
                _this.SessionKey = SessionKey;
                return _this;
            }
            return LeaveVCBEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.LeaveVCBEvent = LeaveVCBEvent;
        var GlobalMessageModifiedEvent = /** @class */ (function (_super) {
            __extends(GlobalMessageModifiedEvent, _super);
            function GlobalMessageModifiedEvent(order, UserId, Message, Tenant) {
                var _this = _super.call(this, "GlobalMessageModifiedEvent", "NONE", "", order) || this;
                _this.UserId = UserId;
                _this.Message = Message;
                _this.Tenant = Tenant;
                return _this;
            }
            return GlobalMessageModifiedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.GlobalMessageModifiedEvent = GlobalMessageModifiedEvent;
        var GlobalMessageRemovedEvent = /** @class */ (function (_super) {
            __extends(GlobalMessageRemovedEvent, _super);
            function GlobalMessageRemovedEvent(order, UserId, Message, Tenant) {
                var _this = _super.call(this, "GlobalMessageRemovedEvent", "NONE", "", order) || this;
                _this.UserId = UserId;
                _this.Message = Message;
                _this.Tenant = Tenant;
                return _this;
            }
            return GlobalMessageRemovedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.GlobalMessageRemovedEvent = GlobalMessageRemovedEvent;
        var HideWinningBidSaleEvent = /** @class */ (function (_super) {
            __extends(HideWinningBidSaleEvent, _super);
            function HideWinningBidSaleEvent(order, HideWinningBidAmount, Tenant) {
                var _this = _super.call(this, "HideWinningBidSaleEvent", "NONE", "", order) || this;
                _this.HideWinningBidAmount = HideWinningBidAmount;
                _this.Tenant = Tenant;
                return _this;
            }
            return HideWinningBidSaleEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.HideWinningBidSaleEvent = HideWinningBidSaleEvent;
        var AutoBidRemovedEvent = /** @class */ (function (_super) {
            __extends(AutoBidRemovedEvent, _super);
            function AutoBidRemovedEvent(auctionId, itemId, order, BidderId) {
                var _this = _super.call(this, "AutoBidRemovedEvent", auctionId, itemId, order) || this;
                _this.BidderId = BidderId;
                return _this;
            }
            return AutoBidRemovedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AutoBidRemovedEvent = AutoBidRemovedEvent;
        var NotesAddedEvent = /** @class */ (function (_super) {
            __extends(NotesAddedEvent, _super);
            function NotesAddedEvent(auctionId, itemId, order, Message) {
                var _this = _super.call(this, "NotesAddedEvent", auctionId, itemId, order) || this;
                _this.Message = Message;
                return _this;
            }
            return NotesAddedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NotesAddedEvent = NotesAddedEvent;
        var ConsignorNotesAddedEvent = /** @class */ (function (_super) {
            __extends(ConsignorNotesAddedEvent, _super);
            function ConsignorNotesAddedEvent(auctionId, itemId, order, Message) {
                var _this = _super.call(this, "ConsignorNotesAddedEvent", auctionId, itemId, order) || this;
                _this.Message = Message;
                return _this;
            }
            return ConsignorNotesAddedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ConsignorNotesAddedEvent = ConsignorNotesAddedEvent;
        var ReservePriceRemovedEvent = /** @class */ (function (_super) {
            __extends(ReservePriceRemovedEvent, _super);
            function ReservePriceRemovedEvent(auctionId, itemId, order, IsDisplay) {
                var _this = _super.call(this, "ReservePriceRemovedEvent", auctionId, itemId, order) || this;
                _this.IsDisplay = IsDisplay;
                return _this;
            }
            return ReservePriceRemovedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReservePriceRemovedEvent = ReservePriceRemovedEvent;
        var OfferAllowedEvent = /** @class */ (function (_super) {
            __extends(OfferAllowedEvent, _super);
            function OfferAllowedEvent(auctionId, itemId, order) {
                return _super.call(this, "OfferAllowedEvent", auctionId, itemId, order) || this;
            }
            return OfferAllowedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.OfferAllowedEvent = OfferAllowedEvent;
        var NoNegotiationNeededEvent = /** @class */ (function (_super) {
            __extends(NoNegotiationNeededEvent, _super);
            function NoNegotiationNeededEvent(auctionId, itemId, order) {
                return _super.call(this, "NoNegotiationNeededEvent", auctionId, itemId, order) || this;
            }
            return NoNegotiationNeededEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NoNegotiationNeededEvent = NoNegotiationNeededEvent;
        var SellerReppingOnlineEvent = /** @class */ (function (_super) {
            __extends(SellerReppingOnlineEvent, _super);
            function SellerReppingOnlineEvent(auctionId, itemId, order, IsRepped) {
                var _this = _super.call(this, "SellerReppingOnlineEvent", auctionId, itemId, order) || this;
                _this.IsRepped = IsRepped;
                return _this;
            }
            return SellerReppingOnlineEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.SellerReppingOnlineEvent = SellerReppingOnlineEvent;
        var ReserveTogglePreBlockEvent = /** @class */ (function (_super) {
            __extends(ReserveTogglePreBlockEvent, _super);
            function ReserveTogglePreBlockEvent(auctionId, itemId, order, IsRemoved) {
                var _this = _super.call(this, "ReserveTogglePreBlockEvent", auctionId, itemId, order) || this;
                _this.IsRemoved = IsRemoved;
                return _this;
            }
            return ReserveTogglePreBlockEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReserveTogglePreBlockEvent = ReserveTogglePreBlockEvent;
        var ReppingOnlineForCurrentItemEvent = /** @class */ (function (_super) {
            __extends(ReppingOnlineForCurrentItemEvent, _super);
            function ReppingOnlineForCurrentItemEvent(auctionId, itemId, order) {
                return _super.call(this, "ReppingOnlineForCurrentItemEvent", auctionId, itemId, order) || this;
            }
            return ReppingOnlineForCurrentItemEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReppingOnlineForCurrentItemEvent = ReppingOnlineForCurrentItemEvent;
        var AutoBidDisabledEvent = /** @class */ (function (_super) {
            __extends(AutoBidDisabledEvent, _super);
            function AutoBidDisabledEvent(auctionId, itemId, order) {
                return _super.call(this, "AutoBidDisabledEvent", auctionId, itemId, order) || this;
            }
            return AutoBidDisabledEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AutoBidDisabledEvent = AutoBidDisabledEvent;
        var AuctionStartingEarlyConfirmationEvent = /** @class */ (function (_super) {
            __extends(AuctionStartingEarlyConfirmationEvent, _super);
            function AuctionStartingEarlyConfirmationEvent(auctionId, itemId, order, ValidWhen, StartWarningLimit) {
                var _this = _super.call(this, "AuctionStartingEarlyConfirmationEvent", auctionId, itemId, order) || this;
                _this.ValidWhen = ValidWhen;
                _this.StartWarningLimit = StartWarningLimit;
                return _this;
            }
            return AuctionStartingEarlyConfirmationEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionStartingEarlyConfirmationEvent = AuctionStartingEarlyConfirmationEvent;
        var AutoBidEnabledEvent = /** @class */ (function (_super) {
            __extends(AutoBidEnabledEvent, _super);
            function AutoBidEnabledEvent(auctionId, itemId, order) {
                return _super.call(this, "AutoBidEnabledEvent", auctionId, itemId, order) || this;
            }
            return AutoBidEnabledEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AutoBidEnabledEvent = AutoBidEnabledEvent;
        var NotesRemovedEvent = /** @class */ (function (_super) {
            __extends(NotesRemovedEvent, _super);
            function NotesRemovedEvent(auctionId, itemId, order) {
                return _super.call(this, "NotesRemovedEvent", auctionId, itemId, order) || this;
            }
            return NotesRemovedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NotesRemovedEvent = NotesRemovedEvent;
        var WatchListItemRemovedEvent = /** @class */ (function (_super) {
            __extends(WatchListItemRemovedEvent, _super);
            function WatchListItemRemovedEvent(auctionId, itemId, order) {
                return _super.call(this, "WatchListItemRemovedEvent", auctionId, itemId, order) || this;
            }
            return WatchListItemRemovedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.WatchListItemRemovedEvent = WatchListItemRemovedEvent;
        var WatchListItemAddedEvent = /** @class */ (function (_super) {
            __extends(WatchListItemAddedEvent, _super);
            function WatchListItemAddedEvent(auctionId, itemId, order) {
                return _super.call(this, "WatchListItemAddedEvent", auctionId, itemId, order) || this;
            }
            return WatchListItemAddedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.WatchListItemAddedEvent = WatchListItemAddedEvent;
        var IntegrationNotesAddedEvent = /** @class */ (function (_super) {
            __extends(IntegrationNotesAddedEvent, _super);
            function IntegrationNotesAddedEvent(auctionId, itemId, order, Message) {
                var _this = _super.call(this, "IntegrationNotesAddedEvent", auctionId, itemId, order) || this;
                _this.Message = Message;
                return _this;
            }
            return IntegrationNotesAddedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.IntegrationNotesAddedEvent = IntegrationNotesAddedEvent;
        var IntegrationNotesRemovedEvent = /** @class */ (function (_super) {
            __extends(IntegrationNotesRemovedEvent, _super);
            function IntegrationNotesRemovedEvent(auctionId, itemId, order) {
                return _super.call(this, "IntegrationNotesRemovedEvent", auctionId, itemId, order) || this;
            }
            return IntegrationNotesRemovedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.IntegrationNotesRemovedEvent = IntegrationNotesRemovedEvent;
        var ItemPulledEvent = /** @class */ (function (_super) {
            __extends(ItemPulledEvent, _super);
            function ItemPulledEvent(auctionId, itemId, order, SequenceNumber) {
                var _this = _super.call(this, "ItemPulledEvent", auctionId, itemId, order) || this;
                _this.SequenceNumber = SequenceNumber;
                return _this;
            }
            return ItemPulledEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemPulledEvent = ItemPulledEvent;
        var IntegrationWatchListUpdatedEvent = /** @class */ (function (_super) {
            __extends(IntegrationWatchListUpdatedEvent, _super);
            function IntegrationWatchListUpdatedEvent(auctionId, order, Removed) {
                var _this = _super.call(this, "IntegrationWatchListUpdatedEvent", auctionId, null, order) || this;
                _this.Removed = Removed;
                return _this;
            }
            return IntegrationWatchListUpdatedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.IntegrationWatchListUpdatedEvent = IntegrationWatchListUpdatedEvent;
        var LeaveAuctionConfirmationEvent = /** @class */ (function (_super) {
            __extends(LeaveAuctionConfirmationEvent, _super);
            function LeaveAuctionConfirmationEvent(auctionId, itemId, order, LeaveReason, ShowKick) {
                var _this = _super.call(this, "LeaveAuctionConfirmationEvent", auctionId, itemId, order) || this;
                _this.LeaveReason = LeaveReason;
                _this.ShowKick = ShowKick;
                return _this;
            }
            return LeaveAuctionConfirmationEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.LeaveAuctionConfirmationEvent = LeaveAuctionConfirmationEvent;
        var DisambiguationNeededEvent = /** @class */ (function (_super) {
            __extends(DisambiguationNeededEvent, _super);
            function DisambiguationNeededEvent(auctionId, itemId, order, LiveUserRoles) {
                var _this = _super.call(this, "DisambiguationNeededEvent", auctionId, itemId, order) || this;
                _this.LiveUserRoles = LiveUserRoles;
                return _this;
            }
            return DisambiguationNeededEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.DisambiguationNeededEvent = DisambiguationNeededEvent;
        var SelectedUsersEvent = /** @class */ (function (_super) {
            __extends(SelectedUsersEvent, _super);
            function SelectedUsersEvent(auctionId, itemId, order, LiveUserRoles) {
                var _this = _super.call(this, "SelectedUsersEvent", auctionId, itemId, order) || this;
                _this.LiveUserRoles = LiveUserRoles;
                return _this;
            }
            return SelectedUsersEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.SelectedUsersEvent = SelectedUsersEvent;
        var AudioStreamOnEvent = /** @class */ (function (_super) {
            __extends(AudioStreamOnEvent, _super);
            function AudioStreamOnEvent(auctionId, itemId, order, Tenant, LocationId, Lane) {
                var _this = _super.call(this, "AudioStreamOnEvent", auctionId, itemId, order) || this;
                _this.Tenant = Tenant;
                _this.LocationId = LocationId;
                _this.Lane = Lane;
                return _this;
            }
            return AudioStreamOnEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AudioStreamOnEvent = AudioStreamOnEvent;
        var AudioStreamOffEvent = /** @class */ (function (_super) {
            __extends(AudioStreamOffEvent, _super);
            function AudioStreamOffEvent(auctionId, itemId, order, Tenant, LocationId, Lane) {
                var _this = _super.call(this, "AudioStreamOffEvent", auctionId, itemId, order) || this;
                _this.Tenant = Tenant;
                _this.LocationId = LocationId;
                _this.Lane = Lane;
                return _this;
            }
            return AudioStreamOffEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AudioStreamOffEvent = AudioStreamOffEvent;
        var AudioStartedEvent = /** @class */ (function (_super) {
            __extends(AudioStartedEvent, _super);
            function AudioStartedEvent(auctionId, itemId, order, Tenant, LocationId, Lane) {
                var _this = _super.call(this, "AudioStartedEvent", auctionId, itemId, order) || this;
                _this.Tenant = Tenant;
                _this.LocationId = LocationId;
                _this.Lane = Lane;
                return _this;
            }
            return AudioStartedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AudioStartedEvent = AudioStartedEvent;
        var AudioStoppedEvent = /** @class */ (function (_super) {
            __extends(AudioStoppedEvent, _super);
            function AudioStoppedEvent(auctionId, itemId, order, Tenant, LocationId, Lane) {
                var _this = _super.call(this, "AudioStoppedEvent", auctionId, itemId, order) || this;
                _this.Tenant = Tenant;
                _this.LocationId = LocationId;
                _this.Lane = Lane;
                return _this;
            }
            return AudioStoppedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AudioStoppedEvent = AudioStoppedEvent;
        var BidAcceptedEvent = /** @class */ (function (_super) {
            __extends(BidAcceptedEvent, _super);
            function BidAcceptedEvent(auctionId, itemId, order, Amount, BidderId, Display, BidderType) {
                var _this = _super.call(this, "BidAcceptedEvent", auctionId, itemId, order) || this;
                _this.Amount = Amount;
                _this.BidderId = BidderId;
                _this.Display = Display;
                _this.BidderType = BidderType;
                return _this;
            }
            return BidAcceptedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BidAcceptedEvent = BidAcceptedEvent;
        var BidRejectedEvent = /** @class */ (function (_super) {
            __extends(BidRejectedEvent, _super);
            function BidRejectedEvent(auctionId, itemId, order, Amount, BidderId, Reason, Display) {
                var _this = _super.call(this, "BidRejectedEvent", auctionId, itemId, order) || this;
                _this.Amount = Amount;
                _this.BidderId = BidderId;
                _this.Reason = Reason;
                _this.Display = Display;
                return _this;
            }
            return BidRejectedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BidRejectedEvent = BidRejectedEvent;
        var ItemsModifiedEvent = /** @class */ (function (_super) {
            __extends(ItemsModifiedEvent, _super);
            function ItemsModifiedEvent(auctionId, itemId, order, ItemsAdded, RemovedItemIds, ItemSession) {
                var _this = _super.call(this, "ItemsModifiedEvent", auctionId, itemId, order) || this;
                _this.ItemsAdded = ItemsAdded;
                _this.RemovedItemIds = RemovedItemIds;
                _this.ItemSession = ItemSession;
                return _this;
            }
            return ItemsModifiedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemsModifiedEvent = ItemsModifiedEvent;
        var SequenceNumberChangedEvent = /** @class */ (function (_super) {
            __extends(SequenceNumberChangedEvent, _super);
            function SequenceNumberChangedEvent(auctionId, itemId, order, Changes) {
                var _this = _super.call(this, "SequenceNumberChangedEvent", auctionId, itemId, order) || this;
                _this.Changes = Changes;
                return _this;
            }
            return SequenceNumberChangedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.SequenceNumberChangedEvent = SequenceNumberChangedEvent;
        var ItemResetEvent = /** @class */ (function (_super) {
            __extends(ItemResetEvent, _super);
            function ItemResetEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ItemResetEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemResetEvent = ItemResetEvent;
        var AuctionPausedEvent = /** @class */ (function (_super) {
            __extends(AuctionPausedEvent, _super);
            function AuctionPausedEvent(auctionId, itemId, order, AuctionStatus) {
                var _this = _super.call(this, "AuctionPausedEvent", auctionId, itemId, order) || this;
                _this.AuctionStatus = AuctionStatus;
                return _this;
            }
            return AuctionPausedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionPausedEvent = AuctionPausedEvent;
        var AuctionResumedEvent = /** @class */ (function (_super) {
            __extends(AuctionResumedEvent, _super);
            function AuctionResumedEvent(auctionId, itemId, order, AuctionStatus) {
                var _this = _super.call(this, "AuctionResumedEvent", auctionId, itemId, order) || this;
                _this.AuctionStatus = AuctionStatus;
                return _this;
            }
            return AuctionResumedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionResumedEvent = AuctionResumedEvent;
        var AuctionCanEndEvent = /** @class */ (function (_super) {
            __extends(AuctionCanEndEvent, _super);
            function AuctionCanEndEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return AuctionCanEndEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionCanEndEvent = AuctionCanEndEvent;
        var AuctionEndedEvent = /** @class */ (function (_super) {
            __extends(AuctionEndedEvent, _super);
            function AuctionEndedEvent(auctionId, itemId, order, AuctionStatus) {
                var _this = _super.call(this, "AuctionEndedEvent", auctionId, itemId, order) || this;
                _this.AuctionStatus = AuctionStatus;
                return _this;
            }
            return AuctionEndedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionEndedEvent = AuctionEndedEvent;
        var AuctionStartedEvent = /** @class */ (function (_super) {
            __extends(AuctionStartedEvent, _super);
            function AuctionStartedEvent(auctionId, itemId, order, AuctionStatus) {
                var _this = _super.call(this, "AuctionStartedEvent", auctionId, itemId, order) || this;
                _this.AuctionStatus = AuctionStatus;
                return _this;
            }
            return AuctionStartedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionStartedEvent = AuctionStartedEvent;
        var AuctionNotStartedEvent = /** @class */ (function (_super) {
            __extends(AuctionNotStartedEvent, _super);
            function AuctionNotStartedEvent(auctionId, itemId, order, AuctionStatus) {
                var _this = _super.call(this, "AuctionNotStartedEvent", auctionId, itemId, order) || this;
                _this.AuctionStatus = AuctionStatus;
                return _this;
            }
            return AuctionNotStartedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionNotStartedEvent = AuctionNotStartedEvent;
        var StartAuctionRejectedEvent = /** @class */ (function (_super) {
            __extends(StartAuctionRejectedEvent, _super);
            function StartAuctionRejectedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return StartAuctionRejectedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.StartAuctionRejectedEvent = StartAuctionRejectedEvent;
        var BiddingReopenedEvent = /** @class */ (function (_super) {
            __extends(BiddingReopenedEvent, _super);
            function BiddingReopenedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return BiddingReopenedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BiddingReopenedEvent = BiddingReopenedEvent;
        var NavigatedToEvent = /** @class */ (function (_super) {
            __extends(NavigatedToEvent, _super);
            function NavigatedToEvent(auctionId, itemId, order, IsNotInSequence, IsRerun) {
                var _this = _super.call(this, "NavigatedToEvent", auctionId, itemId, order) || this;
                _this.IsNotInSequence = IsNotInSequence;
                _this.IsRerun = IsRerun;
                return _this;
            }
            return NavigatedToEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NavigatedToEvent = NavigatedToEvent;
        var NavigatedFromEvent = /** @class */ (function (_super) {
            __extends(NavigatedFromEvent, _super);
            function NavigatedFromEvent(auctionId, itemId, order) {
                return _super.call(this, "NavigatedFromEvent", auctionId, itemId, order) || this;
            }
            return NavigatedFromEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NavigatedFromEvent = NavigatedFromEvent;
        var ConfirmNavigationFromEvent = /** @class */ (function (_super) {
            __extends(ConfirmNavigationFromEvent, _super);
            function ConfirmNavigationFromEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ConfirmNavigationFromEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ConfirmNavigationFromEvent = ConfirmNavigationFromEvent;
        var ConfirmNavigationEvent = /** @class */ (function (_super) {
            __extends(ConfirmNavigationEvent, _super);
            function ConfirmNavigationEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ConfirmNavigationEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ConfirmNavigationEvent = ConfirmNavigationEvent;
        var CounterStartedEvent = /** @class */ (function (_super) {
            __extends(CounterStartedEvent, _super);
            function CounterStartedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return CounterStartedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.CounterStartedEvent = CounterStartedEvent;
        var ReopenBiddingCounterStartedEvent = /** @class */ (function (_super) {
            __extends(ReopenBiddingCounterStartedEvent, _super);
            function ReopenBiddingCounterStartedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ReopenBiddingCounterStartedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReopenBiddingCounterStartedEvent = ReopenBiddingCounterStartedEvent;
        var NegotiationSellerCounterStartedEvent = /** @class */ (function (_super) {
            __extends(NegotiationSellerCounterStartedEvent, _super);
            function NegotiationSellerCounterStartedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return NegotiationSellerCounterStartedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationSellerCounterStartedEvent = NegotiationSellerCounterStartedEvent;
        var NegotiationBidderCounterStartedEvent = /** @class */ (function (_super) {
            __extends(NegotiationBidderCounterStartedEvent, _super);
            function NegotiationBidderCounterStartedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return NegotiationBidderCounterStartedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationBidderCounterStartedEvent = NegotiationBidderCounterStartedEvent;
        var BiddingCompletedEvent = /** @class */ (function (_super) {
            __extends(BiddingCompletedEvent, _super);
            function BiddingCompletedEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return BiddingCompletedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BiddingCompletedEvent = BiddingCompletedEvent;
        var NegotiationProposedEvent = /** @class */ (function (_super) {
            __extends(NegotiationProposedEvent, _super);
            function NegotiationProposedEvent(auctionId, itemId, order, IsBidderOnline) {
                var _this = _super.call(this, "NegotiationProposedEvent", auctionId, itemId, order) || this;
                _this.IsBidderOnline = IsBidderOnline;
                return _this;
            }
            return NegotiationProposedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationProposedEvent = NegotiationProposedEvent;
        var NegotiationProposalCancelledEvent = /** @class */ (function (_super) {
            __extends(NegotiationProposalCancelledEvent, _super);
            function NegotiationProposalCancelledEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return NegotiationProposalCancelledEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationProposalCancelledEvent = NegotiationProposalCancelledEvent;
        var ReopenBiddingDisabledEvent = /** @class */ (function (_super) {
            __extends(ReopenBiddingDisabledEvent, _super);
            function ReopenBiddingDisabledEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ReopenBiddingDisabledEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReopenBiddingDisabledEvent = ReopenBiddingDisabledEvent;
        var ReopenBiddingEnabledEvent = /** @class */ (function (_super) {
            __extends(ReopenBiddingEnabledEvent, _super);
            function ReopenBiddingEnabledEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ReopenBiddingEnabledEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReopenBiddingEnabledEvent = ReopenBiddingEnabledEvent;
        var ReservePriceMetEvent = /** @class */ (function (_super) {
            __extends(ReservePriceMetEvent, _super);
            function ReservePriceMetEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ReservePriceMetEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReservePriceMetEvent = ReservePriceMetEvent;
        var CloseToReserveEvent = /** @class */ (function (_super) {
            __extends(CloseToReserveEvent, _super);
            function CloseToReserveEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return CloseToReserveEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.CloseToReserveEvent = CloseToReserveEvent;
        var CounterStoppedEvent = /** @class */ (function (_super) {
            __extends(CounterStoppedEvent, _super);
            function CounterStoppedEvent(auctionId, itemId, order, FinishedCountdown) {
                var _this = _super.call(this, "CounterStoppedEvent", auctionId, itemId, order) || this;
                _this.FinishedCountdown = FinishedCountdown;
                return _this;
            }
            return CounterStoppedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.CounterStoppedEvent = CounterStoppedEvent;
        var ReopenBiddingCounterStoppedEvent = /** @class */ (function (_super) {
            __extends(ReopenBiddingCounterStoppedEvent, _super);
            function ReopenBiddingCounterStoppedEvent(auctionId, itemId, order, FinishedCountdown) {
                var _this = _super.call(this, "ReopenBiddingCounterStoppedEvent", auctionId, itemId, order) || this;
                _this.FinishedCountdown = FinishedCountdown;
                return _this;
            }
            return ReopenBiddingCounterStoppedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReopenBiddingCounterStoppedEvent = ReopenBiddingCounterStoppedEvent;
        var NegotiationSellerCounterStoppedEvent = /** @class */ (function (_super) {
            __extends(NegotiationSellerCounterStoppedEvent, _super);
            function NegotiationSellerCounterStoppedEvent(auctionId, itemId, order, FinishedCountdown) {
                var _this = _super.call(this, "NegotiationSellerCounterStoppedEvent", auctionId, itemId, order) || this;
                _this.FinishedCountdown = FinishedCountdown;
                return _this;
            }
            return NegotiationSellerCounterStoppedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationSellerCounterStoppedEvent = NegotiationSellerCounterStoppedEvent;
        var NegotiationBidderCounterStoppedEvent = /** @class */ (function (_super) {
            __extends(NegotiationBidderCounterStoppedEvent, _super);
            function NegotiationBidderCounterStoppedEvent(auctionId, itemId, order, FinishedCountdown) {
                var _this = _super.call(this, "NegotiationBidderCounterStoppedEvent", auctionId, itemId, order) || this;
                _this.FinishedCountdown = FinishedCountdown;
                return _this;
            }
            return NegotiationBidderCounterStoppedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationBidderCounterStoppedEvent = NegotiationBidderCounterStoppedEvent;
        var AskingAmountNeededEvent = /** @class */ (function (_super) {
            __extends(AskingAmountNeededEvent, _super);
            function AskingAmountNeededEvent(auctionId, itemId, order, Amount) {
                var _this = _super.call(this, "AskingAmountNeededEvent", auctionId, itemId, order) || this;
                _this.Amount = Amount;
                return _this;
            }
            return AskingAmountNeededEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AskingAmountNeededEvent = AskingAmountNeededEvent;
        var CounterTickEvent = /** @class */ (function (_super) {
            __extends(CounterTickEvent, _super);
            function CounterTickEvent(auctionId, itemId, order, Counter) {
                var _this = _super.call(this, "CounterTickEvent", auctionId, itemId, order) || this;
                _this.Counter = Counter;
                return _this;
            }
            return CounterTickEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.CounterTickEvent = CounterTickEvent;
        var ReopenBiddingCounterTickEvent = /** @class */ (function (_super) {
            __extends(ReopenBiddingCounterTickEvent, _super);
            function ReopenBiddingCounterTickEvent(auctionId, itemId, order, Counter) {
                var _this = _super.call(this, "ReopenBiddingCounterTickEvent", auctionId, itemId, order) || this;
                _this.Counter = Counter;
                return _this;
            }
            return ReopenBiddingCounterTickEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReopenBiddingCounterTickEvent = ReopenBiddingCounterTickEvent;
        var NegotiationSellerCounterTickEvent = /** @class */ (function (_super) {
            __extends(NegotiationSellerCounterTickEvent, _super);
            function NegotiationSellerCounterTickEvent(auctionId, itemId, order, Counter) {
                var _this = _super.call(this, "NegotiationSellerCounterTickEvent", auctionId, itemId, order) || this;
                _this.Counter = Counter;
                return _this;
            }
            return NegotiationSellerCounterTickEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationSellerCounterTickEvent = NegotiationSellerCounterTickEvent;
        var NegotiationBidderCounterTickEvent = /** @class */ (function (_super) {
            __extends(NegotiationBidderCounterTickEvent, _super);
            function NegotiationBidderCounterTickEvent(auctionId, itemId, order, Counter) {
                var _this = _super.call(this, "NegotiationBidderCounterTickEvent", auctionId, itemId, order) || this;
                _this.Counter = Counter;
                return _this;
            }
            return NegotiationBidderCounterTickEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationBidderCounterTickEvent = NegotiationBidderCounterTickEvent;
        var NegotiationOfferAcceptedEvent = /** @class */ (function (_super) {
            __extends(NegotiationOfferAcceptedEvent, _super);
            function NegotiationOfferAcceptedEvent(auctionId, itemId, order, OfferAmount) {
                var _this = _super.call(this, "NegotiationOfferAcceptedEvent", auctionId, itemId, order) || this;
                _this.OfferAmount = OfferAmount;
                return _this;
            }
            return NegotiationOfferAcceptedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationOfferAcceptedEvent = NegotiationOfferAcceptedEvent;
        var NegotiationOfferRejectedEvent = /** @class */ (function (_super) {
            __extends(NegotiationOfferRejectedEvent, _super);
            function NegotiationOfferRejectedEvent(auctionId, itemId, order, OfferAmount) {
                var _this = _super.call(this, "NegotiationOfferRejectedEvent", auctionId, itemId, order) || this;
                _this.OfferAmount = OfferAmount;
                return _this;
            }
            return NegotiationOfferRejectedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationOfferRejectedEvent = NegotiationOfferRejectedEvent;
        var AnswerNegotiationOfferTimeOutEvent = /** @class */ (function (_super) {
            __extends(AnswerNegotiationOfferTimeOutEvent, _super);
            function AnswerNegotiationOfferTimeOutEvent(auctionId, itemId, order) {
                return _super.call(this, "AnswerNegotiationOfferTimeOutEvent", auctionId, itemId, order) || this;
            }
            return AnswerNegotiationOfferTimeOutEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AnswerNegotiationOfferTimeOutEvent = AnswerNegotiationOfferTimeOutEvent;
        var CreateNegotiationOfferTimeOutEvent = /** @class */ (function (_super) {
            __extends(CreateNegotiationOfferTimeOutEvent, _super);
            function CreateNegotiationOfferTimeOutEvent(auctionId, itemId, order) {
                return _super.call(this, "CreateNegotiationOfferTimeOutEvent", auctionId, itemId, order) || this;
            }
            return CreateNegotiationOfferTimeOutEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.CreateNegotiationOfferTimeOutEvent = CreateNegotiationOfferTimeOutEvent;
        var NegotiationSellerOfferCreatedEvent = /** @class */ (function (_super) {
            __extends(NegotiationSellerOfferCreatedEvent, _super);
            function NegotiationSellerOfferCreatedEvent(auctionId, itemId, order, OfferAmount, OnlineBidderId, IsSellerOnline) {
                var _this = _super.call(this, "NegotiationSellerOfferCreatedEvent", auctionId, itemId, order) || this;
                _this.OfferAmount = OfferAmount;
                _this.OnlineBidderId = OnlineBidderId;
                _this.IsSellerOnline = IsSellerOnline;
                return _this;
            }
            return NegotiationSellerOfferCreatedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationSellerOfferCreatedEvent = NegotiationSellerOfferCreatedEvent;
        var NegotiationSellerResponseCallEvent = /** @class */ (function (_super) {
            __extends(NegotiationSellerResponseCallEvent, _super);
            function NegotiationSellerResponseCallEvent(auctionId, itemId, order) {
                return _super.call(this, "NegotiationSellerResponseCallEvent", auctionId, itemId, order) || this;
            }
            return NegotiationSellerResponseCallEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationSellerResponseCallEvent = NegotiationSellerResponseCallEvent;
        var NegotiationSellerResponseRerunEvent = /** @class */ (function (_super) {
            __extends(NegotiationSellerResponseRerunEvent, _super);
            function NegotiationSellerResponseRerunEvent(auctionId, itemId, order) {
                return _super.call(this, "NegotiationSellerResponseRerunEvent", auctionId, itemId, order) || this;
            }
            return NegotiationSellerResponseRerunEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationSellerResponseRerunEvent = NegotiationSellerResponseRerunEvent;
        var NegotiationSellerResponseSellEvent = /** @class */ (function (_super) {
            __extends(NegotiationSellerResponseSellEvent, _super);
            function NegotiationSellerResponseSellEvent(auctionId, itemId, order) {
                return _super.call(this, "NegotiationSellerResponseSellEvent", auctionId, itemId, order) || this;
            }
            return NegotiationSellerResponseSellEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.NegotiationSellerResponseSellEvent = NegotiationSellerResponseSellEvent;
        var AskingAmountSetEvent = /** @class */ (function (_super) {
            __extends(AskingAmountSetEvent, _super);
            function AskingAmountSetEvent(auctionId, itemId, order, Amount, JumpAmounts, SetBySystem, CadenceApplied, BidHistory) {
                var _this = _super.call(this, "AskingAmountSetEvent", auctionId, itemId, order) || this;
                _this.Amount = Amount;
                _this.JumpAmounts = JumpAmounts;
                _this.SetBySystem = SetBySystem;
                _this.CadenceApplied = CadenceApplied;
                _this.BidHistory = BidHistory;
                return _this;
            }
            return AskingAmountSetEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AskingAmountSetEvent = AskingAmountSetEvent;
        var IncrementSetEvent = /** @class */ (function (_super) {
            __extends(IncrementSetEvent, _super);
            function IncrementSetEvent(auctionId, itemId, order, Increment, SetBySystem, SetByPolicy) {
                var _this = _super.call(this, "IncrementSetEvent", auctionId, itemId, order) || this;
                _this.Increment = Increment;
                _this.SetBySystem = SetBySystem;
                _this.SetByPolicy = SetByPolicy;
                return _this;
            }
            return IncrementSetEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.IncrementSetEvent = IncrementSetEvent;
        var LeaveAuctionEvent = /** @class */ (function (_super) {
            __extends(LeaveAuctionEvent, _super);
            function LeaveAuctionEvent(auctionId, itemId, order, User, Role, LeaveReason) {
                var _this = _super.call(this, "LeaveAuctionEvent", auctionId, itemId, order) || this;
                _this.User = User;
                _this.Role = Role;
                _this.LeaveReason = LeaveReason;
                return _this;
            }
            return LeaveAuctionEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.LeaveAuctionEvent = LeaveAuctionEvent;
        var LeaveAuctionGuestEvent = /** @class */ (function (_super) {
            __extends(LeaveAuctionGuestEvent, _super);
            function LeaveAuctionGuestEvent(auctionId, itemId, order, User, Role) {
                var _this = _super.call(this, "LeaveAuctionEvent", auctionId, itemId, order) || this;
                _this.User = User;
                _this.Role = Role;
                return _this;
            }
            return LeaveAuctionGuestEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.LeaveAuctionGuestEvent = LeaveAuctionGuestEvent;
        var TransientSpendingLimitEvent = /** @class */ (function (_super) {
            __extends(TransientSpendingLimitEvent, _super);
            function TransientSpendingLimitEvent(auctionId, itemId, order, UserId, BidderId, AmountSpent, Limit) {
                var _this = _super.call(this, "TransientSpendingLimitEvent", auctionId, itemId, order) || this;
                _this.UserId = UserId;
                _this.BidderId = BidderId;
                _this.AmountSpent = AmountSpent;
                _this.Limit = Limit;
                return _this;
            }
            return TransientSpendingLimitEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.TransientSpendingLimitEvent = TransientSpendingLimitEvent;
        var UserSuspendAuctionEvent = /** @class */ (function (_super) {
            __extends(UserSuspendAuctionEvent, _super);
            function UserSuspendAuctionEvent(auctionId, itemId, order, BidderId) {
                var _this = _super.call(this, "UserSuspendAuctionEvent", auctionId, itemId, order) || this;
                _this.BidderId = BidderId;
                return _this;
            }
            return UserSuspendAuctionEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.UserSuspendAuctionEvent = UserSuspendAuctionEvent;
        var UserJoinedAuctionChatEvent = /** @class */ (function (_super) {
            __extends(UserJoinedAuctionChatEvent, _super);
            function UserJoinedAuctionChatEvent(auctionId, itemId, order, User, Role) {
                var _this = _super.call(this, "UserJoinedAuctionChatEvent", auctionId, itemId, order) || this;
                _this.User = User;
                _this.Role = Role;
                return _this;
            }
            return UserJoinedAuctionChatEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.UserJoinedAuctionChatEvent = UserJoinedAuctionChatEvent;
        var UserLeftAuctionChatEvent = /** @class */ (function (_super) {
            __extends(UserLeftAuctionChatEvent, _super);
            function UserLeftAuctionChatEvent(auctionId, itemId, order, User, Role) {
                var _this = _super.call(this, "UserLeftAuctionChatEvent", auctionId, itemId, order) || this;
                _this.User = User;
                _this.Role = Role;
                return _this;
            }
            return UserLeftAuctionChatEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.UserLeftAuctionChatEvent = UserLeftAuctionChatEvent;
        var EventFromCommand = /** @class */ (function (_super) {
            __extends(EventFromCommand, _super);
            function EventFromCommand(auctionId, itemId, order, Command) {
                var _this = _super.call(this, "EventFromCommand", auctionId, itemId, order) || this;
                _this.Command = Command;
                return _this;
            }
            return EventFromCommand;
        }(Shared_1.Shared.DomainEvent));
        Events_1.EventFromCommand = EventFromCommand;
        var ItemIfBidEvent = /** @class */ (function (_super) {
            __extends(ItemIfBidEvent, _super);
            function ItemIfBidEvent(auctionId, itemId, order, BidderId, Amount, SequenceNumber) {
                var _this = _super.call(this, "ItemIfBidEvent", auctionId, itemId, order) || this;
                _this.BidderId = BidderId;
                _this.Amount = Amount;
                _this.SequenceNumber = SequenceNumber;
                return _this;
            }
            return ItemIfBidEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemIfBidEvent = ItemIfBidEvent;
        var ClerkConfigurationEvent = /** @class */ (function (_super) {
            __extends(ClerkConfigurationEvent, _super);
            function ClerkConfigurationEvent(auctionId, itemId, order, Configuration) {
                var _this = _super.call(this, "ClerkConfigurationEvent", auctionId, itemId, order) || this;
                _this.Configuration = Configuration;
                return _this;
            }
            return ClerkConfigurationEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ClerkConfigurationEvent = ClerkConfigurationEvent;
        var ReservePriceResetEvent = /** @class */ (function (_super) {
            __extends(ReservePriceResetEvent, _super);
            function ReservePriceResetEvent(auctionId, itemId, order, IsDisplay) {
                var _this = _super.call(this, "ReservePriceResetEvent", auctionId, itemId, order) || this;
                _this.IsDisplay = IsDisplay;
                return _this;
            }
            return ReservePriceResetEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReservePriceResetEvent = ReservePriceResetEvent;
        var ItemSoldEvent = /** @class */ (function (_super) {
            __extends(ItemSoldEvent, _super);
            function ItemSoldEvent(auctionId, itemId, order, BidderId, Amount, SequenceNumber) {
                var _this = _super.call(this, "ItemSoldEvent", auctionId, itemId, order) || this;
                _this.BidderId = BidderId;
                _this.Amount = Amount;
                _this.SequenceNumber = SequenceNumber;
                return _this;
            }
            return ItemSoldEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemSoldEvent = ItemSoldEvent;
        var ItemPassEvent = /** @class */ (function (_super) {
            __extends(ItemPassEvent, _super);
            function ItemPassEvent(auctionId, itemId, order, SequenceNumber) {
                var _this = _super.call(this, "ItemPassEvent", auctionId, itemId, order) || this;
                _this.SequenceNumber = SequenceNumber;
                return _this;
            }
            return ItemPassEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemPassEvent = ItemPassEvent;
        var ItemReRunEvent = /** @class */ (function (_super) {
            __extends(ItemReRunEvent, _super);
            function ItemReRunEvent(auctionId, itemId, order, BidderId, Amount, SequenceNumber) {
                var _this = _super.call(this, "ItemReRunEvent", auctionId, itemId, order) || this;
                _this.BidderId = BidderId;
                _this.Amount = Amount;
                _this.SequenceNumber = SequenceNumber;
                return _this;
            }
            return ItemReRunEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemReRunEvent = ItemReRunEvent;
        var ItemNoBidEvent = /** @class */ (function (_super) {
            __extends(ItemNoBidEvent, _super);
            function ItemNoBidEvent(auctionId, itemId, order, SequenceNumber) {
                var _this = _super.call(this, "ItemNoBidEvent", auctionId, itemId, order) || this;
                _this.SequenceNumber = SequenceNumber;
                return _this;
            }
            return ItemNoBidEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ItemNoBidEvent = ItemNoBidEvent;
        var ManualActivationNeededEvent = /** @class */ (function (_super) {
            __extends(ManualActivationNeededEvent, _super);
            function ManualActivationNeededEvent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ManualActivationNeededEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ManualActivationNeededEvent = ManualActivationNeededEvent;
        var RetractedEvent = /** @class */ (function (_super) {
            __extends(RetractedEvent, _super);
            function RetractedEvent(auctionId, itemId, order, BidderId, Amount, Display, NewBidderId, NewAmount, NewDisplay) {
                var _this = _super.call(this, "RetractedEvent", auctionId, itemId, order) || this;
                _this.BidderId = BidderId;
                _this.Amount = Amount;
                _this.Display = Display;
                _this.NewBidderId = NewBidderId;
                _this.NewAmount = NewAmount;
                _this.NewDisplay = NewDisplay;
                return _this;
            }
            return RetractedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.RetractedEvent = RetractedEvent;
        var OverruledEvent = /** @class */ (function (_super) {
            __extends(OverruledEvent, _super);
            function OverruledEvent(auctionId, itemId, order, BidderId, Amount, Display, NewBidderId, NewAmount, NewDisplay) {
                var _this = _super.call(this, "OverruledEvent", auctionId, itemId, order) || this;
                _this.BidderId = BidderId;
                _this.Amount = Amount;
                _this.Display = Display;
                _this.NewBidderId = NewBidderId;
                _this.NewAmount = NewAmount;
                _this.NewDisplay = NewDisplay;
                return _this;
            }
            return OverruledEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.OverruledEvent = OverruledEvent;
        var MessageToBidderOrSellerEvent = /** @class */ (function (_super) {
            __extends(MessageToBidderOrSellerEvent, _super);
            function MessageToBidderOrSellerEvent(auctionId, itemId, order, To, Message, MessageType) {
                var _this = _super.call(this, "MessageToBidderOrSellerEvent", auctionId, itemId, order) || this;
                _this.To = To;
                _this.Message = Message;
                _this.MessageType = MessageType;
                return _this;
            }
            return MessageToBidderOrSellerEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.MessageToBidderOrSellerEvent = MessageToBidderOrSellerEvent;
        var MessageToBiddersAndSellersEvent = /** @class */ (function (_super) {
            __extends(MessageToBiddersAndSellersEvent, _super);
            function MessageToBiddersAndSellersEvent(auctionId, itemId, order, From, Message, MessageType) {
                var _this = _super.call(this, "MessageToBiddersAndSellersEvent", auctionId, itemId, order) || this;
                _this.From = From;
                _this.Message = Message;
                _this.MessageType = MessageType;
                return _this;
            }
            return MessageToBiddersAndSellersEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.MessageToBiddersAndSellersEvent = MessageToBiddersAndSellersEvent;
        var MessageToClerkEvent = /** @class */ (function (_super) {
            __extends(MessageToClerkEvent, _super);
            function MessageToClerkEvent(auctionId, itemId, order, UserId, Message, MessageType) {
                var _this = _super.call(this, "MessageToClerkEvent", auctionId, itemId, order) || this;
                _this.UserId = UserId;
                _this.Message = Message;
                _this.MessageType = MessageType;
                return _this;
            }
            return MessageToClerkEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.MessageToClerkEvent = MessageToClerkEvent;
        var RepInfoToClerkEvent = /** @class */ (function (_super) {
            __extends(RepInfoToClerkEvent, _super);
            function RepInfoToClerkEvent(auctionId, itemId, order, UserId) {
                var _this = _super.call(this, "RepInfoToClerkEvent", auctionId, itemId, order) || this;
                _this.UserId = UserId;
                return _this;
            }
            return RepInfoToClerkEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.RepInfoToClerkEvent = RepInfoToClerkEvent;
        var AuctionLevelMessageToAllBiddersAndSellersEvent = /** @class */ (function (_super) {
            __extends(AuctionLevelMessageToAllBiddersAndSellersEvent, _super);
            function AuctionLevelMessageToAllBiddersAndSellersEvent(auctionId, itemId, order, From, Message, MessageType) {
                var _this = _super.call(this, "AuctionLevelMessageToAllBiddersAndSellersEvent", auctionId, itemId, order) || this;
                _this.From = From;
                _this.Message = Message;
                _this.MessageType = MessageType;
                return _this;
            }
            return AuctionLevelMessageToAllBiddersAndSellersEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionLevelMessageToAllBiddersAndSellersEvent = AuctionLevelMessageToAllBiddersAndSellersEvent;
        var SetLightsEvent = /** @class */ (function (_super) {
            __extends(SetLightsEvent, _super);
            function SetLightsEvent(auctionId, itemId, order, Lights) {
                var _this = _super.call(this, "SetLightsEvent", auctionId, itemId, order) || this;
                _this.Lights = Lights;
                return _this;
            }
            return SetLightsEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.SetLightsEvent = SetLightsEvent;
        var GetBidIncrementsEvent = /** @class */ (function (_super) {
            __extends(GetBidIncrementsEvent, _super);
            function GetBidIncrementsEvent(auctionId, itemId, order, BidIncrements) {
                var _this = _super.call(this, "GetBidIncrementsEvent", auctionId, itemId, order) || this;
                _this.BidIncrements = BidIncrements;
                return _this;
            }
            return GetBidIncrementsEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.GetBidIncrementsEvent = GetBidIncrementsEvent;
        var SetAnnouncementsEvent = /** @class */ (function (_super) {
            __extends(SetAnnouncementsEvent, _super);
            function SetAnnouncementsEvent(auctionId, itemId, order, Announcements) {
                var _this = _super.call(this, "SetAnnouncementsEvent", auctionId, itemId, order) || this;
                _this.Announcements = Announcements;
                return _this;
            }
            return SetAnnouncementsEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.SetAnnouncementsEvent = SetAnnouncementsEvent;
        var DigitalAuctionTickEvent = /** @class */ (function (_super) {
            __extends(DigitalAuctionTickEvent, _super);
            function DigitalAuctionTickEvent(auctionId, itemId, order, TotalTicks, Tick, IsBonusTime) {
                var _this = _super.call(this, "DigitalAuctionTickEvent", auctionId, itemId, order) || this;
                _this.TotalTicks = TotalTicks;
                _this.Tick = Tick;
                _this.IsBonusTime = IsBonusTime;
                return _this;
            }
            return DigitalAuctionTickEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.DigitalAuctionTickEvent = DigitalAuctionTickEvent;
        var WatchAddedCountEvent = /** @class */ (function (_super) {
            __extends(WatchAddedCountEvent, _super);
            function WatchAddedCountEvent(auctionId, itemId, order, Count, ConsignorId) {
                var _this = _super.call(this, "WatchAddedCountEvent", auctionId, itemId, order) || this;
                _this.Count = Count;
                _this.ConsignorId = ConsignorId;
                return _this;
            }
            return WatchAddedCountEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.WatchAddedCountEvent = WatchAddedCountEvent;
        var BidCountUpdateEvent = /** @class */ (function (_super) {
            __extends(BidCountUpdateEvent, _super);
            function BidCountUpdateEvent(auctionId, itemId, order, Count) {
                var _this = _super.call(this, "BidCountUpdateEvent", auctionId, itemId, order) || this;
                _this.Count = Count;
                return _this;
            }
            return BidCountUpdateEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BidCountUpdateEvent = BidCountUpdateEvent;
        var BiddersCountUpdateEvent = /** @class */ (function (_super) {
            __extends(BiddersCountUpdateEvent, _super);
            function BiddersCountUpdateEvent(auctionId, itemId, order, Count) {
                var _this = _super.call(this, "BiddersCountUpdateEvent", auctionId, itemId, order) || this;
                _this.Count = Count;
                return _this;
            }
            return BiddersCountUpdateEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BiddersCountUpdateEvent = BiddersCountUpdateEvent;
        var BidInfoUpdatedEvent = /** @class */ (function (_super) {
            __extends(BidInfoUpdatedEvent, _super);
            function BidInfoUpdatedEvent(auctionId, itemId, order, BidCount, BiddersCount, ConsignorId) {
                var _this = _super.call(this, "BidInfoUpdatedEvent", auctionId, itemId, order) || this;
                _this.BidCount = BidCount;
                _this.BiddersCount = BiddersCount;
                _this.ConsignorId = ConsignorId;
                return _this;
            }
            return BidInfoUpdatedEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.BidInfoUpdatedEvent = BidInfoUpdatedEvent;
        var PreBiddersCountUpdateEvent = /** @class */ (function (_super) {
            __extends(PreBiddersCountUpdateEvent, _super);
            function PreBiddersCountUpdateEvent(auctionId, itemId, order, Count, ConsignorId) {
                var _this = _super.call(this, "PreBiddersCountUpdateEvent", auctionId, itemId, order) || this;
                _this.Count = Count;
                _this.ConsignorId = ConsignorId;
                return _this;
            }
            return PreBiddersCountUpdateEvent;
        }(Shared_1.Shared.DomainEvent));
        Events_1.PreBiddersCountUpdateEvent = PreBiddersCountUpdateEvent;
        var ReplayedEventsBatch = /** @class */ (function (_super) {
            __extends(ReplayedEventsBatch, _super);
            function ReplayedEventsBatch(auctionId, itemId, order, Events) {
                var _this = _super.call(this, "ReplayedEventsBatch", auctionId, itemId, order) || this;
                _this.Events = Events;
                return _this;
            }
            return ReplayedEventsBatch;
        }(Shared_1.Shared.DomainEvent));
        Events_1.ReplayedEventsBatch = ReplayedEventsBatch;
        var AuctionJoinRequested = /** @class */ (function (_super) {
            __extends(AuctionJoinRequested, _super);
            function AuctionJoinRequested(AuctionId, Tenant, Language, Timezone) {
                var _this = _super.call(this, "AuctionJoinRequested", AuctionId, null, -1) || this;
                _this.Tenant = Tenant;
                _this.Language = Language;
                _this.Timezone = Timezone;
                return _this;
            }
            return AuctionJoinRequested;
        }(Shared_1.Shared.DomainEvent));
        Events_1.AuctionJoinRequested = AuctionJoinRequested;
    })(Events = exports.Events || (exports.Events = {}));
});
},{"./Shared":38}],34:[function(require,module,exports){
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./Shared", "./Events"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    __exportStar(require("./Shared"), exports);
    __exportStar(require("./Events"), exports);
});
},{"./Events":33,"./Shared":38}],35:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared", "./BidderSellerCommands", "./BidderSellerShared", "./EngineShared"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CoreEngine = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var BidderSellerCommands_1 = require("./BidderSellerCommands");
    var BidderShared = require("./BidderSellerShared");
    var EngineShared = require("./EngineShared");
    var CoreEngine;
    (function (CoreEngine) {
        var Engine = /** @class */ (function (_super) {
            __extends(Engine, _super);
            function Engine() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Engine.prototype.CreateAuctionModifier = function (aucId) {
                return new BidderShared.BidderAuctionModifier(aucId);
            };
            Engine.prototype.CreateEventProcessor = function (auc, logger, repo) {
                return new InternalEventProcessor(auc, logger, repo, this, this.SessionKey);
            };
            Engine.prototype.FireCommand = function (command) {
                return __awaiter(this, void 0, void 0, function () {
                    var map, anc, anc, rnc, wc, wc, wc, wc, wc, pabc2, pabc, pabc3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                map = _super.prototype.GetMappings.call(this)[command.InternalAuctionId];
                                if (!(command instanceof BidderSellerCommands_1.Commands.AddOrUpdateNotesCommand ||
                                    command instanceof BidderSellerCommands_1.Commands.AddOrUpdateConsginorNotesCommand ||
                                    command instanceof BidderSellerCommands_1.Commands.RemoveNotesCommand ||
                                    command instanceof BidderSellerCommands_1.Commands.ModifyWatchListCommand)) return [3 /*break*/, 17];
                                if (!(command instanceof BidderSellerCommands_1.Commands.AddOrUpdateNotesCommand)) return [3 /*break*/, 2];
                                anc = command;
                                return [4 /*yield*/, this.CurrentRepository().AddNotes(command.InternalAuctionId, command.ItemId, anc.Message, anc.RoleId)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!(command instanceof BidderSellerCommands_1.Commands.AddOrUpdateConsginorNotesCommand)) return [3 /*break*/, 4];
                                anc = command;
                                return [4 /*yield*/, this.CurrentRepository().AddConsignorNotes(command.InternalAuctionId, command.ItemId, anc.Message, anc.RoleId)];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (!(command instanceof BidderSellerCommands_1.Commands.RemoveNotesCommand)) return [3 /*break*/, 6];
                                rnc = command;
                                return [4 /*yield*/, this.CurrentRepository().RemoveNotes(command.InternalAuctionId, command.ItemId, rnc.RoleId)];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6:
                                if (!(command instanceof BidderSellerCommands_1.Commands.ModifyWatchListCommand)) return [3 /*break*/, 8];
                                wc = command;
                                return [4 /*yield*/, this.CurrentRepository().ModifyWatchList(command.InternalAuctionId, wc.WatchItemIds, wc.UnWatchItemIds, wc.Roleid)];
                            case 7:
                                _a.sent();
                                _a.label = 8;
                            case 8:
                                if (!(command instanceof BidderSellerCommands_1.Commands.KickVCBUserCommand)) return [3 /*break*/, 10];
                                wc = command;
                                return [4 /*yield*/, this.CurrentRepository().KickVCBUser(wc.UserId, wc.SessionKey)];
                            case 9:
                                _a.sent();
                                _a.label = 10;
                            case 10:
                                if (!(command instanceof BidderSellerCommands_1.Commands.AddUsertoVCBCommand)) return [3 /*break*/, 12];
                                wc = command;
                                return [4 /*yield*/, this.CurrentRepository().AddUsertoVCB(wc.UserId, wc.SessionKey)];
                            case 11:
                                _a.sent();
                                _a.label = 12;
                            case 12:
                                if (!(command instanceof BidderSellerCommands_1.Commands.CheckDuplicateLoginUsersVCBCommand)) return [3 /*break*/, 14];
                                wc = command;
                                return [4 /*yield*/, this.CurrentRepository().CheckDuplicateLoginUsersVCB(wc.UserId, wc.SessionKey)];
                            case 13:
                                _a.sent();
                                _a.label = 14;
                            case 14:
                                if (!(command instanceof BidderSellerCommands_1.Commands.RemoveUserVCBCommand)) return [3 /*break*/, 16];
                                wc = command;
                                return [4 /*yield*/, this.CurrentRepository().RemoveUserVCB(wc.UserId, wc.SessionKey)];
                            case 15:
                                _a.sent();
                                _a.label = 16;
                            case 16: return [2 /*return*/];
                            case 17:
                                if (!(command instanceof BidderSellerCommands_1.Commands.PlaceAutoBidCommand ||
                                    command instanceof BidderSellerCommands_1.Commands.ModifyAutoBidCommand ||
                                    command instanceof BidderSellerCommands_1.Commands.RemoveAutoBidCommand)) return [3 /*break*/, 24];
                                if (!(command.ItemId != map.JoinedAuction.CurrentItemId)) return [3 /*break*/, 24];
                                this.logger.LogWarning(command.InternalAuctionId, "not the current item, using WEB API");
                                if (!(command instanceof BidderSellerCommands_1.Commands.ModifyAutoBidCommand)) return [3 /*break*/, 19];
                                pabc2 = command;
                                return [4 /*yield*/, this.CurrentRepository().ModifyMaxBid(command.InternalAuctionId, command.ItemId, pabc2.SelectedBidderId, pabc2.Amount, this.SessionKey)];
                            case 18:
                                _a.sent();
                                _a.label = 19;
                            case 19:
                                if (!(command instanceof BidderSellerCommands_1.Commands.PlaceAutoBidCommand)) return [3 /*break*/, 21];
                                pabc = command;
                                return [4 /*yield*/, this.CurrentRepository().PlaceMaxBid(command.InternalAuctionId, command.ItemId, pabc.SelectedBidderId, pabc.Amount, this.SessionKey)];
                            case 20:
                                _a.sent();
                                _a.label = 21;
                            case 21:
                                if (!(command instanceof BidderSellerCommands_1.Commands.RemoveAutoBidCommand)) return [3 /*break*/, 23];
                                pabc3 = command;
                                return [4 /*yield*/, this.CurrentRepository().RemoveMaxBid(command.InternalAuctionId, command.ItemId, pabc3.SelectedBidderId, this.SessionKey)];
                            case 22:
                                _a.sent();
                                _a.label = 23;
                            case 23: return [2 /*return*/];
                            case 24: return [4 /*yield*/, map.CommandProcessor.Process(command)];
                            case 25:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            return Engine;
        }(EngineShared.BaseEngine));
        CoreEngine.Engine = Engine;
        var InternalEventProcessor = /** @class */ (function (_super) {
            __extends(InternalEventProcessor, _super);
            function InternalEventProcessor(Auction, logger, repo, fireCommandServide, sessionKey) {
                var _this = _super.call(this, Auction, logger, repo, fireCommandServide) || this;
                _this.EventProcessorName = "AuctionInternalEventProcessor";
                _this._repoWasCalled = false;
                _this.SessionKey = sessionKey;
                return _this;
            }
            InternalEventProcessor.prototype.Process = function (event, channelName) {
                return __awaiter(this, void 0, void 0, function () {
                    var aje, usrs, aje, sue, ev, ev, ev, ev, ev, ev, ev, ev;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, _super.prototype.Process.call(this, event, channelName)];
                            case 1:
                                _a.sent();
                                if (event instanceof ForAllShared_1.Events.AuctionJoinedEvent) {
                                    aje = event;
                                    if (!this._repoWasCalled) {
                                        usrs = this.Auction.Users.map(function (u) { return u.RoleId; });
                                        this.repo.GetAutoBids(event.InternalAuctionId, usrs).then(function (p) { p.forEach(function (z) { return _this.Auction.AutoBids.push(z); }); _this.Auction.AutoBidsLoaded(); });
                                        this.repo.GetNotes(event.InternalAuctionId, usrs).then(function (p) { p.forEach(function (z) { return _this.Auction.Notes.push(z); }); _this.Auction.NotesLoaded(); });
                                        this.repo.GetWatchedItemIds(event.InternalAuctionId, usrs).then(function (p) { p.forEach(function (z) { return _this.Auction.WatchList.push(z); }); _this.Auction.WatchListsLoaded(); });
                                        if (aje.Items.some(function (p) { return p.UserCanSell; })) {
                                            this.repo.GetConsignorInfo(event.InternalAuctionId, this.SessionKey).then(function (p) { p.forEach(function (z) { return _this.Auction.ConsignorInfo.push(z); }); _this.Auction.ConsignorInfoLoaded(); });
                                        }
                                        this._repoWasCalled = true;
                                    }
                                }
                                else if (event instanceof ForAllShared_1.Events.SecurityChangedEvent) {
                                    aje = event;
                                    this.Auction.SecurityChanged(aje.Items);
                                }
                                else if (event instanceof ForAllShared_1.Events.SelectedUsersEvent) {
                                    sue = event;
                                    this.Auction.SetSelectedUsers(sue.LiveUserRoles);
                                }
                                else if (event instanceof ForAllShared_1.Events.AutoBidPlacedEvent) {
                                    ev = event;
                                    this.Auction.AutoBidPlaced(ev.InternalAuctionItemId, ev.Amount, ev.BidderId, ev.CurrentHighBidAmount);
                                }
                                else if (event instanceof ForAllShared_1.Events.AutoBidRemovedEvent) {
                                    ev = event;
                                    this.Auction.AutoBidRemoved(ev.InternalAuctionItemId);
                                }
                                else if (event instanceof ForAllShared_1.Events.AutoBidModifiedEvent) {
                                    ev = event;
                                    this.Auction.AutoBidModified(ev.InternalAuctionItemId, ev.Amount, ev.BidderId, ev.CurrentHighBidAmount);
                                }
                                else if (event instanceof ForAllShared_1.Events.HighAutoBidEvent) {
                                    ev = event;
                                    this.Auction.HighAutoBid(ev.InternalAuctionItemId, ev.WinningBidderId);
                                }
                                else if (event instanceof ForAllShared_1.Events.WatchListItemRemovedEvent) {
                                    ev = event;
                                    this.Auction.WatchListModified(true, ev.InternalAuctionItemId);
                                }
                                else if (event instanceof ForAllShared_1.Events.WatchListItemAddedEvent) {
                                    ev = event;
                                    this.Auction.WatchListModified(false, ev.InternalAuctionItemId);
                                }
                                else if (event instanceof ForAllShared_1.Events.NotesAddedEvent) {
                                    ev = event;
                                    this.Auction.NotesAdded(ev.InternalAuctionItemId, ev.Message);
                                }
                                else if (event instanceof ForAllShared_1.Events.NotesRemovedEvent) {
                                    ev = event;
                                    this.Auction.NotesRemoved(ev.InternalAuctionItemId);
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            };
            return InternalEventProcessor;
        }(EngineShared.BaseInternalEventProcessor));
    })(CoreEngine = exports.CoreEngine || (exports.CoreEngine = {}));
});
},{"./BidderSellerCommands":29,"./BidderSellerShared":30,"./EngineShared":32,"./ForAllShared":34}],36:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./PortalModels"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Portal = void 0;
    var PortalModels_1 = require("./PortalModels");
    var Portal;
    (function (Portal) {
        var PortalRepository = /** @class */ (function () {
            function PortalRepository(basePortalUri, bearerToken, portalJoinApiApiUrl) {
                this.basePortalUri = basePortalUri;
                this.bearerToken = bearerToken;
                this.portalJoinApiApiUrl = portalJoinApiApiUrl;
                this._auctionSessionToken = new Map();
                this._itemSessionToken = new Map();
            }
            PortalRepository.prototype.ModifyMaxBid = function (internalAuctionId, internalItemId, bidderId, amount, sessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var abr, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                abr = new PortalModels_1.PortalModels.AutoBidRequest(internalAuctionId, internalItemId, bidderId, amount, sessionKey);
                                url = this.basePortalUri + "autobid/ModifyMaxBid";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(abr))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.RemoveMaxBid = function (internalAuctionId, internalItemId, bidderId, sessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var abr, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                abr = new PortalModels_1.PortalModels.AutoBidRequest(internalAuctionId, internalItemId, bidderId, 0, sessionKey);
                                url = this.basePortalUri + "autobid/RemoveMaxBid";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(abr))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.PlaceMaxBid = function (internalAuctionId, internalItemId, bidderId, amount, sessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var abr, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                abr = new PortalModels_1.PortalModels.AutoBidRequest(internalAuctionId, internalItemId, bidderId, amount, sessionKey);
                                url = this.basePortalUri + "autobid/PlaceMaxBid";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(abr))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetAutoBids = function (internalAuctionId, selectedRoles) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "autoBid/?internalAuctionId=" + internalAuctionId + "&selectedRoles=" + JSON.stringify(selectedRoles);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                e_1 = _a.sent();
                                console.log(e_1);
                                return [2 /*return*/, []];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetWatchedItemIds = function (internalAuctionId, selectedRoles) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "watch/?internalAuctionId=" + internalAuctionId + "&selectedRoles=" + JSON.stringify(selectedRoles);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                e_2 = _a.sent();
                                console.log(e_2);
                                return [2 /*return*/, []];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetNotes = function (internalAuctionId, roleId) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, e_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "notes/?internalAuctionId=" + internalAuctionId + "&roleId=" + JSON.stringify(roleId);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                e_3 = _a.sent();
                                console.log(e_3);
                                return [2 /*return*/, []];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetGlobalMessage = function (tenant) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, e_4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + ("globalmessage/GetGlobalMessage?tenant=" + tenant);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                e_4 = _a.sent();
                                console.log(e_4);
                                return [2 /*return*/, null];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetHideWinningBidSale = function (tenant) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, e_5;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + ("globalmessage/GetHideWinningBidSale?tenant=" + tenant);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                e_5 = _a.sent();
                                console.log(e_5);
                                return [2 /*return*/, null];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetAudioForLane = function (tenant, locationId, lane) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + ("audio?tenant=" + tenant + "&locationId=" + locationId + "&lane=" + lane);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                error_1 = _a.sent();
                                console.error(error_1);
                                return [2 /*return*/, null];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetV1AudioForLane = function (tenant, locationId, lane) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, error_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + ("audiov1?tenant=" + tenant + "&locationId=" + locationId + "&lane=" + lane);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                error_2 = _a.sent();
                                console.error(error_2);
                                return [2 /*return*/, null];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.UpdateAudioForLane = function (tenant, locationId, lane, isAvailable) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + ("audio?tenant=" + tenant + "&locationId=" + locationId + "&lane=" + lane + "&isAvailable=" + isAvailable);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                error_3 = _a.sent();
                                console.error(error_3);
                                return [2 /*return*/, null];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetConsignorInfo = function (internalAuctionId, sessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var url, e_6;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + ("ConsignorInfo/GetConsignorInfo?internalAuctionId=" + internalAuctionId + "&sessionKey=" + sessionKey);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3:
                                e_6 = _a.sent();
                                console.log(e_6);
                                return [2 /*return*/, []];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.AddCustomerFeedback = function (UserId, Tenant, Comment) {
                return __awaiter(this, void 0, void 0, function () {
                    var feedback, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                feedback = new PortalModels_1.PortalModels.FeedbackRequest(UserId, Tenant, Comment, "", "", "");
                                url = this.basePortalUri + "Feedback/AddFeedback";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(feedback))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetConsignorNotes = function (internalAuctionId, internalItemId) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "ConsignorInfo/GetConsignorNotes?internalAuctionId=" + internalAuctionId + "&internalItemId=" + internalItemId;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.AddNotes = function (internalAuctionId, internalItemId, message, roleId) {
                return __awaiter(this, void 0, void 0, function () {
                    var note, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                note = new PortalModels_1.PortalModels.NotesRequest(internalAuctionId, internalItemId, message, roleId);
                                url = this.basePortalUri + "notes/AddNotes";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(note))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.AddConsignorNotes = function (internalAuctionId, internalItemId, message, roleId) {
                return __awaiter(this, void 0, void 0, function () {
                    var note, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                note = new PortalModels_1.PortalModels.NotesRequest(internalAuctionId, internalItemId, message, roleId);
                                url = this.basePortalUri + "ConsignorInfo/AddConsignorNotes";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(note))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.RemoveNotes = function (internalAuctionId, internalItemId, roleId) {
                return __awaiter(this, void 0, void 0, function () {
                    var note, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                note = new PortalModels_1.PortalModels.NotesRequest(internalAuctionId, internalItemId, null, roleId);
                                url = this.basePortalUri + "notes/RemoveNotes";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(note))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.ModifyWatchList = function (internalAuctionId, watchItemIds, unWatchItemIds, Roleid) {
                return __awaiter(this, void 0, void 0, function () {
                    var w, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                w = new PortalModels_1.PortalModels.WatchRequest(internalAuctionId, watchItemIds, unWatchItemIds, Roleid);
                                url = this.basePortalUri + "watch/ModifyWatchList";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(w))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.KickVCBUser = function (UserId, SessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var w, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                w = new PortalModels_1.PortalModels.VCBRequest(UserId, SessionKey);
                                url = this.basePortalUri + "VCB/KickVCBUser";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(w))];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.AddUsertoVCB = function (UserId, SessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var w, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                w = new PortalModels_1.PortalModels.VCBRequest(UserId, SessionKey);
                                url = this.basePortalUri + "VCB/AddUsertoVCB";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(w))];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.CheckDuplicateLoginUsersVCB = function (UserId, SessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var w, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                w = new PortalModels_1.PortalModels.VCBRequest(UserId, SessionKey);
                                url = this.basePortalUri + "VCB/CheckDuplicateLoginUsersVCB";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(w))];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.RemoveUserVCB = function (UserId, SessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    var w, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                w = new PortalModels_1.PortalModels.VCBRequest(UserId, SessionKey);
                                url = this.basePortalUri + "VCB/RemoveUserVCB";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST", JSON.stringify(w))];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.SetAuctionSessionToken = function (auctionId, sessionToken) {
                this._auctionSessionToken.set(auctionId, sessionToken);
            };
            PortalRepository.prototype.SetItemSessionToken = function (auctionId, sessionToken) {
                this._itemSessionToken.set(auctionId, sessionToken);
            };
            PortalRepository.prototype.GetInternalInformationUsingExternal = function (tenant, externalAuctionId, isFromBidApi) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/InternalInformationLookup/?tenant=" + tenant + "&externalId=" + externalAuctionId + "&BidAPI=" + true;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetInternalInfoUsingExternalWithoutURL = function (tenant, externalAuctionId) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/GetInternalInfo/?tenant=" + tenant + "&externalId=" + externalAuctionId;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetUriForLive = function (auctionId, isFromBidApi) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/AuctionUri/?internalAuctionId=" + auctionId + "&BidAPI=" + true;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetJoinApiResponse = function (internalAuctionId, userId, sessionkey) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.portalJoinApiApiUrl + "AuctionJoining/Join?userId=" + userId + "&internalAuctionId=" + internalAuctionId + "&sessionkey=" + sessionkey;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.InvalidateSideBarCache = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/InvalidateSideBarCache";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST")];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetAuctions = function (searchString, includeTestAuctions) {
                if (includeTestAuctions === void 0) { includeTestAuctions = false; }
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/Auctions/?searchString=" + searchString + "&includeTestAuctions=" + true;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetAuction = function (internalAuctionId, language, FromVCB) {
                if (language === void 0) { language = ""; }
                if (FromVCB === void 0) { FromVCB = false; }
                return __awaiter(this, void 0, void 0, function () {
                    var session, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                session = this._auctionSessionToken.get(internalAuctionId);
                                url = this.basePortalUri + "auction/Auction" + "?internalAuctionId=" + internalAuctionId + "&language=" + language + "&FromVCB=" + FromVCB + (session != null ? "&sessionToken=" + session : "");
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.LoginUser = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/Login";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "POST")];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetAuctionItems = function (internalAuctionId, language) {
                return __awaiter(this, void 0, void 0, function () {
                    var session, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                session = this._itemSessionToken.get(internalAuctionId);
                                url = this.basePortalUri + "auction/AuctionItems/?internalAuctionId=" + internalAuctionId + "&language=" + language + "&BidAPI=" + true + (session != null ? "&sessionToken=" + session : "");
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetRunList = function (internalAuctionId, language, bidAPI) {
                return __awaiter(this, void 0, void 0, function () {
                    var session, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                session = this._itemSessionToken.get(internalAuctionId);
                                url = this.basePortalUri + "auction/RunList/?internalAuctionId=" + internalAuctionId + "&language=" + language + "&BidAPI=" + bidAPI + (session != null ? "&sessionToken=" + session : "");
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetAuctionItem = function (internalAuctionId, internalItemId, language, bidAPI) {
                return __awaiter(this, void 0, void 0, function () {
                    var session, url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                session = this._itemSessionToken.get(internalAuctionId);
                                url = this.basePortalUri + "auction/AuctionItem/?internalAuctionId=" + internalAuctionId + "&internalItemId=" + internalItemId + "&language=" + language + "&BidAPI=" + bidAPI + (session != null ? "&sessionToken=" + session : "");
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetUserWatchedItems = function (roleId) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "watch/GetUserWatchedItems/?roleId=" + roleId;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetwatchedItemDetails = function (auctionId, auctionItemId) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "watch/GetItemDetails/?auctionId=" + auctionId + "&auctionItemId=" + auctionItemId;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetContent = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/GetContent";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetCountries = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = this.basePortalUri + "auction/GetCountries";
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET")];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.GetSaleDecisionByItemId = function (uri, auctionItemId) {
                return __awaiter(this, void 0, void 0, function () {
                    var url;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                url = uri + "GetSaleDecisionByItemId" + "/" + auctionItemId;
                                return [4 /*yield*/, this.AjaxWithCredentials(url, "GET", null, false)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            PortalRepository.prototype.AjaxWithCredentials = function (url, method, data, withBearer) {
                var _this = this;
                if (withBearer === void 0) { withBearer = true; }
                return new Promise(function (resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    if (url.indexOf("?") == -1)
                        url += "?c=" + new Date().getTime().toString();
                    xhr.open(method, url);
                    xhr.setRequestHeader("Content-type", "application/json");
                    if (withBearer)
                        xhr.setRequestHeader("Authorization", "Bearer " + _this.bearerToken);
                    xhr.withCredentials = false;
                    xhr.send(data);
                    xhr.onload = function () {
                        if (xhr.status == 200) {
                            resolve(xhr.response == "" ? xhr.responseText : JSON.parse(xhr.response));
                        }
                        else {
                            reject(xhr); //
                        }
                    };
                    xhr.onerror = function () {
                        reject(xhr);
                    };
                });
            };
            return PortalRepository;
        }());
        Portal.PortalRepository = PortalRepository;
    })(Portal = exports.Portal || (exports.Portal = {}));
});
},{"./PortalModels":37}],37:[function(require,module,exports){
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PortalModels = void 0;
    var PortalModels;
    (function (PortalModels) {
        var AuctionStatus;
        (function (AuctionStatus) {
            AuctionStatus[AuctionStatus["None"] = 0] = "None";
            AuctionStatus[AuctionStatus["Started"] = 1] = "Started";
            AuctionStatus[AuctionStatus["Paused"] = 2] = "Paused";
            AuctionStatus[AuctionStatus["Ended"] = 4] = "Ended";
        })(AuctionStatus = PortalModels.AuctionStatus || (PortalModels.AuctionStatus = {}));
        var FeedbackRequest = /** @class */ (function () {
            function FeedbackRequest(UserId, Tenant, Comment, UserAgent, SourceIP, ConsignerID) {
                this.UserId = UserId;
                this.Tenant = Tenant;
                this.Comment = Comment;
                this.UserAgent = UserAgent;
                this.SourceIP = SourceIP;
                this.ConsignerID = ConsignerID;
            }
            return FeedbackRequest;
        }());
        PortalModels.FeedbackRequest = FeedbackRequest;
        var AutoBidRequest = /** @class */ (function () {
            function AutoBidRequest(InternalAuctionId, InternalItemId, BidderId, Amount, SessionKey) {
                this.InternalAuctionId = InternalAuctionId;
                this.InternalItemId = InternalItemId;
                this.BidderId = BidderId;
                this.Amount = Amount;
                this.SessionKey = SessionKey;
            }
            return AutoBidRequest;
        }());
        PortalModels.AutoBidRequest = AutoBidRequest;
        var WatchRequest = /** @class */ (function () {
            function WatchRequest(InternalAuctionId, WatchItemIds, UnWatchItemIds, Roleid) {
                this.InternalAuctionId = InternalAuctionId;
                this.WatchItemIds = WatchItemIds;
                this.UnWatchItemIds = UnWatchItemIds;
                this.Roleid = Roleid;
            }
            return WatchRequest;
        }());
        PortalModels.WatchRequest = WatchRequest;
        var VCBRequest = /** @class */ (function () {
            function VCBRequest(UserId, SessionKey) {
                this.UserId = UserId;
                this.SessionKey = SessionKey;
            }
            return VCBRequest;
        }());
        PortalModels.VCBRequest = VCBRequest;
        var NotesRequest = /** @class */ (function () {
            function NotesRequest(InternalAuctionId, InternalAuctionItemId,
            // public BidderId : string,
            Message, RoleId) {
                this.InternalAuctionId = InternalAuctionId;
                this.InternalAuctionItemId = InternalAuctionItemId;
                this.Message = Message;
                this.RoleId = RoleId;
            }
            return NotesRequest;
        }());
        PortalModels.NotesRequest = NotesRequest;
        var LightValue;
        (function (LightValue) {
            LightValue[LightValue["Red"] = 1] = "Red";
            LightValue[LightValue["Yellow"] = 2] = "Yellow";
            LightValue[LightValue["Green"] = 3] = "Green";
            LightValue[LightValue["White"] = 4] = "White";
            LightValue[LightValue["Blue"] = 5] = "Blue";
        })(LightValue = PortalModels.LightValue || (PortalModels.LightValue = {}));
    })(PortalModels = exports.PortalModels || (exports.PortalModels = {}));
});
},{}],38:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Shared = void 0;
    var Shared;
    (function (Shared) {
        var CommandException = /** @class */ (function () {
            function CommandException(message) {
                this.Message = message;
            }
            return CommandException;
        }());
        Shared.CommandException = CommandException;
        var Observable = /** @class */ (function () {
            function Observable() {
                this.Observers = [];
            }
            Observable.prototype.Unobserve = function (observer) {
                var index = this.Observers.findIndex(function (p) { return p == observer; });
                this.Observers.splice(index, 1);
            };
            Observable.prototype.Observe = function (observer) {
                this.Observers.push(observer);
            };
            Observable.prototype.CallObservers = function (propName) {
                var _this = this;
                this.Observers.forEach(function (p) {
                    try {
                        p.Change(propName, _this);
                    }
                    catch (_a) { }
                });
            };
            return Observable;
        }());
        Shared.Observable = Observable;
        var AuctionModifierBase = /** @class */ (function (_super) {
            __extends(AuctionModifierBase, _super);
            function AuctionModifierBase(InternalAuctionId) {
                var _this = _super.call(this) || this;
                _this.InternalAuctionId = InternalAuctionId;
                _this._eventProcessors = [];
                _this.CurrentItemId = null;
                _this.PredictedNextItem = null;
                _this.CurrentItem = null;
                _this.AuctionItems = [];
                return _this;
            }
            AuctionModifierBase.prototype.SetItemsReloadCallback = function (cb) {
                this.itemsReloadCallback = cb;
            };
            AuctionModifierBase.prototype.AddEventProcessor = function (eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            };
            AuctionModifierBase.prototype.RemoveEventProcessor = function (eventProcessor) {
                var i = this._eventProcessors.findIndex(function (v, i, ob) { return v === eventProcessor; });
                this._eventProcessors.splice(i, 1);
            };
            AuctionModifierBase.prototype.Process = function (event, channelName) {
                if (channelName === void 0) { channelName = Shared.Constants.AuctionChannelName; }
                return __awaiter(this, void 0, void 0, function () {
                    var _i, _a, e, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _i = 0, _a = this._eventProcessors;
                                _c.label = 1;
                            case 1:
                                if (!(_i < _a.length)) return [3 /*break*/, 6];
                                e = _a[_i];
                                _c.label = 2;
                            case 2:
                                _c.trys.push([2, 4, , 5]);
                                return [4 /*yield*/, e.Process(event, channelName)];
                            case 3:
                                _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                _b = _c.sent();
                                return [3 /*break*/, 5];
                            case 5:
                                _i++;
                                return [3 /*break*/, 1];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            };
            AuctionModifierBase.prototype.SetIfBid = function (itemId, bidderId, amount) {
                var item = this.AuctionItems.find(function (p) { return p.ItemId == itemId; });
                item.State = ItemState.IfBid;
                //item.WinningBidAmount = amount;
                item.WinningBidderId = bidderId;
                this.CallObservers("State");
            };
            AuctionModifierBase.prototype.SetSold = function (itemId, bidderId, amount) {
                var item = this.AuctionItems.find(function (p) { return p.ItemId == itemId; });
                item.State = ItemState.Sold;
                //  item.WinningBidAmount = amount;
                item.WinningBidderId = bidderId;
                this.CallObservers("State");
            };
            AuctionModifierBase.prototype.SetReRun = function (itemId, bidderId, amount) {
                var item = this.AuctionItems.find(function (p) { return p.ItemId == itemId; });
                item.State = ItemState.ReRun;
                // item.WinningBidAmount =amount;
                item.WinningBidderId = bidderId;
                this.CallObservers("State");
            };
            AuctionModifierBase.prototype.SetNoBid = function (itemId) {
                var item = this.AuctionItems.find(function (p) { return p.ItemId == itemId; });
                item.State = ItemState.NoBid;
                this.CallObservers("State");
            };
            AuctionModifierBase.prototype.SetPulled = function (itemId) {
                var item = this.AuctionItems.find(function (p) { return p.ItemId == itemId; });
                item.State = ItemState.Pulled;
                this.CallObservers("State");
            };
            AuctionModifierBase.prototype.SetPassed = function (itemId) {
                var item = this.AuctionItems.find(function (p) { return p.ItemId == itemId; });
                item.State = ItemState.Pass;
                this.CallObservers("State");
            };
            AuctionModifierBase.prototype.SetAskingAmount = function (value, jumps) {
                this.CurrentItem.AskingAmount = value;
                this.CurrentItem.JumpAmounts = jumps;
                this.CallObservers("AskingAmount");
            };
            AuctionModifierBase.prototype.SetItems = function (items) {
                this.AuctionItems = items;
                this.CallObservers("AuctionItems");
            };
            AuctionModifierBase.prototype.SetCurrentItem = function (internalAuctionItemId) {
                this.CurrentItemId = internalAuctionItemId;
                var index = this.AuctionItems.findIndex(function (p) { return p.ItemId == internalAuctionItemId; });
                this.CurrentItem = this.AuctionItems[index];
                if (index + 1 < this.AuctionItems.length) {
                    this.PredictedNextItem = this.AuctionItems[index + 1];
                }
                this.CallObservers("CurrentItem");
            };
            AuctionModifierBase.prototype.SetHighInformation = function (itemId, bidderId, display, amount) {
                var item = this.AuctionItems.find(function (p) { return p.ItemId == itemId; });
                item.CurrentBidAmount = amount;
                item.CurrentHighBidderId = bidderId;
                item.CurrentHighBidderDisplay = display;
                this.CallObservers("HighInformation");
            };
            AuctionModifierBase.prototype.ReloadItems = function (items, removedIds) {
                var current = this.AuctionItems;
                var newlist = current.filter(function (p) { return !removedIds.some(function (z) { return z == p.ItemId; }); });
                var _loop_1 = function (x) {
                    if (!newlist.some(function (p) { return p.ItemId == items[x].ItemId; })) {
                        newlist.push(items[x]);
                    }
                };
                for (var x = 0; x < items.length; x++) {
                    _loop_1(x);
                }
                this.AuctionItems = newlist;
                this.CallObservers("Items");
                this.itemsReloadCallback(items, removedIds);
            };
            AuctionModifierBase.prototype.ChangeSequences = function (changes) {
                var current = this.AuctionItems;
                var NOSEQ = -1;
                for (var x = 0; x < changes.length; x++) {
                    for (var y = 0; y < current.length; y++) {
                        if (changes[x].InternalItemId == current[y].ItemId) {
                            current[y].SequenceNumber = changes[x].NewSequence;
                        }
                    }
                }
                var newlist = current.filter(function (p) { return p.SequenceNumber != NOSEQ; });
                newlist.sort(function (a, b) {
                    if (a.SequenceNumber < b.SequenceNumber)
                        return -1;
                    if (a.SequenceNumber > b.SequenceNumber)
                        return 1;
                    return 0;
                });
                this.AuctionItems = newlist;
                this.CallObservers("Sequences");
            };
            return AuctionModifierBase;
        }(Observable));
        Shared.AuctionModifierBase = AuctionModifierBase;
        var BidderTypes;
        (function (BidderTypes) {
            BidderTypes[BidderTypes["OnSite"] = 0] = "OnSite";
            BidderTypes[BidderTypes["OnLine"] = 1] = "OnLine";
            BidderTypes[BidderTypes["AutoBid"] = 2] = "AutoBid";
        })(BidderTypes = Shared.BidderTypes || (Shared.BidderTypes = {}));
        var BidRejectionReasons;
        (function (BidRejectionReasons) {
            BidRejectionReasons[BidRejectionReasons["None"] = 0] = "None";
            BidRejectionReasons[BidRejectionReasons["AutoBidsDisabled"] = 1] = "AutoBidsDisabled";
            BidRejectionReasons[BidRejectionReasons["NoCurrentItem"] = 2] = "NoCurrentItem";
            BidRejectionReasons[BidRejectionReasons["BidAmount"] = 3] = "BidAmount";
            BidRejectionReasons[BidRejectionReasons["WrongItem"] = 4] = "WrongItem";
            BidRejectionReasons[BidRejectionReasons["BiddingNotActive"] = 5] = "BiddingNotActive";
            BidRejectionReasons[BidRejectionReasons["IsPaused"] = 6] = "IsPaused";
            BidRejectionReasons[BidRejectionReasons["IsEnded"] = 7] = "IsEnded";
            BidRejectionReasons[BidRejectionReasons["CurrentHighBidder"] = 8] = "CurrentHighBidder";
            BidRejectionReasons[BidRejectionReasons["CountDownComplete"] = 9] = "CountDownComplete";
            BidRejectionReasons[BidRejectionReasons["SpendingLimit"] = 10] = "SpendingLimit";
            BidRejectionReasons[BidRejectionReasons["IsNotStarted"] = 11] = "IsNotStarted";
            BidRejectionReasons[BidRejectionReasons["AccessDeniedToBidderId"] = 12] = "AccessDeniedToBidderId";
            BidRejectionReasons[BidRejectionReasons["WrongAuction"] = 13] = "WrongAuction";
            BidRejectionReasons[BidRejectionReasons["CustomJumpBidsDisabled"] = 14] = "CustomJumpBidsDisabled";
        })(BidRejectionReasons = Shared.BidRejectionReasons || (Shared.BidRejectionReasons = {}));
        var Command = /** @class */ (function () {
            function Command(InternalAuctionId, CommandName) {
                this.InternalAuctionId = InternalAuctionId;
                this.CommandName = CommandName;
            }
            return Command;
        }());
        Shared.Command = Command;
        var ItemCommand = /** @class */ (function (_super) {
            __extends(ItemCommand, _super);
            function ItemCommand(commandName, InternalAuctionId, ItemId) {
                var _this = _super.call(this, InternalAuctionId, commandName) || this;
                _this.ItemId = ItemId;
                return _this;
            }
            return ItemCommand;
        }(Command));
        Shared.ItemCommand = ItemCommand;
        var EventHandle = /** @class */ (function () {
            function EventHandle(state) {
                this.state = state;
            }
            return EventHandle;
        }());
        Shared.EventHandle = EventHandle;
        var ItemState;
        (function (ItemState) {
            ItemState[ItemState["Unprocessed"] = 0] = "Unprocessed";
            ItemState[ItemState["Biddable"] = 1] = "Biddable";
            ItemState[ItemState["Sold"] = 4] = "Sold";
            ItemState[ItemState["IfBid"] = 8] = "IfBid";
            ItemState[ItemState["Pass"] = 16] = "Pass";
            ItemState[ItemState["Pulled"] = 32] = "Pulled";
            ItemState[ItemState["ReRun"] = 64] = "ReRun";
            ItemState[ItemState["NoBid"] = 128] = "NoBid";
            ItemState[ItemState["Complete"] = 60] = "Complete";
            ItemState[ItemState["Transacted"] = 12] = "Transacted";
        })(ItemState = Shared.ItemState || (Shared.ItemState = {}));
        var MessageType;
        (function (MessageType) {
            MessageType[MessageType["Key"] = 1] = "Key";
            MessageType[MessageType["FreeForm"] = 2] = "FreeForm";
        })(MessageType = Shared.MessageType || (Shared.MessageType = {}));
        var LeaveReason;
        (function (LeaveReason) {
            LeaveReason[LeaveReason["DuplicateLogin"] = 1] = "DuplicateLogin";
            LeaveReason[LeaveReason["GuestLogin"] = 2] = "GuestLogin";
        })(LeaveReason = Shared.LeaveReason || (Shared.LeaveReason = {}));
        var AuctionStatus;
        (function (AuctionStatus) {
            AuctionStatus[AuctionStatus["None"] = 0] = "None";
            AuctionStatus[AuctionStatus["Started"] = 1] = "Started";
            AuctionStatus[AuctionStatus["Paused"] = 2] = "Paused";
            AuctionStatus[AuctionStatus["Ended"] = 4] = "Ended";
        })(AuctionStatus = Shared.AuctionStatus || (Shared.AuctionStatus = {}));
        var OfferAnswer;
        (function (OfferAnswer) {
            OfferAnswer[OfferAnswer["None"] = 0] = "None";
            OfferAnswer[OfferAnswer["Accepted"] = 1] = "Accepted";
            OfferAnswer[OfferAnswer["Rejected"] = 2] = "Rejected";
        })(OfferAnswer = Shared.OfferAnswer || (Shared.OfferAnswer = {}));
        var DomainEvent = /** @class */ (function () {
            function DomainEvent(_eventName, auctionId, itemId, order) {
                this._eventName = _eventName;
                this.InternalAuctionId = auctionId;
                this.InternalAuctionItemId = itemId;
                this.Order = order;
            }
            return DomainEvent;
        }());
        Shared.DomainEvent = DomainEvent;
        var InternalReplayedEventsBatch = /** @class */ (function (_super) {
            __extends(InternalReplayedEventsBatch, _super);
            function InternalReplayedEventsBatch(auctionId, itemId, order, Events) {
                var _this = _super.call(this, "InternalReplayedEventsBatch", auctionId, itemId, order) || this;
                _this.Events = Events;
                return _this;
            }
            return InternalReplayedEventsBatch;
        }(DomainEvent));
        Shared.InternalReplayedEventsBatch = InternalReplayedEventsBatch;
        var CommunicationChannelBase = /** @class */ (function () {
            function CommunicationChannelBase(EventQueue) {
                this.EventQueue = EventQueue;
                this._lastEvent = 0;
            }
            CommunicationChannelBase.prototype.IncomingEvent = function (ev) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (ev && this._lastEvent <= ev.Order)
                                    this._lastEvent = ev.Order;
                                return [4 /*yield*/, this.EventQueue.Enqueue(ev)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            CommunicationChannelBase.prototype.Dispose = function () {
                this.EventQueue.Dispose();
                this.EventQueue = null;
            };
            return CommunicationChannelBase;
        }());
        Shared.CommunicationChannelBase = CommunicationChannelBase;
        var MockLifetimeNotifications = /** @class */ (function () {
            function MockLifetimeNotifications() {
            }
            MockLifetimeNotifications.prototype.LoggingInUser = function () {
            };
            MockLifetimeNotifications.prototype.UserLoggedIn = function () {
            };
            MockLifetimeNotifications.prototype.CreatingSystemChannel = function () {
            };
            MockLifetimeNotifications.prototype.SystemChannelCreated = function () {
            };
            MockLifetimeNotifications.prototype.SystemChannelStopping = function () {
            };
            MockLifetimeNotifications.prototype.SystemChannelStopped = function () {
            };
            MockLifetimeNotifications.prototype.AttendeeJoiningTimeIssue = function (aucId) {
            };
            MockLifetimeNotifications.prototype.JoiningCommand = function (aucId) {
            };
            MockLifetimeNotifications.prototype.FiredJoiningCommand = function (aucId) {
            };
            MockLifetimeNotifications.prototype.SystemChannelJoining = function (aucId) {
            };
            MockLifetimeNotifications.prototype.SystemChannelJoined = function (aucId) {
            };
            MockLifetimeNotifications.prototype.ReplayStarted = function (aucId) {
            };
            MockLifetimeNotifications.prototype.ReplayEnded = function (aucId) {
            };
            MockLifetimeNotifications.prototype.ProcessingEventsQueue = function (aucId) {
            };
            MockLifetimeNotifications.prototype.ProcessedEventsQueue = function (aucId) {
            };
            MockLifetimeNotifications.prototype.JoinError = function (aucId, error) {
            };
            MockLifetimeNotifications.prototype.StartingChannels = function (aucId, uri) {
            };
            MockLifetimeNotifications.prototype.StartedChannels = function (aucId, uri) {
            };
            MockLifetimeNotifications.prototype.FailingOver = function (aucId, uri) {
            };
            MockLifetimeNotifications.prototype.FailedOver = function (aucId, uri) {
            };
            return MockLifetimeNotifications;
        }());
        Shared.MockLifetimeNotifications = MockLifetimeNotifications;
        var AutoBidResult = /** @class */ (function () {
            function AutoBidResult(InternalAuctionItemId, Amount, BidderId, CurrentHighBidAmount, WinnerBidderId) {
                this.InternalAuctionItemId = InternalAuctionItemId;
                this.Amount = Amount;
                this.BidderId = BidderId;
                this.CurrentHighBidAmount = CurrentHighBidAmount;
                this.WinnerBidderId = WinnerBidderId;
            }
            return AutoBidResult;
        }());
        Shared.AutoBidResult = AutoBidResult;
        var NoteResult = /** @class */ (function () {
            function NoteResult(InternalAuctionItemId, Message) {
                this.InternalAuctionItemId = InternalAuctionItemId;
                this.Message = Message;
            }
            return NoteResult;
        }());
        Shared.NoteResult = NoteResult;
        var Audio = /** @class */ (function () {
            function Audio() {
            }
            return Audio;
        }());
        Shared.Audio = Audio;
        var Link = /** @class */ (function () {
            function Link() {
            }
            return Link;
        }());
        Shared.Link = Link;
        var Constants = /** @class */ (function () {
            function Constants() {
            }
            Constants.InternalCommandEventChannelName = "InternalCommandEvent";
            Constants.AuctionChannelName = "Auction";
            Constants.SystemChannelName = "System";
            return Constants;
        }());
        Shared.Constants = Constants;
        var Commands;
        (function (Commands) {
            var ReplayCommand = /** @class */ (function (_super) {
                __extends(ReplayCommand, _super);
                function ReplayCommand(id) {
                    return _super.call(this, id, "ReplayCommand") || this;
                }
                return ReplayCommand;
            }(Shared.Command));
            Commands.ReplayCommand = ReplayCommand;
            var ReplayFromCommand = /** @class */ (function (_super) {
                __extends(ReplayFromCommand, _super);
                function ReplayFromCommand(id, LastKnownEvent) {
                    if (LastKnownEvent === void 0) { LastKnownEvent = -1; }
                    var _this = _super.call(this, id, "ReplayFromCommand") || this;
                    _this.LastKnownEvent = LastKnownEvent;
                    return _this;
                }
                return ReplayFromCommand;
            }(Shared.Command));
            Commands.ReplayFromCommand = ReplayFromCommand;
            var JoinCommand = /** @class */ (function (_super) {
                __extends(JoinCommand, _super);
                function JoinCommand(id, isVehicleCentricFlag, isFromBidApi, selectedRoles) {
                    var _this =
                    //constructor(id: string, public selectedRoles: Shared.ILiveUserRole[], public checkforDuplicateLogIn:boolean) {
                    _super.call(this, id, "JoinCommand") || this;
                    _this.isVehicleCentricFlag = isVehicleCentricFlag;
                    _this.isFromBidApi = isFromBidApi;
                    _this.selectedRoles = selectedRoles;
                    return _this;
                }
                return JoinCommand;
            }(Shared.Command));
            Commands.JoinCommand = JoinCommand;
            var JoinAfterAPICommand = /** @class */ (function (_super) {
                __extends(JoinAfterAPICommand, _super);
                function JoinAfterAPICommand(id, selectedRoles) {
                    var _this = _super.call(this, id, "JoinAfterAPICommand") || this;
                    _this.selectedRoles = selectedRoles;
                    return _this;
                }
                return JoinAfterAPICommand;
            }(Shared.Command));
            Commands.JoinAfterAPICommand = JoinAfterAPICommand;
            var LeaveCommand = /** @class */ (function (_super) {
                __extends(LeaveCommand, _super);
                function LeaveCommand(id) {
                    return _super.call(this, id, "LeaveCommand") || this;
                }
                return LeaveCommand;
            }(Shared.Command));
            Commands.LeaveCommand = LeaveCommand;
            var KickDuplicateUserCommand = /** @class */ (function (_super) {
                __extends(KickDuplicateUserCommand, _super);
                function KickDuplicateUserCommand(id) {
                    return _super.call(this, id, "KickDuplicateUserCommand") || this;
                }
                return KickDuplicateUserCommand;
            }(Shared.Command));
            Commands.KickDuplicateUserCommand = KickDuplicateUserCommand;
            var KickGuestUserCommand = /** @class */ (function (_super) {
                __extends(KickGuestUserCommand, _super);
                function KickGuestUserCommand(id) {
                    return _super.call(this, id, "KickGuestUserCommand") || this;
                }
                return KickGuestUserCommand;
            }(Shared.Command));
            Commands.KickGuestUserCommand = KickGuestUserCommand;
        })(Commands = Shared.Commands || (Shared.Commands = {}));
    })(Shared = exports.Shared || (exports.Shared = {}));
});
},{}],39:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared", "./SignalREventCreator", "@microsoft/signalr"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SignalRChannels = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var SignalREventCreator_1 = require("./SignalREventCreator");
    var SignalR = require("@microsoft/signalr");
    /*
    import 'expose-loader?jQuery!jquery';
    import '../node_modules/signalr/jquery.signalR.js';
    */
    var SignalRChannels;
    (function (SignalRChannels) {
        var SignalRConnection = /** @class */ (function () {
            function SignalRConnection(uri, logger, auctionId, notifications, bearerToken, sessionKey, hubName) {
                var _this = this;
                if (hubName === void 0) { hubName = ""; }
                this.uri = uri;
                this.logger = logger;
                this.auctionId = auctionId;
                this.notifications = notifications;
                this.bearerToken = bearerToken;
                this.sessionKey = sessionKey;
                this.hubName = hubName;
                this._forceStopped = false;
                if (!this.uri.endsWith("/")) {
                    this.uri += "/";
                }
                var queryParams = {
                    SessionKey: sessionKey,
                    AuctionId: auctionId
                };
                var queryString = this.buildQueryString(queryParams);
                var url = (hubName ? this.uri + hubName + "?" + queryString : this.uri);
                this._connection = new SignalR.HubConnectionBuilder()
                    .withUrl(url, { accessTokenFactory: function () { return bearerToken; } })
                    .configureLogging(SignalR.LogLevel.Debug)
                    .withAutomaticReconnect({
                    nextRetryDelayInMilliseconds: function (retryContext) {
                        if (retryContext.elapsedMilliseconds < 600000) {
                            return Math.random() * 10000;
                        }
                        else {
                            return null;
                        }
                    }
                })
                    .build();
                this._connection.onclose(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        this.notifications.Disconnected(this);
                        if (this._forceStopped)
                            return [2 /*return*/];
                        window.setTimeout(function () {
                            _this.Reconnect();
                        }, 5000);
                        return [2 /*return*/];
                    });
                }); });
                this._connection.onreconnected(function () {
                    if (_this._cleanReconnectCB)
                        _this._cleanReconnectCB();
                    _this.notifications.Reconnected(_this);
                });
                this._connection.onreconnecting(function () {
                    _this.notifications.Disconnected(_this);
                });
            }
            SignalRConnection.prototype.buildQueryString = function (params) {
                return Object.keys(params)
                    .map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); })
                    .join('&');
            };
            SignalRConnection.prototype.AddCleanReconnectCallback = function (cb) {
                this._cleanReconnectCB = cb;
            };
            SignalRConnection.prototype.AddUncleanReconnectCallback = function (cb) {
                this._reconnectCB = cb;
            };
            SignalRConnection.prototype.GetHubConnection = function () {
                return this._connection;
            };
            SignalRConnection.prototype.startConnection = function () {
                var _this = this;
                var p = new Promise(function (suc, rej) {
                    _this._connection.start().then(function () {
                        var tries = 0;
                        var timer = function () {
                            window.setTimeout(function () {
                                tries++;
                                if (_this._connection.state == SignalR.HubConnectionState.Connected) {
                                    _this.notifications.Connected(_this);
                                    suc();
                                }
                                else {
                                    if (tries > 20) {
                                        rej("too many tries waiting for connection");
                                    }
                                    else {
                                        timer();
                                    }
                                }
                            }, 10);
                        };
                        timer();
                    });
                });
                return p;
            };
            SignalRConnection.prototype.Stop = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        try {
                            this._forceStopped = true;
                            if (this._connection)
                                this._connection.stop();
                        }
                        catch (e) {
                            this.notifications.Error(this, e);
                        }
                        this._cleanReconnectCB = null;
                        this._reconnectCB = null;
                        $(window).unbind("unload");
                        this._connection = null;
                        return [2 /*return*/];
                    });
                });
            };
            SignalRConnection.prototype.Reconnect = function () {
                var _this = this;
                if (this._forceStopped)
                    return;
                if (this._connection == null || this._connection.state == SignalR.HubConnectionState.Connected || this._connection.state == SignalR.HubConnectionState.Connecting)
                    return;
                this.notifications.Reconnecting(this);
                this._connection.start().then(function () {
                    if (_this._connection.state != SignalR.HubConnectionState.Connected) {
                        window.setTimeout(function () {
                            _this.Reconnect();
                        }, 5000);
                    }
                    else {
                        _this.notifications.Reconnected(_this);
                        if (_this._reconnectCB != null)
                            _this._reconnectCB();
                    }
                });
            };
            return SignalRConnection;
        }());
        SignalRChannels.SignalRConnection = SignalRConnection;
        var SignalrBase = /** @class */ (function (_super) {
            __extends(SignalrBase, _super);
            function SignalrBase(hubName, uri, bearerToken, internalAuctionId, eventQueue, logger, notifications, sessionKey, Name) {
                if (Name === void 0) { Name = hubName; }
                var _this = _super.call(this, eventQueue) || this;
                _this.hubName = hubName;
                _this.uri = uri;
                _this.bearerToken = bearerToken;
                _this.internalAuctionId = internalAuctionId;
                _this.logger = logger;
                _this.notifications = notifications;
                _this.sessionKey = sessionKey;
                _this.Name = Name;
                _this.IgnoreEventsUntilReplay = false;
                _this.eventFilter = ['AskingAmountSetEvent'];
                _this._hubSignalRConnection = new SignalRConnection(_this.uri, _this.logger, _this.internalAuctionId, _this.notifications, _this.bearerToken, _this.sessionKey, _this.hubName);
                _this.StartChannel();
                return _this;
            }
            SignalrBase.prototype.FailedOver = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/];
                    });
                });
            };
            SignalrBase.prototype.InvokeBidLevel = function (auctionId, itemId, amount, bidderId, bidMask, command, traceString) {
                var parm = [];
                for (var _i = 7; _i < arguments.length; _i++) {
                    parm[_i - 7] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var sp, id;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                sp = this.logger.RequestCorrelationId();
                                id = new BidItemIdentifier(sp, auctionId, itemId, amount, bidderId, bidMask);
                                return [4 /*yield*/, this.Invoke(command, id, traceString, parm)];
                            case 1:
                                _a.sent();
                                this.logger.RequestCorrelationId();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SignalrBase.prototype.InvokeItemLevel = function (auctionId, itemId, command, traceString) {
                var parm = [];
                for (var _i = 4; _i < arguments.length; _i++) {
                    parm[_i - 4] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var sp, id;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                sp = this.logger.RequestCorrelationId();
                                id = new AuctionItemIdentifier(sp, auctionId, itemId);
                                return [4 /*yield*/, this.Invoke(command, id, traceString, parm)];
                            case 1:
                                _a.sent();
                                this.logger.RequestCorrelationId();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            ///Send a command to the server
            SignalrBase.prototype.InvokeAuctionLevel = function (auctionId, command, traceString) {
                var parm = [];
                for (var _i = 3; _i < arguments.length; _i++) {
                    parm[_i - 3] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var sp, id;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                sp = this.logger.RequestCorrelationId();
                                id = new AuctionIdentifier(sp, auctionId);
                                return [4 /*yield*/, this.Invoke(command, id, traceString, parm)];
                            case 1:
                                _a.sent();
                                this.logger.RequestCorrelationId();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SignalrBase.prototype.InvokeSystemLevel = function (command, traceString, data) {
                return __awaiter(this, void 0, void 0, function () {
                    var sp, handle, success;
                    return __generator(this, function (_a) {
                        this.logger.LogVerbose("GLOBAL", "", "InvokingSystemLevel ", traceString);
                        sp = this.logger.RequestCorrelationId();
                        handle = this.logger.BeginDependency(command, traceString);
                        success = false;
                        try {
                            this._hub.invoke(command, sp, data);
                            success = true;
                        }
                        catch (e) {
                            this.logger.LogError("", "", e);
                            throw e;
                        }
                        finally {
                            this.logger.EndDependency("", "", handle, success);
                        }
                        this.logger.RequestCorrelationId();
                        return [2 /*return*/];
                    });
                });
            };
            SignalrBase.prototype.Invoke = function (command, id, traceString, parm) {
                return __awaiter(this, void 0, void 0, function () {
                    var ignoreLogString, handle, success, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                ignoreLogString = "PingAuctionLevel";
                                if (this._hub.state == SignalR.HubConnectionState.Disconnecting || this._hub.state == SignalR.HubConnectionState.Disconnected)
                                    return [2 /*return*/];
                                if (traceString.toLocaleLowerCase() !== ignoreLogString.toLocaleLowerCase()) {
                                    this.logger.LogVerbose(id.AuctionId, "", "Invoking ", traceString);
                                }
                                handle = this.logger.BeginDependency(command);
                                success = false;
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 15, 16, 17]);
                                if (!(parm != null)) return [3 /*break*/, 12];
                                if (!(parm.length == 0)) return [3 /*break*/, 3];
                                return [4 /*yield*/, this._hub.invoke(command, id)];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 11];
                            case 3:
                                if (!(parm.length == 1)) return [3 /*break*/, 5];
                                return [4 /*yield*/, this._hub.invoke(command, id, parm[0])];
                            case 4:
                                _a.sent();
                                return [3 /*break*/, 11];
                            case 5:
                                if (!(parm.length == 2)) return [3 /*break*/, 7];
                                return [4 /*yield*/, this._hub.invoke(command, id, parm[0], parm[1])];
                            case 6:
                                _a.sent();
                                return [3 /*break*/, 11];
                            case 7:
                                if (!(parm.length == 3)) return [3 /*break*/, 9];
                                return [4 /*yield*/, this._hub.invoke(command, id, parm[0], parm[1], parm[2])];
                            case 8:
                                _a.sent();
                                return [3 /*break*/, 11];
                            case 9:
                                if (!(parm.length == 4)) return [3 /*break*/, 11];
                                return [4 /*yield*/, this._hub.invoke(command, id, parm[0], parm[1], parm[2], parm[3])];
                            case 10:
                                _a.sent();
                                _a.label = 11;
                            case 11: return [3 /*break*/, 14];
                            case 12: return [4 /*yield*/, this._hub.invoke(command, id)];
                            case 13:
                                _a.sent();
                                _a.label = 14;
                            case 14:
                                success = true;
                                return [3 /*break*/, 17];
                            case 15:
                                e_1 = _a.sent();
                                this.logger.LogError(id.AuctionId, "", e_1);
                                throw e_1;
                            case 16:
                                this.logger.EndDependency(id.AuctionId, "", handle, success);
                                return [7 /*endfinally*/];
                            case 17: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalrBase.prototype.SetupHub = function (hub) {
            };
            ///Start the channel
            SignalrBase.prototype.StartChannel = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        this._hub = this._hubSignalRConnection.GetHubConnection();
                        this.SetupHub(this._hub);
                        this._hub.on("HandleEvent", function (name, ev) { return __awaiter(_this, void 0, void 0, function () {
                            var l, e, e_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        l = this.logger.BeginEvent("signalr received event , " + name + ", for  " + ev.InternalAuctionId);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, 4, 5]);
                                        e = SignalREventCreator_1.SignalRChannels.EventCreator.MapEvent(name, ev);
                                        if (e == null) {
                                            return [2 /*return*/];
                                        }
                                        if (e instanceof ForAllShared_1.Events.ReplayEventStarted || e instanceof ForAllShared_1.Events.LeaveAuctionConfirmationEvent) {
                                            this.IgnoreEventsUntilReplay = false;
                                        }
                                        if (this.IgnoreEventsUntilReplay) {
                                            this.logger.LogWarning(ev.InternalAuctionId, ev.InternalAuctionItemId, "ignoring events");
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, _super.prototype.IncomingEvent.call(this, e)];
                                    case 2:
                                        _a.sent();
                                        return [3 /*break*/, 5];
                                    case 3:
                                        e_2 = _a.sent();
                                        this.logger.LogError(ev.InternalAuctionId, ev.InternalAuctionItemId, e_2);
                                        return [3 /*break*/, 5];
                                    case 4:
                                        if (this.eventFilter.indexOf(name) > -1) {
                                            this.logger.EndEvent(ev.InternalAuctionId, ev.InternalAuctionItemId, l);
                                        }
                                        return [7 /*endfinally*/];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); });
                        this.logger.LogVerbose("GLOBAL", "", this.hubName, " Started");
                        return [2 /*return*/];
                    });
                });
            };
            SignalrBase.prototype.StartSignalRConnection = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, this._hubSignalRConnection.startConnection()];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _a.sent();
                                console.error("SignalR Connection failed: ", error_1.message);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalrBase.prototype.Stop = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this._hubSignalRConnection.Stop()];
                            case 1:
                                _a.sent();
                                _super.prototype.Dispose.call(this);
                                return [2 /*return*/];
                        }
                    });
                });
            };
            return SignalrBase;
        }(ForAllShared_1.Shared.CommunicationChannelBase));
        SignalRChannels.SignalrBase = SignalrBase;
        var SystemCommunicationChannel = /** @class */ (function (_super) {
            __extends(SystemCommunicationChannel, _super);
            function SystemCommunicationChannel(uri, auctionId, eventQueue, logger, notifications, sessionKey, bearerToken) {
                var _this = _super.call(this, "SystemHub", uri, bearerToken, auctionId, eventQueue, logger, notifications, sessionKey) || this;
                _this._subscribes = [];
                _this._roles = [];
                _this._hubSignalRConnection.AddUncleanReconnectCallback(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _i, _a, c;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _i = 0, _a = this._subscribes;
                                _b.label = 1;
                            case 1:
                                if (!(_i < _a.length)) return [3 /*break*/, 5];
                                c = _a[_i];
                                return [4 /*yield*/, this.InvokeSystemLevel("SubscribeToAuction", "SubscribeToAuction", c)];
                            case 2:
                                _b.sent();
                                return [4 /*yield*/, this.InvokeSystemLevel("CreateGroupsForRoles", "CreateGroupsForRoles", this._roles)];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4:
                                _i++;
                                return [3 /*break*/, 1];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); });
                _this._hubSignalRConnection.AddCleanReconnectCallback(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _i, _a, c;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _i = 0, _a = this._subscribes;
                                _b.label = 1;
                            case 1:
                                if (!(_i < _a.length)) return [3 /*break*/, 5];
                                c = _a[_i];
                                return [4 /*yield*/, this.InvokeSystemLevel("SubscribeToAuction", "SubscribeToAuction", c)];
                            case 2:
                                _b.sent();
                                return [4 /*yield*/, this.InvokeSystemLevel("CreateGroupsForRoles", "CreateGroupsForRoles", this._roles)];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4:
                                _i++;
                                return [3 /*break*/, 1];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); });
                return _this;
            }
            SystemCommunicationChannel.prototype.Ping = function (data) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.InvokeSystemLevel("Ping", "Ping", data)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SystemCommunicationChannel.prototype.CreateGroupsForRoles = function (roles) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this._roles = roles;
                                return [4 /*yield*/, this.InvokeSystemLevel("CreateGroupsForRoles", "CreateGroupsForRoles", roles)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SystemCommunicationChannel.prototype.JoinWindowId = function (windowId) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.InvokeSystemLevel("JoinWindowId", "JoinWindowId", windowId)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SystemCommunicationChannel.prototype.FailedOver = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/];
                    });
                });
            };
            SystemCommunicationChannel.prototype.Process = function (com) {
                return __awaiter(this, void 0, void 0, function () {
                    var c, c, c_1, item;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.JoinCommand)) return [3 /*break*/, 2];
                                c = com;
                                return [4 /*yield*/, this.InvokeSystemLevel("SubscribeToAuction", "SubscribeToAuction", c.InternalAuctionId)];
                            case 1:
                                _a.sent();
                                this._subscribes.push(c.InternalAuctionId);
                                return [3 /*break*/, 6];
                            case 2:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.JoinAfterAPICommand)) return [3 /*break*/, 4];
                                c = com;
                                return [4 /*yield*/, this.InvokeSystemLevel("SubscribeToAuction", "SubscribeToAuction", c.InternalAuctionId)];
                            case 3:
                                _a.sent();
                                this._subscribes.push(c.InternalAuctionId);
                                return [3 /*break*/, 6];
                            case 4:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.LeaveCommand)) return [3 /*break*/, 6];
                                c_1 = com;
                                return [4 /*yield*/, this.InvokeSystemLevel("UnsubscribeFromAuction", "UnsubscribeFromAuction", c_1.InternalAuctionId)];
                            case 5:
                                _a.sent();
                                item = this._subscribes.findIndex(function (p) { return p == c_1.InternalAuctionId; });
                                this._subscribes.splice(item, 1);
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            };
            SystemCommunicationChannel.prototype.SetupHub = function (hub) {
                var _this = this;
                this._hub.on("Pong", function (data) { return _this.LastPong = data; });
                this._hub.on("RemoteJoin", function (auctions, windowId) {
                    _this.InvokeSystemLevel("ReceivedJoin", "ReceivedJoin", windowId);
                    auctions.forEach(function (item) { return _this.EventQueue.Enqueue(new ForAllShared_1.Events.AuctionJoinRequested(item.Id, item.T, item.Lang, item.Timezone)); });
                });
            };
            return SystemCommunicationChannel;
        }(SignalrBase));
        SignalRChannels.SystemCommunicationChannel = SystemCommunicationChannel;
        var SignalRCoreHub = /** @class */ (function (_super) {
            __extends(SignalRCoreHub, _super);
            function SignalRCoreHub(uri, auctionId, eventQueue, logger, notifications, sessionKey, bearerToken) {
                var _this = _super.call(this, "CoreHub", uri, bearerToken, auctionId, eventQueue, logger, notifications, sessionKey) || this;
                _this.auctionId = auctionId;
                _this._joinCalled = false;
                _this._hubSignalRConnection.AddUncleanReconnectCallback(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.Reconnected()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); });
                _this._hubSignalRConnection.AddCleanReconnectCallback(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.CleanReconnected()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); });
                _this.ping = new PingRoutine(function () { return _this.PingCommand(); }, function () { return _this.PingTimedOutCommand(); });
                _this.ping.Start();
                return _this;
            }
            SignalRCoreHub.prototype.Reconnected = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this._joinCalled) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "Replay", "ReplayCommand")];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRCoreHub.prototype.CleanReconnected = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this._joinCalled) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "ReplayFrom", "ReplayFromCommand", this._lastEvent)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRCoreHub.prototype.FailedOver = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "Replay", "ReplayCommand")];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRCoreHub.prototype.PingCommand = function () {
                try {
                    this.InvokeAuctionLevel(this.auctionId, "PingAuctionLevel", "PingAuctionLevel");
                }
                catch (_a) {
                }
            };
            SignalRCoreHub.prototype.PingTimedOutCommand = function () {
                this.CleanReconnected();
            };
            SignalRCoreHub.prototype.SetupHub = function (hub) {
                var _this = this;
                this._hub.onreconnecting(function () {
                    _this.IgnoreEventsUntilReplay = true;
                });
                this._hub.onclose(function () {
                    _this.IgnoreEventsUntilReplay = false;
                });
                this._hub.on("Pong", function (correlationId, auctionId) { return _this.ping.Pong(correlationId); });
                _super.prototype.SetupHub.call(this, hub);
            };
            SignalRCoreHub.prototype.Process = function (com) {
                return __awaiter(this, void 0, void 0, function () {
                    var c, c, c, c, c, c, c;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.JoinCommand)) return [3 /*break*/, 2];
                                c = com;
                                // await this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuction", c.CommandName, c.selectedRoles == null ? null : c.selectedRoles.map(p => p.RoleId),c.checkforDuplicateLogIn);
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuction", c.CommandName, c.isVehicleCentricFlag, c.isFromBidApi, c.selectedRoles == null ? null : c.selectedRoles.map(function (p) { return p.RoleId; }))];
                            case 1:
                                // await this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuction", c.CommandName, c.selectedRoles == null ? null : c.selectedRoles.map(p => p.RoleId),c.checkforDuplicateLogIn);
                                _a.sent();
                                this._joinCalled = true;
                                return [3 /*break*/, 14];
                            case 2:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.JoinAfterAPICommand)) return [3 /*break*/, 4];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuctionAfterAPI", c.CommandName, c.selectedRoles == null ? null : c.selectedRoles.map(function (p) { return p.RoleId; }))];
                            case 3:
                                _a.sent();
                                this._joinCalled = true;
                                return [3 /*break*/, 14];
                            case 4:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.ReplayCommand)) return [3 /*break*/, 6];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "Replay", c.CommandName)];
                            case 5:
                                _a.sent();
                                return [3 /*break*/, 14];
                            case 6:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.ReplayFromCommand)) return [3 /*break*/, 8];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "ReplayFrom", "ReplayFromCommand", c.LastKnownEvent)];
                            case 7:
                                _a.sent();
                                return [3 /*break*/, 14];
                            case 8:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.LeaveCommand)) return [3 /*break*/, 10];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "LeaveAuction", c.CommandName)];
                            case 9:
                                _a.sent();
                                return [3 /*break*/, 14];
                            case 10:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.KickDuplicateUserCommand)) return [3 /*break*/, 12];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "KickDuplicateUser", c.CommandName)];
                            case 11:
                                _a.sent();
                                return [3 /*break*/, 14];
                            case 12:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.KickGuestUserCommand)) return [3 /*break*/, 14];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "KickGuestUser", c.CommandName)];
                            case 13:
                                _a.sent();
                                _a.label = 14;
                            case 14: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRCoreHub.prototype.Stop = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.ping.Dispose();
                                return [4 /*yield*/, _super.prototype.Stop.call(this)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            return SignalRCoreHub;
        }(SignalrBase));
        SignalRChannels.SignalRCoreHub = SignalRCoreHub;
        var PingRoutine = /** @class */ (function () {
            function PingRoutine(SendPingCallback, pongTimedOutCallback) {
                this.SendPingCallback = SendPingCallback;
                this.pongTimedOutCallback = pongTimedOutCallback;
                this.PONGTIMEOUT = 25000;
            }
            PingRoutine.prototype.Pong = function (correlationId) {
                window.clearTimeout(this.pongHandle);
                this.Start();
            };
            PingRoutine.prototype.Start = function () {
                var _this = this;
                if (this.handle != 0)
                    window.clearTimeout(this.handle);
                this.handle = window.setTimeout(function () { return _this.Ping(); }, 15000);
            };
            PingRoutine.prototype.Ping = function () {
                var _this = this;
                this.pongHandle = window.setTimeout(function () { return _this.PongTimedOut(); }, this.PONGTIMEOUT);
                this.SendPingCallback();
            };
            PingRoutine.prototype.PongTimedOut = function () {
                this.pongTimedOutCallback();
                this.Start();
            };
            PingRoutine.prototype.Dispose = function () {
                window.clearTimeout(this.pongHandle);
                window.clearTimeout(this.handle);
                this.pongTimedOutCallback = null;
                this.SendPingCallback = null;
            };
            return PingRoutine;
        }());
        var AuctionIdentifier = /** @class */ (function () {
            function AuctionIdentifier(CorrelationId, AuctionId) {
                this.CorrelationId = CorrelationId;
                this.AuctionId = AuctionId;
            }
            return AuctionIdentifier;
        }());
        SignalRChannels.AuctionIdentifier = AuctionIdentifier;
        var AuctionItemIdentifier = /** @class */ (function (_super) {
            __extends(AuctionItemIdentifier, _super);
            function AuctionItemIdentifier(CorrelationId, AuctionId, ItemId) {
                var _this = _super.call(this, CorrelationId, AuctionId) || this;
                _this.ItemId = ItemId;
                return _this;
            }
            return AuctionItemIdentifier;
        }(AuctionIdentifier));
        SignalRChannels.AuctionItemIdentifier = AuctionItemIdentifier;
        var BidItemIdentifier = /** @class */ (function (_super) {
            __extends(BidItemIdentifier, _super);
            function BidItemIdentifier(CorrelationId, AuctionId, itemId, Amount, SelectedBidderId, BidMask) {
                var _this = _super.call(this, CorrelationId, AuctionId, itemId) || this;
                _this.Amount = Amount;
                _this.SelectedBidderId = SelectedBidderId;
                _this.BidMask = BidMask;
                return _this;
            }
            return BidItemIdentifier;
        }(AuctionItemIdentifier));
        SignalRChannels.BidItemIdentifier = BidItemIdentifier;
    })(SignalRChannels = exports.SignalRChannels || (exports.SignalRChannels = {}));
});
},{"./ForAllShared":34,"./SignalREventCreator":41,"@microsoft/signalr":26}],40:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared", "./BidderSellerCommands", "./SignalRBase"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SignalRChannels = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var BidderSellerCommands_1 = require("./BidderSellerCommands");
    var SignalRBase_1 = require("./SignalRBase");
    var SignalRChannels;
    (function (SignalRChannels) {
        var SignalRBidderCommunicationChannel = /** @class */ (function (_super) {
            __extends(SignalRBidderCommunicationChannel, _super);
            function SignalRBidderCommunicationChannel(uri, auctionId, eventQueue, logger, notifications, sessionKey, bearerToken) {
                var _this = _super.call(this, "BidderManagementHub", uri, bearerToken, auctionId, eventQueue, logger, notifications, sessionKey) || this;
                _this.auctionId = auctionId;
                _this._joinCalled = false;
                _this._hubSignalRConnection.AddUncleanReconnectCallback(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.Reconnected()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); });
                _this._hubSignalRConnection.AddCleanReconnectCallback(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.CleanReconnected()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); });
                _this.ping = new PingRoutine(function () { return _this.PingCommand(); }, function () { return _this.PingTimedOutCommand(); });
                _this.ping.Start();
                return _this;
            }
            SignalRBidderCommunicationChannel.prototype.Reconnected = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this._joinCalled) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "Replay", "ReplayCommand")];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRBidderCommunicationChannel.prototype.CleanReconnected = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this._joinCalled) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "ReplayFrom", "ReplayFromCommand", this._lastEvent)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRBidderCommunicationChannel.prototype.FailedOver = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "Replay", "ReplayCommand")];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRBidderCommunicationChannel.prototype.PingCommand = function () {
                try {
                    this.InvokeAuctionLevel(this.auctionId, "PingAuctionLevel", "PingAuctionLevel");
                }
                catch (_a) {
                }
            };
            SignalRBidderCommunicationChannel.prototype.PingTimedOutCommand = function () {
                this.CleanReconnected();
            };
            SignalRBidderCommunicationChannel.prototype.SetupHub = function (hub) {
                var _this = this;
                this._hub.onreconnecting(function () {
                    _this.IgnoreEventsUntilReplay = true;
                });
                this._hub.onclose(function () {
                    _this.IgnoreEventsUntilReplay = false;
                });
                this._hub.on("Pong", function (correlationId, auctionId) { return _this.ping.Pong(correlationId); });
                _super.prototype.SetupHub.call(this, hub);
            };
            SignalRBidderCommunicationChannel.prototype.RemoteJoin = function (windowId) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, _super.prototype.InvokeSystemLevel.call(this, "RemoteJoin", "RemoteJoin", windowId)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRBidderCommunicationChannel.prototype.Process = function (com) {
                return __awaiter(this, void 0, void 0, function () {
                    var c, c, c, c, c, c, c, c, c, c, c, c, c, c, c, c, c, c, c, c;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.JoinCommand)) return [3 /*break*/, 2];
                                c = com;
                                // await this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuction", c.CommandName, c.selectedRoles == null ? null : c.selectedRoles.map(p => p.RoleId),c.checkforDuplicateLogIn);
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuction", c.CommandName, c.isVehicleCentricFlag, c.isFromBidApi, c.selectedRoles == null ? null : c.selectedRoles.map(function (p) { return p.RoleId; }))];
                            case 1:
                                // await this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuction", c.CommandName, c.selectedRoles == null ? null : c.selectedRoles.map(p => p.RoleId),c.checkforDuplicateLogIn);
                                _a.sent();
                                this._joinCalled = true;
                                return [3 /*break*/, 40];
                            case 2:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.JoinAfterAPICommand)) return [3 /*break*/, 4];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "JoinAuctionAfterAPI", c.CommandName, c.selectedRoles == null ? null : c.selectedRoles.map(function (p) { return p.RoleId; }))];
                            case 3:
                                _a.sent();
                                this._joinCalled = true;
                                return [3 /*break*/, 40];
                            case 4:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.ReplayCommand)) return [3 /*break*/, 6];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "Replay", c.CommandName)];
                            case 5:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 6:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.ReplayFromCommand)) return [3 /*break*/, 8];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(this.auctionId, "ReplayFrom", "ReplayFromCommand", c.LastKnownEvent)];
                            case 7:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 8:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.LeaveCommand)) return [3 /*break*/, 10];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "LeaveAuction", c.CommandName)];
                            case 9:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 10:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.KickDuplicateUserCommand)) return [3 /*break*/, 12];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "KickDuplicateUser", c.CommandName)];
                            case 11:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 12:
                                if (!(com instanceof ForAllShared_1.Shared.Commands.KickGuestUserCommand)) return [3 /*break*/, 14];
                                c = com;
                                return [4 /*yield*/, this.InvokeAuctionLevel(c.InternalAuctionId, "KickGuestUser", c.CommandName)];
                            case 13:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 14:
                                if (!(com instanceof BidderSellerCommands_1.Commands.PlaceBidCommand)) return [3 /*break*/, 16];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeBidLevel.call(this, c.InternalAuctionId, c.ItemId, c.Amount, c.SelectedBidderId, c.BidMask, "PlaceBid", "PlaceBid")];
                            case 15:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 16:
                                if (!(com instanceof BidderSellerCommands_1.Commands.PlaceAutoBidCommand)) return [3 /*break*/, 18];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeBidLevel.call(this, c.InternalAuctionId, c.ItemId, c.Amount, c.SelectedBidderId, c.BidMask, "PlaceAutoBid", "PlaceAutoBid")];
                            case 17:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 18:
                                if (!(com instanceof BidderSellerCommands_1.Commands.ModifyAutoBidCommand)) return [3 /*break*/, 20];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeBidLevel.call(this, c.InternalAuctionId, c.ItemId, c.Amount, c.SelectedBidderId, c.BidMask, "ModifyAutoBid", "ModifyAutoBid")];
                            case 19:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 20:
                                if (!(com instanceof BidderSellerCommands_1.Commands.RemoveAutoBidCommand)) return [3 /*break*/, 22];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeBidLevel.call(this, c.InternalAuctionId, c.ItemId, 0, c.SelectedBidderId, c.BidMask, "RemoveAutoBid", "RemoveAutoBid")];
                            case 21:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 22:
                                if (!(com instanceof BidderSellerCommands_1.Commands.MessageToClerkCommand)) return [3 /*break*/, 24];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "SendMessageToClerk", "SendMessageToClerk", c.MessageType, c.Message)];
                            case 23:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 24:
                                if (!(com instanceof BidderSellerCommands_1.Commands.AnswerNegotiationOfferCommand)) return [3 /*break*/, 26];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "AnswerNegotiationOffer", "AnswerNegotiationOffer", c.OfferAnswer)];
                            case 25:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 26:
                                if (!(com instanceof BidderSellerCommands_1.Commands.SellerReppingOnlineCommand)) return [3 /*break*/, 28];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "SellerReppingOnline", "SellerReppingOnline", c.SelectedBidderId, c.IsRepped)];
                            case 27:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 28:
                                if (!(com instanceof BidderSellerCommands_1.Commands.RepInfoToClerkCommand)) return [3 /*break*/, 30];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "RepInfoToClerk", "RepInfoToClerk")];
                            case 29:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 30:
                                if (!(com instanceof BidderSellerCommands_1.Commands.CreateNegotiationOfferCommand)) return [3 /*break*/, 32];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "CreateNegotiationOffer", "CreateNegotiationOffer", c.SelectedBidderId, c.OfferAmount)];
                            case 31:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 32:
                                if (!(com instanceof BidderSellerCommands_1.Commands.NegotiationSellItCommand)) return [3 /*break*/, 34];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "SellIt", "SellIt", c.SelectedBidderId)];
                            case 33:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 34:
                                if (!(com instanceof BidderSellerCommands_1.Commands.NegotiationCallCommand)) return [3 /*break*/, 36];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "Call", "Call", c.SelectedBidderId)];
                            case 35:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 36:
                                if (!(com instanceof BidderSellerCommands_1.Commands.NegotiationRerunCommand)) return [3 /*break*/, 38];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "Rerun", "Rerun", c.SelectedBidderId)];
                            case 37:
                                _a.sent();
                                return [3 /*break*/, 40];
                            case 38:
                                if (!(com instanceof BidderSellerCommands_1.Commands.ReserveTogglePreBlockCommand)) return [3 /*break*/, 40];
                                c = com;
                                return [4 /*yield*/, _super.prototype.InvokeItemLevel.call(this, c.InternalAuctionId, c.ItemId, "ReserveTogglePreBlock", "ReserveTogglePreBlock", c.SelectedBidderId, c.IsRemoved)];
                            case 39:
                                _a.sent();
                                _a.label = 40;
                            case 40: return [2 /*return*/];
                        }
                    });
                });
            };
            SignalRBidderCommunicationChannel.prototype.Stop = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.ping.Dispose();
                                return [4 /*yield*/, _super.prototype.Stop.call(this)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            return SignalRBidderCommunicationChannel;
        }(SignalRBase_1.SignalRChannels.SignalrBase));
        SignalRChannels.SignalRBidderCommunicationChannel = SignalRBidderCommunicationChannel;
        var PingRoutine = /** @class */ (function () {
            function PingRoutine(SendPingCallback, pongTimedOutCallback) {
                this.SendPingCallback = SendPingCallback;
                this.pongTimedOutCallback = pongTimedOutCallback;
                this.PONGTIMEOUT = 25000;
            }
            PingRoutine.prototype.Pong = function (correlationId) {
                window.clearTimeout(this.pongHandle);
                this.Start();
            };
            PingRoutine.prototype.Start = function () {
                var _this = this;
                if (this.handle != 0)
                    window.clearTimeout(this.handle);
                this.handle = window.setTimeout(function () { return _this.Ping(); }, 15000);
            };
            PingRoutine.prototype.Ping = function () {
                var _this = this;
                this.pongHandle = window.setTimeout(function () { return _this.PongTimedOut(); }, this.PONGTIMEOUT);
                this.SendPingCallback();
            };
            PingRoutine.prototype.PongTimedOut = function () {
                this.pongTimedOutCallback();
                this.Start();
            };
            PingRoutine.prototype.Dispose = function () {
                window.clearTimeout(this.pongHandle);
                window.clearTimeout(this.handle);
                this.pongTimedOutCallback = null;
                this.SendPingCallback = null;
            };
            return PingRoutine;
        }());
        var SignalRSellerCommunicationChannel = /** @class */ (function (_super) {
            __extends(SignalRSellerCommunicationChannel, _super);
            function SignalRSellerCommunicationChannel(uri, auctionId, eventQueue, logger, notifications, sessionKey, bearerToken) {
                return _super.call(this, "SellerManagementHub", uri, bearerToken, auctionId, eventQueue, logger, notifications, sessionKey) || this;
            }
            SignalRSellerCommunicationChannel.prototype.Process = function (com) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/];
                    });
                });
            };
            return SignalRSellerCommunicationChannel;
        }(SignalRBase_1.SignalRChannels.SignalrBase));
        SignalRChannels.SignalRSellerCommunicationChannel = SignalRSellerCommunicationChannel;
        var SignalRChannelFactory = /** @class */ (function () {
            function SignalRChannelFactory(bearerToken) {
                this.bearerToken = bearerToken;
            }
            SignalRChannelFactory.prototype.SetSessionKey = function (sessionKey) {
                this.sessionKey = sessionKey;
            };
            SignalRChannelFactory.prototype.FailOver = function (currentChannels, uri, auctionId, eventQueue, logger, notifications) {
                return __awaiter(this, void 0, void 0, function () {
                    var channels;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.InternalCreateChannels(uri, auctionId, eventQueue, logger, notifications)];
                            case 1:
                                channels = _a.sent();
                                channels.forEach(function (p) { return p.FailedOver(); });
                                return [2 /*return*/, channels];
                        }
                    });
                });
            };
            SignalRChannelFactory.prototype.CreateSystemChannel = function (uri, eventQueue, logger, notifications, windowId) {
                return __awaiter(this, void 0, void 0, function () {
                    var res;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                res = new SignalRBase_1.SignalRChannels.SystemCommunicationChannel(uri, "system", eventQueue, logger, notifications, this.sessionKey, this.bearerToken);
                                return [4 /*yield*/, res.StartSignalRConnection()];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, res.JoinWindowId(windowId)];
                            case 2:
                                _a.sent();
                                return [2 /*return*/, res];
                        }
                    });
                });
            };
            SignalRChannelFactory.prototype.CreateChannels = function (uri, auctionId, eventQueue, logger, notifications) {
                return __awaiter(this, void 0, void 0, function () {
                    var chans;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.InternalCreateChannels(uri, auctionId, eventQueue, logger, notifications)];
                            case 1:
                                chans = _a.sent();
                                return [2 /*return*/, chans];
                        }
                    });
                });
            };
            SignalRChannelFactory.prototype.InternalCreateChannels = function (uri, auctionId, eventQueue, logger, notifications) {
                return __awaiter(this, void 0, void 0, function () {
                    var sch, res, _i, res_1, p;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                sch = new SignalRBidderCommunicationChannel(uri, auctionId, eventQueue(true), logger, notifications, this.sessionKey, this.bearerToken);
                                res = [
                                    sch
                                ];
                                _i = 0, res_1 = res;
                                _a.label = 1;
                            case 1:
                                if (!(_i < res_1.length)) return [3 /*break*/, 4];
                                p = res_1[_i];
                                return [4 /*yield*/, p.StartSignalRConnection()];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                _i++;
                                return [3 /*break*/, 1];
                            case 4: return [2 /*return*/, res];
                        }
                    });
                });
            };
            return SignalRChannelFactory;
        }());
        SignalRChannels.SignalRChannelFactory = SignalRChannelFactory;
    })(SignalRChannels = exports.SignalRChannels || (exports.SignalRChannels = {}));
});
},{"./BidderSellerCommands":29,"./ForAllShared":34,"./SignalRBase":39}],41:[function(require,module,exports){
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports", "./ForAllShared"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SignalRChannels = void 0;
    var ForAllShared_1 = require("./ForAllShared");
    var SignalRChannels;
    (function (SignalRChannels) {
        var EventCreator = /** @class */ (function () {
            function EventCreator() {
            }
            EventCreator.MapEvent = function (name, ev) {
                var auctionId = ev.InternalAuctionId;
                var auctionItemId = ev.InternalAuctionItemId;
                if (name == "BidAcceptedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.BidAcceptedEvent(auctionId, auctionItemId, ev.Order, e.Amount, e.BidderId, e.Display, e.BidderType);
                }
                else if (name == "AuctionAttendeeCountEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.AuctionAttendeeCountEvent(auctionId, "", ev.Order, e.Bidders, e.Sellers, e.Clerks);
                }
                else if (name == "AudioStreamOnEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.AudioStreamOnEvent(auctionId, auctionItemId, ev.Order, e.Tenant, e.LocationId, e.Lane);
                }
                else if (name == "AudioStreamOffEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.AudioStreamOffEvent(auctionId, auctionItemId, ev.Order, e.Tenant, e.LocationId, e.Lane);
                }
                else if (name == "AudioStartedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.AudioStartedEvent(auctionId, auctionItemId, ev.Order, e.Tenant, e.LocationId, e.Lane);
                }
                else if (name == "AudioStoppedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.AudioStoppedEvent(auctionId, auctionItemId, ev.Order, e.Tenant, e.LocationId, e.Lane);
                }
                else if (name == "UserBannedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.UserBannedEvent(e.Order, e.UserId);
                }
                else if (name == "UserKickedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.UserKickedEvent(e.Order, e.UserId, e.Code);
                }
                else if (name == "UserSuspendEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.UserSuspendEvent(e.Order, e.UserId, e.Tenants);
                }
                else if (name == "LeaveVCBEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.LeaveVCBEvent(e.Order, e.User, e.SessionKey);
                }
                else if (name == "GlobalMessageModifiedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.GlobalMessageModifiedEvent(e.Order, e.UserId, e.Message, e.Tenant);
                }
                else if (name == "GlobalMessageRemovedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.GlobalMessageRemovedEvent(e.Order, e.UserId, e.Message, e.Tenant);
                }
                else if (name == "HideWinningBidSaleEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.HideWinningBidSaleEvent(e.Order, e.HideWinningBidAmount, e.Tenant);
                }
                else if (name == "FailOverEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.FailOverEvent(auctionId, "", e.Order, e.Uri);
                }
                else if (name == "AuctionStatisticsEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.AuctionStatisticsEvent(e.InternalAuctionId, e.InternalAuctionItemId, e.Order, e.ItemsSold, e.ItemsPulled, e.ItemsIfBid, e.ItemsNoBid, e.ItemsReRun, e.ItemsPassed, e.AverageTimeOnBlock);
                }
                else if (name == "WatchListSequenceUpdateEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.WatchListSequenceUpdateEvent(e.InternalAuctionId, e.InternalAuctionItemId, e.Order, e.WatchList);
                }
                else if (name == "WatchListUserItemsAwayEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.WatchListUserItemsAwayEvent(e.InternalAuctionId, e.InternalAuctionItemId, e.Order, e.WatchList);
                }
                else if (name == "ReplayedEventsBatch") {
                    var e = ev;
                    var newEvents_1 = [];
                    e.Events.forEach(function (p) {
                        var ne = EventCreator.MapEvent(p.Name, p.Event);
                        if (ne != null)
                            newEvents_1.push(ne);
                    });
                    return new ForAllShared_1.Shared.InternalReplayedEventsBatch(auctionId, auctionItemId, ev.Order, newEvents_1);
                }
                else if (name == "BiddingCompletedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.BiddingCompletedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "BiddingReopenedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.BiddingReopenedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NotesRemovedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.NotesRemovedEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NotesAddedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.NotesAddedEvent(auctionId, auctionItemId, ev.Order, e.Message);
                }
                else if (name == "ConsignorNotesAddedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.ConsignorNotesAddedEvent(auctionId, auctionItemId, ev.Order, e.Message);
                }
                else if (name == "ReservePriceRemovedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.ReservePriceRemovedEvent(auctionId, auctionItemId, ev.Order, e.IsDisplay);
                }
                else if (name == "OfferAllowedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.OfferAllowedEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NoNegotiationNeededEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.NoNegotiationNeededEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "SellerReppingOnlineEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.SellerReppingOnlineEvent(auctionId, auctionItemId, ev.Order, e.IsRepped);
                }
                else if (name == "ReserveTogglePreBlockEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.ReserveTogglePreBlockEvent(auctionId, auctionItemId, ev.Order, e.IsRemoved);
                }
                else if (name == "ReppingOnlineForCurrentItemEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.ReppingOnlineForCurrentItemEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "WatchListItemAddedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.WatchListItemAddedEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "WatchListItemRemovedEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.WatchListItemRemovedEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ClerkConfigurationEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.ClerkConfigurationEvent(auctionId, auctionItemId, ev.Order, e.Configuration);
                }
                else if (name == "ReservePriceResetEvent") {
                    var e = ev;
                    return new ForAllShared_1.Events.ReservePriceResetEvent(auctionId, auctionItemId, ev.Order, e.IsDisplay);
                }
                else if (name == "AutoBidRemovedEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.AutoBidRemovedEvent(auctionId, auctionItemId, ev.Order, aje.BidderId);
                }
                else if (name == "AutoBidPlacedEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.AutoBidPlacedEvent(auctionId, auctionItemId, ev.Order, aje.Amount, aje.BidderId, aje.CurrentHighBidAmount);
                }
                else if (name == "AutoBidModifiedEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.AutoBidModifiedEvent(auctionId, auctionItemId, ev.Order, aje.Amount, aje.BidderId, aje.CurrentHighBidAmount);
                }
                else if (name == "HighAutoBidEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.HighAutoBidEvent(auctionId, auctionItemId, ev.Order, aje.WinningBidderId, aje.CurrentHighBidAmount);
                }
                else if (name == "GuaranteedSaleEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.GuaranteedSaleEvent(auctionId, auctionItemId, ev.Order, aje.ReserveOffFlag);
                }
                else if (name == "SecurityChangedEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.SecurityChangedEvent(auctionId, auctionItemId, ev.Order, aje.Items);
                }
                else if (name == "AuctionJoinedEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.AuctionJoinedEvent(auctionId, auctionItemId, ev.Order, aje.AuctionSession, aje.ItemSession, aje.Items, aje.UserRole);
                }
                else if (name == "AskingAmountNeededEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.AskingAmountNeededEvent(auctionId, auctionItemId, ev.Order, aje.Amount);
                }
                else if (name == "ReplayEndedEvent") {
                    return new ForAllShared_1.Events.ReplayEventEnded(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ReplayStartedEvent") {
                    return new ForAllShared_1.Events.ReplayEventStarted(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "AutoBidValidationEvent") {
                    var aje = ev;
                    return new ForAllShared_1.Events.AutoBidValidationEvent(auctionId, auctionItemId, ev.Order, aje.Amount);
                }
                else if (name == "AuctionCanEndEvent") {
                    return new ForAllShared_1.Events.AuctionCanEndEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "AuctionEndedEvent") {
                    return new ForAllShared_1.Events.AuctionEndedEvent(auctionId, auctionItemId, ev.Order, ForAllShared_1.Shared.AuctionStatus.Ended);
                }
                else if (name == "AuctionPausedEvent") {
                    return new ForAllShared_1.Events.AuctionPausedEvent(auctionId, auctionItemId, ev.Order, ForAllShared_1.Shared.AuctionStatus.Paused);
                }
                else if (name == "AuctionStartedEvent") {
                    return new ForAllShared_1.Events.AuctionStartedEvent(auctionId, auctionItemId, ev.Order, ForAllShared_1.Shared.AuctionStatus.Started);
                }
                else if (name == "AuctionNotStartedEvent") {
                    return new ForAllShared_1.Events.AuctionNotStartedEvent(auctionId, auctionItemId, ev.Order, ForAllShared_1.Shared.AuctionStatus.None);
                }
                else if (name == "AuctionResumedEvent") {
                    return new ForAllShared_1.Events.AuctionResumedEvent(auctionId, auctionItemId, ev.Order, ForAllShared_1.Shared.AuctionStatus.Started);
                }
                else if (name == "StartAuctionRejectedEvent") {
                    return new ForAllShared_1.Events.StartAuctionRejectedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NavigatedToEvent") {
                    var nte = ev;
                    return new ForAllShared_1.Events.NavigatedToEvent(auctionId, auctionItemId, ev.Order, nte.IsNotInSequence, nte.IsRerun);
                }
                else if (name == "NavigatedFromEvent") {
                    var nte = ev;
                    return new ForAllShared_1.Events.NavigatedFromEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ConfirmNavigationEvent") {
                    return new ForAllShared_1.Events.ConfirmNavigationEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ConfirmNavigationFromEvent") {
                    return new ForAllShared_1.Events.ConfirmNavigationFromEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "CounterStartedEvent") {
                    return new ForAllShared_1.Events.CounterStartedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "CounterStoppedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.CounterStoppedEvent(auctionId, auctionItemId, ev.Order, cte.FinishedCountdown);
                }
                else if (name == "NegotiationProposedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationProposedEvent(auctionId, auctionItemId, ev.Order, cte.IsBidderOnline);
                }
                else if (name == "NegotiationProposalCancelledEvent") {
                    return new ForAllShared_1.Events.NegotiationProposalCancelledEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ReopenBiddingDisabledEvent") {
                    return new ForAllShared_1.Events.ReopenBiddingDisabledEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ReopenBiddingEnabledEvent") {
                    return new ForAllShared_1.Events.ReopenBiddingEnabledEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ReservePriceMetEvent") {
                    return new ForAllShared_1.Events.ReservePriceMetEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "CloseToReserveEvent") {
                    return new ForAllShared_1.Events.CloseToReserveEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ReopenBiddingCounterStartedEvent") {
                    return new ForAllShared_1.Events.ReopenBiddingCounterStartedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ReopenBiddingCounterStoppedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ReopenBiddingCounterStoppedEvent(auctionId, auctionItemId, ev.Order, cte.FinishedCountdown);
                }
                else if (name == "NegotiationSellerCounterStartedEvent") {
                    return new ForAllShared_1.Events.NegotiationSellerCounterStartedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NegotiationSellerCounterStoppedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationSellerCounterStoppedEvent(auctionId, auctionItemId, ev.Order, cte.FinishedCountdown);
                }
                else if (name == "NegotiationBidderCounterStartedEvent") {
                    return new ForAllShared_1.Events.NegotiationBidderCounterStartedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NegotiationBidderCounterStoppedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationBidderCounterStoppedEvent(auctionId, auctionItemId, ev.Order, cte.FinishedCountdown);
                }
                else if (name == "AuctionStartingEarlyConfirmationEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.AuctionStartingEarlyConfirmationEvent(auctionId, auctionItemId, ev.Order, new Date(cte.ValidWhen), cte.StartWarningLimit);
                }
                else if (name == "CounterTickEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.CounterTickEvent(auctionId, auctionItemId, ev.Order, cte.Counter);
                }
                else if (name == "ReopenBiddingCounterTickEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ReopenBiddingCounterTickEvent(auctionId, auctionItemId, ev.Order, cte.Counter);
                }
                else if (name == "NegotiationSellerCounterTickEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationSellerCounterTickEvent(auctionId, auctionItemId, ev.Order, cte.Counter);
                }
                else if (name == "NegotiationBidderCounterTickEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationBidderCounterTickEvent(auctionId, auctionItemId, ev.Order, cte.Counter);
                }
                else if (name == "AnswerNegotiationOfferTimeOutEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.AnswerNegotiationOfferTimeOutEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "CreateNegotiationOfferTimeOutEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.CreateNegotiationOfferTimeOutEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NegotiationOfferAcceptedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationOfferAcceptedEvent(auctionId, auctionItemId, ev.Order, cte.OfferAmount);
                }
                else if (name == "NegotiationOfferRejectedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationOfferRejectedEvent(auctionId, auctionItemId, ev.Order, cte.OfferAmount);
                }
                else if (name == "NegotiationSellerOfferCreatedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationSellerOfferCreatedEvent(auctionId, auctionItemId, ev.Order, cte.OfferAmount, cte.OnlineBidderId, cte.IsSellerOnline);
                }
                else if (name == "NegotiationSellerResponseCallEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationSellerResponseCallEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NegotiationSellerResponseRerunEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationSellerResponseRerunEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "NegotiationSellerResponseSellEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.NegotiationSellerResponseSellEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "AskingAmountSetEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.AskingAmountSetEvent(auctionId, auctionItemId, ev.Order, cte.Amount, cte.JumpAmounts, cte.SetBySystem, cte.CadenceApplied, cte.BidHistory);
                }
                else if (name == "IncrementSetEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.IncrementSetEvent(auctionId, auctionItemId, ev.Order, cte.Increment, cte.SetBySystem, cte.SetByPolicy);
                }
                else if (name == "LeaveAuctionEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.LeaveAuctionEvent(auctionId, auctionItemId, ev.Order, cte.User, cte.Role, cte.LeaveReason);
                }
                else if (name == "LeaveAuctionGuestEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.LeaveAuctionGuestEvent(auctionId, auctionItemId, ev.Order, cte.User, cte.Role);
                }
                else if (name == "TransientSpendingLimitEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.TransientSpendingLimitEvent(auctionId, auctionItemId, ev.Order, cte.UserId, cte.BidderId, cte.AmountSpent, cte.Limit);
                }
                else if (name == "UserSuspendAuctionEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.UserSuspendAuctionEvent(auctionId, auctionItemId, ev.Order, cte.BidderId);
                }
                else if (name == "UserJoinedAuctionChatEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.UserJoinedAuctionChatEvent(auctionId, auctionItemId, ev.Order, cte.User, cte.Role);
                }
                else if (name == "BidRejectedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.BidRejectedEvent(auctionId, auctionItemId, ev.Order, cte.Amount, cte.BidderId, cte.Reason, cte.Display);
                }
                else if (name == "ManualActivationNeededEvent") {
                    return new ForAllShared_1.Events.ManualActivationNeededEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ItemIfBidEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemIfBidEvent(auctionId, auctionItemId, ev.Order, cte.BidderId, cte.Amount, cte.SequenceNumber);
                }
                else if (name == "ItemSoldEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemSoldEvent(auctionId, auctionItemId, ev.Order, cte.BidderId, cte.Amount, cte.SequenceNumber);
                }
                else if (name == "ItemReRunEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemReRunEvent(auctionId, auctionItemId, ev.Order, cte.BidderId, cte.Amount, cte.SequenceNumber);
                }
                else if (name == "ItemPassEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemPassEvent(auctionId, auctionItemId, ev.Order, cte.SequenceNumber);
                }
                else if (name == "ItemNoBidEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemNoBidEvent(auctionId, auctionItemId, ev.Order, cte.SequenceNumber);
                }
                else if (name == "BiddingActivatedEvent") {
                    return new ForAllShared_1.Events.BiddingActivatedEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "LeaveAuctionConfirmationEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.LeaveAuctionConfirmationEvent(auctionId, auctionItemId, ev.Order, cte.LeaveReason, cte.ShowKick);
                }
                else if (name == "DisambiguationNeededEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.DisambiguationNeededEvent(auctionId, auctionItemId, ev.Order, cte.LiveUserRoles);
                }
                else if (name == "SelectedUsersEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.SelectedUsersEvent(auctionId, auctionItemId, ev.Order, cte.LiveUserRoles);
                }
                else if (name == "RetractedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.RetractedEvent(auctionId, auctionItemId, ev.Order, cte.BidderId, cte.Amount, cte.Display, cte.NewBidderId, cte.NewAmount, cte.NewDisplay);
                }
                else if (name == "OverruledEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.OverruledEvent(auctionId, auctionItemId, ev.Order, cte.BidderId, cte.Amount, cte.Display, cte.NewBidderId, cte.NewAmount, cte.NewDisplay);
                }
                else if (name == "MessageToBidderOrSellerEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.MessageToBidderOrSellerEvent(auctionId, auctionItemId, ev.Order, cte.To, cte.Message, cte.MessageType);
                }
                else if (name == "MessageToBiddersAndSellersEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.MessageToBiddersAndSellersEvent(auctionId, auctionItemId, ev.Order, cte.From, cte.Message, cte.MessageType);
                }
                else if (name == "MessageToClerkEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.MessageToClerkEvent(auctionId, auctionItemId, ev.Order, cte.UserId, cte.Message, cte.MessageType);
                }
                else if (name == "RepInfoToClerkEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.RepInfoToClerkEvent(auctionId, auctionItemId, ev.Order, cte.UserId);
                }
                else if (name == "AuctionLevelMessageToAllBiddersAndSellersEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.AuctionLevelMessageToAllBiddersAndSellersEvent(auctionId, auctionItemId, ev.Order, cte.From, cte.Message, cte.MessageType);
                }
                else if (name == "SetLightsEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.SetLightsEvent(auctionId, auctionItemId, ev.Order, cte.Lights);
                }
                else if (name == "GetBidIncrementsEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.GetBidIncrementsEvent(auctionId, auctionItemId, ev.Order, cte.BidIncrements);
                }
                else if (name == "SetAnnouncementsEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.SetAnnouncementsEvent(auctionId, auctionItemId, ev.Order, cte.Announcements);
                }
                else if (name == "SequenceNumberChangedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.SequenceNumberChangedEvent(auctionId, auctionItemId, ev.Order, cte.Changes);
                }
                else if (name == "ItemsModifiedEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemsModifiedEvent(auctionId, auctionItemId, ev.Order, cte.ItemsAdded, cte.RemovedItemIds, cte.ItemSession);
                }
                else if (name == "AutoBidDisabledEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.AutoBidDisabledEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "AutoBidEnabledEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.AutoBidEnabledEvent(auctionId, auctionItemId, ev.Order);
                }
                else if (name == "ItemPulledEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemPulledEvent(auctionId, auctionItemId, ev.Order, cte.SequenceNumber);
                }
                else if (name == "UserLeftAuctionChatEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.UserLeftAuctionChatEvent(auctionId, auctionItemId, ev.Order, cte.User, cte.Role);
                }
                else if (name == "ItemResetEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.ItemResetEvent(name, auctionId, auctionItemId, ev.Order);
                }
                else if (name == "DigitalAuctionTickEvent") {
                    var cte = ev;
                    return new ForAllShared_1.Events.DigitalAuctionTickEvent(auctionId, auctionItemId, ev.Order, cte.TotalTicks, cte.Tick, cte.IsBonusTime);
                }
                else if (name == "WatchAddedCountEvent") {
                    var wace = ev;
                    return new ForAllShared_1.Events.WatchAddedCountEvent(auctionId, auctionItemId, -1, wace.Count, wace.ConsignorId);
                }
                else if (name == "BidCountUpdateEvent") {
                    var bcue = ev;
                    return new ForAllShared_1.Events.BidCountUpdateEvent(auctionId, auctionItemId, -1, bcue.Count);
                }
                else if (name == "BiddersCountUpdateEvent") {
                    var bscue = ev;
                    return new ForAllShared_1.Events.BiddersCountUpdateEvent(auctionId, auctionItemId, -1, bscue.Count);
                }
                else if (name == "BidInfoUpdatedEvent") {
                    var bscue = ev;
                    return new ForAllShared_1.Events.BidInfoUpdatedEvent(auctionId, auctionItemId, -1, bscue.BidCount, bscue.BiddersCount, bscue.ConsignorId);
                }
                else if (name == "PreBiddersCountUpdateEvent") {
                    var pbscue = ev;
                    return new ForAllShared_1.Events.PreBiddersCountUpdateEvent(auctionId, auctionItemId, -1, pbscue.Count, pbscue.ConsignorId);
                }
                else
                    return null;
            };
            return EventCreator;
        }());
        SignalRChannels.EventCreator = EventCreator;
    })(SignalRChannels = exports.SignalRChannels || (exports.SignalRChannels = {}));
});
},{"./ForAllShared":34}],42:[function(require,module,exports){
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define(["require", "exports"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StandAlone = void 0;
    var StandAlone;
    (function (StandAlone) {
        var PortalAPI = /** @class */ (function () {
            function PortalAPI(basePortalUri, key) {
                this.basePortalUri = basePortalUri;
                this.key = key;
            }
            PortalAPI.prototype.GetAudioForLane = function (tenant, locationId, lane) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetAutoBids = function (internalAuctionId, selectedRoles) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetWatchedItemIds = function (internalAuctionId, selectedRoles) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetNotes = function (internalAuctionId, roleId) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetGlobalMessage = function (tenant) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetHideWinningBidSale = function (tenant) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetConsignorInfo = function (internalAuctionId, sessionKey) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetInternalInformationUsingExternal = function (tenant, externalAuctionId, isFromBidApi) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.GetInternalInfoUsingExternalWithoutURL = function (tenant, externalAuctionId) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.ModifyMaxBid = function (internalAuctionId, internalItemId, bidderId, amount, sessionKey) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.RemoveMaxBid = function (internalAuctionId, internalItemId, bidderId, sessionKey) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.PlaceMaxBid = function (internalAuctionId, internalItemId, bidderId, amount, sessionKey) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.AddNotes = function (internalAuctionId, internalItemId, message, roleId) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.AddConsignorNotes = function (internalAuctionId, internalItemId, message, roleId) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.RemoveNotes = function (internalAuctionId, internalItemId, roleId) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.ModifyWatchList = function (internalAuctionId, watchItemIds, unWatchItemIds, Roleid) {
                throw new Error("Method not implemented.");
            };
            PortalAPI.prototype.SetAuctionSessionToken = function (auctionId, sessionToken) {
            };
            PortalAPI.prototype.SetItemSessionToken = function (auctionId, sessionToken) {
            };
            PortalAPI.prototype.LoginUser = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/];
                    });
                });
            };
            PortalAPI.prototype.GetUriForLive = function (auctionId, isFromBidApi) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, "http://localhost:1029"];
                    });
                });
            };
            PortalAPI.prototype.KickVCBUser = function (UserId, SessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        throw new Error('Method not implemented.');
                    });
                });
            };
            PortalAPI.prototype.AddUsertoVCB = function (UserId, SessionKey) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        throw new Error('Method not implemented.');
                    });
                });
            };
            PortalAPI.prototype.GetJoinApiResponse = function (internalAuctionId, userId) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        throw new Error('Method not implemented.');
                    });
                });
            };
            PortalAPI.prototype.CheckDuplicateLoginUsersVCB = function (UserId, SessionKey) {
                throw new Error('Method not implemented.');
            };
            PortalAPI.prototype.RemoveUserVCB = function (UserId, SessionKey) {
                throw new Error('Method not implemented.');
            };
            return PortalAPI;
        }());
        StandAlone.PortalAPI = PortalAPI;
    })(StandAlone = exports.StandAlone || (exports.StandAlone = {}));
});
},{}]},{},[28])(28)
});

//# sourceMappingURL=AuctionNow.min.js.map
